export const en = {
  store: "Store",
  meal: "Meal",
  users: "Users",
  user: "User",
  layout: "Layout",
  analytics: "Analytics",
  settings: "Settings",
  settingsDescription: "Manage store details and operations.",
  notAvailableWhenOffline: "Not available when offline",
  offlineNotification: "Offline working mode",
  storeDetails: "Store details",
  organization: "Organization",
  organizationHeadquarters: "Organization headquarters",
  organizationLegalEntity: "Legal entity",
  organizationBrand: "Brand",
  organizationOperator: "Operator",
  createOrganizationHeadquarters: "Create organization headquarters",
  createLegalEntity: "Create legal entity",
  createBrand: "Create brand",
  createOperator: "Create operator",
  organizationChoose: "Choose an organization",
  headquarters: "Headquarters",
  legalEntity: "Legal entity",
  brand: "Brand",
  operator: "Operator",
  notLinked: "Not linked",
  thisStore: "This store",
  organizationGroupsStores: "An organization groups stores for navigation and reporting.",
  organizationStartAnyLevel: "You can start at any level. A single restaurant registers as a store.",
  organizationOperatorAcrossBrands: "An operator can run stores from more than one brand.",
  organizationNoAccess: "Linking a store does not give that organization access to the store.",
  storeNotLinked: "This store is not linked to an organization.",
  alsoOperatesBrands: "Also operates stores in",
  hasNoLevel: "It has no",
  isPartOf: "is part of",
  operatesIt: "operates it.",
  itsLegalEntityIs: "Its legal entity is",
  headquartersLevel: "A headquarters groups legal entities.",
  legalEntityLevel: "A legal entity is a registered company.",
  brandLevel: "A brand is a restaurant name.",
  operatorLevel: "An operator runs one or more restaurants.",
  storeLevel: "A store is one restaurant location.",
  createOrganization: "Create organization",
  registerOrganization: "Register an organization",
  associateStore: "Associate an existing store",
  editOrganization: "Edit organization",
  reviewRequests: "Review requests",
  acceptRequest: "Accept",
  declineRequest: "Decline",
  organizationName: "Organization name",
  storeIdToAssociate: "Store ID",
  linkThisStore: "Link this store",
  requestAssociation: "Send request",
  organizationSaved: "Organization saved.",
  organizationRequestSent: "Request sent. The store owner accepts it before the link is saved.",
  noOrganizationYet: "This store has no organization yet.",
  selectOrganizationLevel: "Select a level",
  analyticsThisStore: "This store",
  analyticsOrganizationStores: "stores",
  advanced: "Advanced",
  mevClient: "MEV client",
  mevClientDescription:
    "Review cloud MEV activity, monitor incoming orders, and print receipts directly from this workstation.",
  monitoringActive: "Monitoring Active",
  name: "Name",
  quantity: "Quantity",
  address: "Address",
  email: "Email",
  phone: "Phone",
  thirdParty: "Third Party",
  thirdPartyDeliveryOrders: "Third-Party Delivery Orders",
  thirdPartyHint: "Companies, estimates, contracts, and package deals",
  thirdPartyDashboard: "Dashboard",
  thirdPartyDashboardHint: "All third-party activity for the selected period.",
  thirdPartyAllActivity: "All activity",
  downloadThirdParty: "Download",
  occasionalReport: "Report",
  occasionalReportHint: "Occasional contracts sent in the selected period.",
  occasionalThirdParty: "Occasional third party",
  occasionalThirdPartyHint: "Save a contract, then send that contract. A sent contract cannot be sent again. The customer does not receive a receipt.",
  addOccasionalItem: "Add item",
  dateAscending: "Ascending",
  dateDescending: "Descending",
  noOccasionalHistory: "No contract is in history.",
  historyPastDay: "Past day",
  historyPast7Days: "Past 7 days",
  historyPast1Month: "Past 1 month",
  historyPast2Months: "Past 2 months",
  historyPast3Months: "Past 3 months",
  historyAllTime: "All time",
  historyEmpty: "No document is in history.",
  occasionalItemLimit: "A store can save 60 items.",
  noOccasionalItem: "No item is saved.",
  agreementText: "Agreement",
  payableDate: "Payable date",
  sendContract: "Send contract",
  printMerchantCopy: "Print merchant copy",
  merchantCopyUnavailable: "The merchant copy is not available for this contract.",
  contractSent: "Contract sent to Revenu Québec.",
  contractSentOn: "Contract sent to Revenu Québec",
  contractNotSentYet: "Contract not sent.",
  sendingContract: "Sending",
  sendingContractTitle: "Sending the contract to Revenu Québec",
  copyContract: "Copy",
  confirmEditOccasionalItem: "Edit this contract?",
  contractNotSent: "The contract was not sent.",
  connectionRequired: "A connection is required to send this contract.",
  chooseContractItem: "Choose at least one item.",
  businessCopy: "Business copy",
  businessCopyHint: "This copy is for the business.",
  occasionalItemRequired: "Enter the price, the agreement, the date, and the payable date.",
  occasionalItemSaved: "Item saved.",
  confirmDeleteOccasionalItem: "Delete this item?",
  reference: "Reference",
  estimation: "Estimation",
  quotation: "Quotation",
  contract: "Contract",
  thirdPartySectionPlaceholder: "This section is not available yet.",
  proposalNextStep: "Next step",
  proposalStepEnter: "Enter",
  proposalStepSend: "Send",
  proposalStepFinish: "Finish",
  proposalCustomer: "Customer",
  proposalEmail: "Email",
  proposalEmailHelp: "Where to send the electronic copy. Leave this empty to print only.",
  proposalAddLine: "Add line",
  proposalRemoveLine: "Remove",
  proposalDescription: "Description",
  proposalQuantity: "Quantity",
  proposalPrice: "Price",
  proposalSales: "Sales",
  proposalNoEmail: "No email is entered. This document is printed at the station.",
  proposalPaper: "Paper",
  proposalPaperHelp: "Print the document at the station.",
  proposalPaperAndEmail: "Paper and email",
  proposalPaperAndEmailHelp: "Print the document and send it to this address.",
  proposalEmailOnly: "Email",
  proposalEmailOnlyHelp: "Send it to this address. The station does not print it.",
  proposalEdit: "Edit",
  proposalNotSent: "The document was not sent.",
  proposalConnectionRequired: "A connection is required to send this document.",
  proposalClosed: "This document is closed.",
  proposalReport: "Report",
  proposalDocuments: "Documents",
  proposalReportHint: "Documents sent in the selected period.",
  proposalReportEmpty: "No documents in this period.",
  proposalSentToRq: "Sent to Revenu Québec",
  proposalReturnNumber: "Return number",
  proposalReturnDate: "Return date",
  proposalSending: "Sending the document to Revenu Québec",
  proposalEmailFailed: "The document was sent. The email was not sent.",
  proposalPrintFailed: "The document was sent. It was not printed.",
  proposalSentPrinted: "Sent and printed.",
  proposalSentEmailed: "Sent by email.",
  proposalSentBoth: "Sent, printed, and emailed.",
  proposalDraftNext: "Next: send and print.",
  proposalChargeToAccount: "Charge to account",
  proposalPayment: "Payment",
  proposalReason: "Reason",
  proposalReasonHelp: "This reason is printed on the closing receipt.",
  proposalStatusDraft: "Draft",
  proposalStatusSent: "Sent",
  proposalStatusRevised: "Revised",
  proposalStatusAccepted: "Accepted",
  proposalStatusDeclined: "Declined",
  proposalStatusCompleted: "Completed",
  proposalStatusCancelled: "Cancelled",
  quotationPurpose: "A price offer. Send it and print it. If the customer accepts, print the next bill. If the customer declines, stop.",
  quotationEmpty: "No quotation is saved. Click New quotation. Enter the items, save, then send. The quotation is printed for the customer.",
  quotationNew: "New quotation",
  quotationSaveNext: "Save the offer. Nothing is sent until you click Send quotation.",
  quotationSend: "Send quotation",
  quotationSendPrintConfirm: "Send this quotation and print it?",
  quotationSendEmailConfirm: "Send this quotation by email?",
  quotationFinishNext: "Ask the customer. Accept prints the next bill. Decline stops here. Revise sends a new quotation if the prices changed.",
  quotationAccept: "Accept",
  quotationAcceptHelp: "The customer wants this offer. Choose the next bill, then print it.",
  quotationDecline: "Decline",
  quotationDeclineHelp: "The customer does not want this offer. Nothing else is sent.",
  quotationRevise: "Revise",
  quotationReviseHelp: "The prices changed. Send a revised quotation. The paper says SOUMISSION RÉVISÉE.",
  quotationContinueQuestion: "How should this offer continue?",
  quotationTemporaryBill: "Temporary bill",
  quotationTemporaryBillHelp: "Print a bill now. Payment is collected later.",
  quotationClosingReceipt: "Closing receipt",
  quotationClosingReceiptHelp: "Print the final receipt. Choose how the customer pays, or charge the amount to the account.",
  quotationBillNext: "This bill refers to the quotation. The QR code is printed on it.",
  quotationPrintTemporary: "Print temporary bill",
  quotationPrintClosing: "Print closing receipt",
  quotationDeclineConfirm: "Decline this quotation? Nothing else is sent.",
  quotationDeclinedNext: "This quotation is closed.",
  quotationReviseNext: "Change the prices, then send the revised quotation. The first quotation stays on record.",
  quotationSendRevised: "Send revised quotation",
  quotationContinue: "Continue",
  quotationAnswer: "Record the answer",
  quotationCardSent: "Ask the customer, then accept or decline.",
  estimatePurpose: "Prices or quantities that can still change. Send it and print it. When the work ends, print a closing receipt. If the work is cancelled, print a closing receipt for $0.00.",
  estimateEmpty: "No estimate is saved. Click New estimate. Enter the expected items, save, then send.",
  estimateNew: "New estimate",
  estimateSaveNext: "Save the estimate. Nothing is sent until you click Send estimate.",
  estimateSend: "Send estimate",
  estimateSendNext: "Send this estimate. A closing receipt is still required when the work ends.",
  estimateSendPrintConfirm: "Send this estimate and print it?",
  estimateSendEmailConfirm: "Send this estimate by email?",
  estimateFinishNext: "The estimate is printed. When the work is finished, complete it. If the quantities changed, revise it. If the work stops, cancel it. Each ending prints a closing receipt.",
  estimateComplete: "Complete",
  estimateCompleteHelp: "The work is done. Confirm the final amounts and print the closing receipt.",
  estimateRevise: "Revise",
  estimateReviseHelp: "The quantities or prices changed. Send a revised estimate. The paper says ESTIMATION RÉVISÉE.",
  estimateCancel: "Cancel estimate",
  estimateCancelHelp: "The work will not be done. A closing receipt for $0.00 is printed. The paper says ESTIMATION ANNULÉE.",
  estimateCompleteNext: "This receipt closes the estimate and refers to it. The QR code is printed on it.",
  estimatePrintClosing: "Print closing receipt",
  estimateCancelPrint: "Cancel estimate and print",
  estimateReviseNext: "Change the quantities or prices, then send the revised estimate.",
  estimateSendRevised: "Send revised estimate",
  estimateFinish: "Finish",
  estimateCardSent: "Finish this estimate with a closing receipt.",
  contractPurpose: "A banquet, catering, or group agreement. Enter the agreement, send it, and print it. When the service is done, print the closing receipt.",
  contractEmpty: "No contract is saved. Click New contract. Enter the agreement, save, then send.",
  contractNew: "New contract",
  contractDescription: "Description",
  contractDescriptionHelp: "What this agreement covers.",
  contractReferenceHelp: "The agreement number.",
  contractServiceDate: "Service date",
  contractServiceDateHelp: "The date the service is provided.",
  contractPayableHelp: "The date the full amount is due.",
  contractGuests: "Guests",
  contractGuestsHelp: "How many people this agreement covers.",
  contractPriceHelp: "The amount before taxes.",
  contractSaveNext: "Save the agreement. Send it when the details are final. The customer receives a printed estimate with a QR code. A closing receipt still follows when the service is done.",
  contractSend: "Send contract",
  contractSendPrintConfirm: "Send this contract and print it?",
  contractSendEmailConfirm: "Send this contract by email?",
  contractFinishNext: "The contract is printed. When the service is done, print the closing receipt. If the event changes, revise it. If the event stops, cancel it.",
  contractComplete: "Complete",
  contractCompleteHelp: "The service is done. Print the closing receipt.",
  contractCompleteNext: "This receipt closes the contract and refers to it. The QR code is printed on it.",
  contractRevise: "Revise",
  contractReviseHelp: "A date, the guest count, or the price changed. Send the revised contract.",
  contractCancel: "Cancel contract",
  contractCancelHelp: "The event will not take place. Print a closing receipt for $0.00.",
  contractReviseNext: "Change the agreement, then send the revised contract.",
  contractSendRevised: "Send revised contract",
  contractFinish: "Finish",
  contractCardSent: "Finish this contract with a closing receipt.",
  packageDeal: "Package deal",
  packagePurpose: "A package bought outside the restaurant. Enter the package and the included items, then send the closing receipt. No payment is collected.",
  packageEmpty: "No package deal is saved. Click New package deal. Enter the package, save, then send.",
  packageNew: "New package deal",
  packageName: "Package name",
  packageNameHelp: "The name of this package.",
  packageAmount: "Package amount",
  packageAmountHelp: "This amount is the negative of the included items. The total is $0.00.",
  packageLinePriceHelp: "Enter the price of each item. Leave the price empty when there is no price.",
  packageAddItem: "Add item",
  packageItemOptional: "Items are optional. Add an item only when this package includes one.",
  packageServiceDate: "Service date (optional)",
  packageServiceDateHelp: "Leave this empty when there is no service date.",
  packagePayableDate: "Payable date (optional)",
  packagePayableHelp: "Leave this empty when there is no payable date.",
  packageLeaving: "You are leaving.",
  packageLeavingSave: "This package deal will be saved.",
  packageLeavingName: "Enter a package name to save this package deal.",
  packageStay: "Stay",
  packageSaveNext: "Save the package. Nothing is sent until you click Send package deal.",
  packageSend: "Send package deal",
  packageSendPrintConfirm: "Send this package deal and print it?",
  packageSendEmailConfirm: "Send this package deal by email?",
  packageSendNext: "Send this package deal. The closing receipt shows no payment and a total of $0.00.",
  packageFinishNext: "The package deal is printed. If an item changes, revise it. If it stops, cancel it.",
  packageComplete: "Complete",
  packageCompleteHelp: "The service is done. Print the closing receipt. No payment is collected.",
  packageCompleteNext: "This receipt closes the package deal. No payment is collected. The total is $0.00.",
  packageNoPayment: "No payment is collected. The receipt total is $0.00.",
  packageRevise: "Revise",
  packageReviseHelp: "An item or a price changed. Send the revised package deal.",
  packageReviseNext: "Change the package, then send the revised package deal.",
  packageSendRevised: "Send revised package deal",
  packageCancel: "Cancel package deal",
  packageCancelHelp: "This package will not be supplied. Print a closing receipt for $0.00.",
  packageFinish: "Finish",
  packageCardSent: "This package deal has a closing receipt.",
  frequentThirdParty: "Frequent third party",
  frequentThirdPartyHint: "Add a company, then send the contract declaration when the agreement is new, changed, or ended. You can save it and send later.",
  addFrequentThirdParty: "Add frequent third party",
  frequentThirdPartyLimit: "A store can save 10 frequent third parties.",
  noFrequentThirdParty: "No frequent third party is saved.",
  frequentThirdPartySaved: "Frequent third party saved.",
  frequentThirdPartyRequired: "Enter the name and QST number.",
  sendDeclaration: "Send declaration",
  saveForLater: "Save for later",
  sendingDeclaration: "Sending",
  view: "View",
  moreActions: "More actions",
  confirmEditThirdParty: "Edit this frequent third party?",
  confirmDeleteThirdParty: "Delete this frequent third party?",
  declarationSent: "Declaration sent.",
  declarationSentOn: "Declaration sent",
  declarationNotSent: "Declaration not sent.",
  oneFrequentThirdPartyPerBill: "One bill can include only one frequent third party. Place the other company on a separate bill.",
  thirdPartyReport: "Third-party report",
  thirdPartyReportHint: "Sales collected for one company.",
  reportPeriod: "Period",
  reportPeriodDay: "Day",
  reportPeriodMonth: "Month",
  amountToPay: "Total",
  noThirdPartySales: "No sales for this company in this period.",
  sendReportEmail: "Send email",
  reportEmailSent: "Report sent.",
  reportEmailSentAt: "Email sent",
  reportEmailFailed: "The report was not sent.",
  reportEmailRequired: "Enter an email address.",
  thirdPartyRefund: "Refund",
  thirdPartyPrinted: "Sent to the printer.",
  saveReportPdf: "Save PDF",
  declarationFailed: "Declaration was not sent.",
  billingActivity: "Billing activity",
  nonRegulatedItem: "Non-regulated item",
  selectFrequentThirdParty: "Select a frequent third party",
  addThirdPartyInSettings: "Add a frequent third party in Settings.",
  legalName: "Legal name",
  qstNumber: "QST number",
  civicNumber: "Civic number",
  street: "Street",
  city: "City",
  postalCode: "Postal code",
  extension: "Extension",
  neq: "NEQ",
  contractReason: "Contract reason",
  newContract: "New",
  amendment: "Amendment",
  expiration: "Expiration",
  signedOn: "Signature date",
  effectiveOn: "Effective date",
  expiresOn: "Expiration date",
  serviceDescription: "Service description",
  frequency: "Frequency",
  timeOfDay: "Time of day",
  dayTime: "Day",
  evening: "Evening",
  night: "Night",
  galleryForCustomer: "Gallery/Advertisement for Customer Facing Screen",
  customMealCategory: "Custom Meal Category",
  storeType: "Store Type",
  tableOrderingSetting: "Table Ordering Setting",
  serviceMode: "Service Mode",
  sharedService: "Shared Service — Default",
  assignedService: "Assigned Service",
  sharedServiceDescription: "All authorized servers and cashiers can access and manage open orders, regardless of who created them. Employees can assist each other with ordering, kitchen operations, bill splitting, and payments without transferring ownership.",
  assignedServiceDescription: "Each order belongs to the employee who first opens it. Other employees cannot modify or process the order unless ownership is transferred to them or they have special access permissions.",
  serviceModeSaved: "Service mode saved",
  orderBelongsToAnotherEmployee: "This order belongs to another employee.",
  claimOrderBeforeChanges: "Claim this order before making changes.",
  claimOrder: "Claim order",
  transferOrderOwnership: "Transfer ownership",
  selectReceivingEmployee: "Select the receiving employee",
  confirmTransfer: "Confirm transfer",
  transferFromTo: "From {from} to {to}",
  transferOwnershipToast: "Ownership transferred",
  idleTableAutoClosing: "Idle table auto-closing",
  idleTableAfter: "After",
  idleTableMinutes: "minutes, idle table auto-closing.",
  idleTableCloseMinutes: "After how many minutes?",
  tableStatusDirtyAfterPayment: "Set table status to Dirty after payment",
  tableStatusAvailableAfterPayment: "Set table status to Available after payment",
  dirtyTableAutoAvailable: "Set table status from Dirty to Available automatically",
  tableOrderingSaved: "Table ordering setting saved",
  closeTableQuestion: "Close this table?",
  keepTableOpen: "Keep open",
  tableHoldOrderDetail: "Order detail",
  lockTable: "Lock table",
  lockFor1Hour: "Lock for the next 1 hour",
  lockFor2Hours: "Lock for the next 2 hours",
  lockFor3Hours: "Lock for the next 3 hours",
  lockForRestOfNight: "Lock the rest of the night",
  lockForRestOfDay: "Lock the rest of the day",
  unlockTable: "Unlock table",
  tableLockedBy: "Locked by",
  tableLockedUntil: "Until",
  noOpenOrder: "No open order",
  closeTable: "Close table",
  changeTableStatus: "Change table status",
  tableStatus: "Table status",
  tableStatusAvailable: "Available",
  tableStatusSeated: "Seated",
  tableStatusOrdering: "Ordering",
  tableStatusInService: "In service",
  tableStatusPayment: "Payment pending",
  tableStatusDirty: "Dirty",
  tableFaceSeated: "Seated",
  tableFaceOrdering: "Ordering",
  tableFaceService: "Service",
  tableFacePayment: "Payment",
  tableFaceDirty: "Dirty",
  tableStatusMaintenance: "In maintenance",
  tableFaceMaintenance: "Maintenance",
  tableInMaintenance: "This table is in maintenance.",
  tableNeedsCleaning: "This table must be cleaned before an order can be opened. Press and hold the table, then set the status to Available.",
  releaseTable: "Release table",
  billingSubactivity: "Activity",
  billingSubactivityHelp: "This activity is set for the store and is used on bills.",
  itemUsesStoreActivity: "Store activity",
  billingSubactivityUpdated: "Activity updated",
  cartPosition: "Cart position",
  cartPositionLeft: "Left",
  cartPositionRight: "Right",
  cartPositionHelp: "Choose which side shows the cart. Menu categories use the other side.",
  cartPositionUpdated: "Cart position updated",
  cartNowOnLeft: "The cart is on the left.",
  cartNowOnRight: "The cart is on the right.",
  categoryInMiddle: "Categories in the middle",
  categoryInMiddleHelp: "Categories sit between the products and the cart. The cart stays on the side chosen above.",
  categoryInMiddleUpdated: "Categories updated",
  categoryNowInMiddle: "Categories are in the middle.",
  categoryNowOnSide: "Categories are on the side.",
  activityRestaurant: "Restaurant",
  activityBar: "Bar",
  activityFoodTruck: "Food truck",
  barActivityTaxNote: "For a bar item, check the alcohol tax under Taxes below.",
  currency: "Currency",
  add: "Add",
  combo: "Combo",
  print: "Print",
  sessions: "Sessions",
  orders: "Orders",
  customerFacingScreen: "Customer Facing Screen",
  cashierView: "Cashier View",
  kitchenView: "Kitchen View",
  layoutView: "Layout View",
  history: "History",
  noOrderRecordsExist: "No order records exist",
  noSessionRecordsExist: "No session records exist",
  updateMenu: "Update Menu",
  updateMenuSuccessfully: "Update menu successfully",
  updateMenuTooltip: "Publishes menu and category changes.",
  updateMenuFrontEndWarning: "Update Menu publishes menu and category changes.",
  syncingMenu: "Syncing...",
  errorSyncingMenu: "Error syncing menu",
  serving: "Serving",
  active: "Active",
  inactive: "Inactive",
  amount: "Amount",
  total: "Total",
  table: "Table",
  payment: "Payment",
  cash: "Cash",
  creditCard: "Credit Card",
  tips: "Tips",
  tipPercent: "Tip %",
  tipAmount: "Tip Amount",
  customTip: "Custom",
  totalWithTip: "Total with tip",
  paymentTipPercentages: "Payment Tip Percentages",
  paymentTipsBeforeTaxes: "Tips calculated before taxes",
  paymentTipsAfterTaxes: "Tips calculated after taxes",
  tipsSharedAmongStaff: "Tips are shared among staff",
  changeDue: "Change Due",
  printReceipt: "Print Receipt",
  cancel: "Cancel",
  complete: "Complete",
  edit: "Edit",
  delete: "Delete",
  update: "Update",
  deleteOrder: "Delete order",
  printOrderSlip: "Print Order Slip",
  printKitchenSlip: "Print Kitchen Slip",
  latestOrderAt: "Latest order at",
  completedAt: "Completed at",
  received: "Received",
  startEditing: "Start Editing",
  save: "Save",
  addSmallDiningTable: "add small dining table",
  addMediumDiningTable: "add medium dining table",
  addLargeDiningTable: "add large dining table",
  clearAll: "clear all",
  undo: "undo",
  reorder: "reorder",
  renew: "Renew",
  renewSession: "Renew Session",
  createNewSession: "Create New Session",
  addSession: "Add Session",
  createSession: "Create Session",
  printSession: "Print QR Code",
  takeOrder: "Take Order",
  editOrder: "Edit Order",
  completeOrder: "Complete Order",
  CompleteOrderByUser: "Complete Order Per Customer",
  description: "Description",
  ingredients: "Ingredients",
  price: "Price",
  category: "Category",
  createdDate: "Created Date",
  lastUpdated: "Last Updated",
  lastUpdatedAt: "Last updated at",
  admins: "Admins",
  members: "Members",
  invited: "Invited",
  owner: "Owner",
  member: "Member",
  admin: "Admin",
  kdsUser: "KDS user",
  kdsUsers: "KDS users",
  chooseRole: "Choose a role",
  addMemberNotPosNotice: "A POS user and a 6-digit PIN are created with this login. The store owner can see the PIN. This person can change their own PIN.",
  memberRoleHint: "Member is a back-office login. A POS user and PIN are created with this login.",
  adminRoleHint: "Admin is a back-office login with store settings access. A POS user and PIN are created with this login.",
  kdsUserHint: "KDS user is a back-office login for the kitchen display. A POS user and PIN are created with this login.",
  confirmCreateRoleTitle: "Confirm this role",
  confirmCreateRoleIntro: "You are about to create this login. Please confirm the role.",
  adminsTooltip:
    "Only Super Admin (Store's owner) can grant and remove admin role",
  membersTooltip:
    "Member is authorized to only view and  manage customer's order.",
  invitedTooltip:
    "Invited people will be given [Member] role once invitation is accepted.",
  invitedPeople: "Invited People",
  transferOnwership: "Transfer ownership",
  removeAdminRole: "Remove admin role",
  grantAdminRole: "Grant admin role",
  invitePeople: "Invite people",
  addStore: "Add Store",
  alreadyExists: "already exists",
  existingInvitationTo: "Existing invitation to",
  emailIsRequired: "Email is required",
  nameIsRequired: "Name is required",
  priceIsRequired: "Price is required",
  invalidEmailAddress: "Invalid email address",
  fullService: "Full Service",
  limitedService: "Limited Service",
  storeTypeDescription:
    "Changing store type will affect how cashier view display and complete each order.",
  limitedServiceDescription:
    "Limited service manage orders as one order per submission. (e.g., food/beverage kiosk, food court)",
  fullServiceDescription:
    "Full service manage orders as one order per table/session. (e.g., restaurant, cafe)",
  fullServiceExplain:
    "Full serivice provide full dining experience and customer usually pay after dining. (e.g., restaurant, cafe)",
  limitedServiceExplain:
    "Limited service usually end their customer interaction(serving & payment) pre/on meals served. (e.g., food/beverage kiosk, food court)",
  orderIsEmpty: "Order is empty",
  completedByKitchen: "Completed by kitchen",
  changeMealImage: "Edit Image",
  uploadMealImage: "Upload Image",
  food: "Food",
  drink: "Drink",
  side: "Side",
  submitted: "Submitted",
  confirmDeleteMeal: "Confirm delete meal?",
  confirmRenewSession: "Session is still valid, confirm renew session?",
  confirmCompleteOrder: "Confirm complete order?",
  confirmDeleteSession: "Confirm delete session?",
  confirmDeleteImage: "Confirm delete image?",
  storeInvitation: "Store Invitation",
  noInvitationFound:
    "No invitation found, please request authorization from store's admin",
  join: "Join",
  joinStore: "Join store",
  settingUpStore: "Setting up your store",
  createStore: "Create Store",
  invitation: "Invitation",
  uploadProfilePicture: "Upload Profile Picture",
  changeProfilePicture: "Change Profile Picture",
  myStores: "My Stores",
  profile: "Profile",
  accountSettings: "Account Settings",
  signOut: "Sign out",
  deleteStore: "Delete Store",
  cloneStore: "Clone Store",
  cloneItem: "Clone",
  uploadImage: "Upload Image",
  temporarySession: "Temporary (session will be expired within 24 hours)",
  deleteSessionOnCompletion: "Delete session on order complete",
  autoRenew:
    "Automatically renew session on order complete (delete session is required)",
  limitedServiceSession:
    "Session expiration and deletion have been disabled to fit limited-service operation, you can configure your preference of session behavior below",
  noExistingNameFound: "Create session here then create table at ",
  ifYouWantLink: " to link session and table in Layout View",
  noOptions: "No Options",
  addCustomerGallery: "Add Screen Advertisement/Gallery",
  grantAdminRoleToast: "has been granted [Admin] role",
  removeAdminRoleToast: "has been move to member list",
  deleteInvitationToast: "has been removed from invitation list",
  deleteMemberToast: "has been removed from member list",
  deleteAdminToast: "has been removed from admin list",
  transferOnwershipToast: "store ownership transfer to",
  sendInvitationToast: "Successfully send invitation to",
  switchedStoreToast: "Switched to",
  deleteStoreToast: "Successfully deleted",
  recommendItToCustomer: "Recommend it to customer",
  emailUs: "Email us for any inquiry",
  emailUsShort: "Email",
  signup: "Signup",
  login: "Login",
  quitStore: "Quit Store",
  switchToStore: "Swith to store",
  currentStoreLabel: "Current",
  confirmSwitchStoreTitle: "Switch store?",
  confirmSwitchStoreBody: "Switch to",
  changeLogo: "Change Logo",
  uploadLogo: "Upload Logo",
  emailVerifiedToast: "Your email has been verified!",
  emailSentToast: "Email sent!",
  emailSentToastDescription: "Please check your email for verification",
  emailVerificationErrorToast: "Verification Email already sent",
  emailVerificationFailedToast: "Failed to send Verification Email",
  resetPasswordToast:
    "Thanks, check your email for instructions to reset your password",
  emailNotExist: "Email not exist",
  failedToUpload: "Failed to upload",
  saveLayoutToast: "table layout has been updated",
  invalidEmailOrPassword: "Invalid Email or Password",
  failedToLogin: "Failed to login",
  accountCreated: "Account created",
  verificationEmailSent: "Verify your e-mail",
  verficiationEmailSentDescription:
    "To complete your account registration process we must verify that the email address belongs to you.",
  emailAlreadyExist: "Email already exist",
  successfullyCreateStore: "Successfully create store ",
  pleaseSwitchStore: ", please switch to your new store.",
  pleaseCreateMeal: ", please proceed to create meals for your store.",
  youAreNowMemberOf: "You are now member of",
  orderFromTable: "Order from table",
  isCompleted: "is completed",
  addedCategory: "Added category",
  removedCategory: "Removed category",
  currencyChanged: "Currency has been changed to",
  successfullyUpdateStore: "Successfully updated store",
  storeTypeChanged: "Store type changed to",
  layoutNotReady: "Layout not ready...",
  layoutNotReadyDescription:
    "You haven't created your layout yet, please proceed to create layout for your store.",
  createLayout: "Create Layout",
  confirmQuitStore: "Confirm quit store?",
  minimumItemQuantity: "Minimum decimal of order quantity",
  noMoreOrder: "There are no more order",
  loadMore: "Load more",
  id: "ID",
  notifications: "Notifications",
  switchToDarkMode: "Dark mode",
  switchToLightMode: "Light mode",
  highContrast: "High contrast",
  highContrastOff: "Standard contrast",
  defaultMode: "Default mode",
  defaultModeHint: "This theme is used on POS screens. Staff can change it while signed in. After sign-out, this default is used again.",
  enterFullscreen: "Enter fullscreen",
  exitFullscreen: "Exit fullscreen",
  noNotificationFound: "No notification found",
  noticeHistory: "History",
  noticePlain: "Plain text",
  noticeHidden: "Hidden",
  allowMemberEdit: "Allow member to edit orders",
  storeCreated: "Store created",
  printerSettingsUpdated: "Send Printer Setting to Cloud",
  storeCreatedNotification:
    "You have successfully set up your store, please proceed to create meals for your store.",
  manageSubscription: "Manage Subscription",
  billing: "Billing",
  currentSubscription: "Current Subscription",
  mySubscription: "My Subscription",
  initiateSubscription:
    "If you are a store owner, please proceed to create store first.",
  selectYourStoreType: " Select your store type",
  configureStoreTypeInfo:
    "Store type can be reconfigured later if you are not sure which to choose.",
  compulsoryItem: "Automatically added and immutable quantity",
  compulsory: "Compulsory",
  yes: "Yes",
  no: "No",
  hiddenFromMenu: "Hidden from menu",
  dashboard: "Dashboard",
  addedPaymentMethod: "Added payment method",
  removedPaymentMethod: "Deleted payment method",
  paymentMethod: "Payment Method",
  paymentMethods: "Payment Methods",
  // Payment Method Names (English only)
  paymentMethodArgentComptant: "Cash",
  paymentMethodCarteCredit: "Credit Card",
  paymentMethodPaiementMixte: "Mixed Payment",
  chooseNextPaymentMethod: "Next payment",
  editTendered: "Edit tendered amount",
  cashAmountDue: "Due",
  changeDue: "Change",
  receiptPrinting: "Receipt printing",
  amountReceived: "Received",
  amountRemaining: "Remaining",
  mixedPaymentSettingNote: "This does not appear in the payment window. When it is on, a bill can be paid with more than one method. The closing bill is sent as mixed payment.",
  discardPartialPaymentsTitle: "This bill is not paid.",
  discardPartialPaymentsBody: "The payments entered here will be discarded.",
  keepPaying: "Keep paying",
  discardPayments: "Discard payments",
  paymentMethodCarteDebit: "Debit Card",
  paymentMethodTransfertElectronique: "Electronic Funds Transfer",
  paymentMethodPortefeuilleElectronique: "Digital Wallet",
  paymentMethodCryptomonnaie: "Cryptocurrency",
  paymentMethodCertificatCadeau: "Gift Certificate/Coupon",
  paymentMethodProgrammeFidelisation: "Loyalty Program",
  paymentMethodPorteAuCompte: "Charge to Account",
  paymentMethodCheque: "Cheque",
  paymentMethodAutre: "Other Payment Method",
  paymentMethodAucunPaiement: "No Payment",
  paymentMethodSansObjet: "Not Applicable / No Payment",
  openCashDrawer: "Open cash drawer",
  openCashDrawerDescription: "Cash drawer will open when using this payment method",
  cashDrawerOpened: "Cash drawer opened",
  cashDrawerError: "Failed to open cash drawer",
  allowRefund: "Allow refund processing on POS",
  allowRefundDescription: "This payment method can be used for refunds in the POS system",
  options: "Options",
  summarized: "Summarized",
  unit: "Unit",
  unitPlaceHolder: "Unit for display purpose (e.g., gram, kg, sets)",
  totalAmount: "Total Amount",
  checkout: "Checkout",
  back: "Back",
  close: "Close",
  remark: "Remark",
  orderSettings: "Order",
  paymentKitchenOrder: "Served first / Payment first",
  paymentFirst: "Payment first",
  servedFirst: "Served first",
  alwaysCompleteAtKitchenView:
    "For Payment-First operation, complete your order at Kitchen View everytime after payment.",
  paymentFirstWarning:
    "Select Payment-First for Full-Service may cause unexpected behaviour",
  paymentKitchenExplained:
    "Only select the payment-first option to prevent order being removed after payment.  This is useful if your staff require to read info in kitchen view (e.g., ingredients)",
  kitchenPrintTiming: "Kitchen print",
  kitchenPrintBeforePayment: "Before payment",
  kitchenPrintAfterPayment: "After payment",
  kitchenPrintAfterAutomatic: "After payment, automatic",
  kitchenPrintAfterManual: "After payment, manual",
  kitchenPrintTimingHelp: "Choose when the kitchen ticket is printed.",
  afterOrderScreen: "After the order",
  afterOrderScreenHelp: "Choose where the screen goes when the order is finished or canceled.",
  afterOrderStay: "Stay on this screen",
  afterOrderOpenTip: "Open TIP",
  afterOrderUpdated: "After-order setting updated",
  kitchenPrintMode: "Kitchen ticket",
  kitchenPrintAutomatic: "Auto",
  kitchenPrintManual: "Manual",
  kitchenPrintModeHelp: "Auto prints the ticket after payment. Manual asks before printing.",
  kitchenPrintUpdated: "Kitchen print setting updated",
  kitchenService: "Kitchen Service",
  kitchenServiceUpdated: "Kitchen service updated",
  kitchenCourses: "Courses",
  addCourse: "Add course",
  kdsCourseFireFlash: "KDS course fire flash",
  courseFirstTicket: "First ticket",
  courseOnFire: "On fire",
  courseOnHold: "On hold",
  courseFireNow: "Fire now",
  coursePrintOnFirst: "Print on the first ticket",
  coursePrintOnSecond: "Print on the second ticket",
  kdsFlash13: "13 seconds",
  kdsFlash15: "15 seconds",
  kdsFlash30: "30 seconds",
  serviceSequence: "Service sequence",
  fire: "Fire",
  fireSent: "Service sent",
  fireNone: "No course is ready to send",
  fireNoPrinter: "No kitchen printer is set up for these dishes",
  printKitchenTicket: "Print kitchen ticket",
  kitchenReceiptNotPrinted: "The kitchen receipt has not been printed. Do you want to proceed?",
  tableName: "Session / Layout's table name",
  storeOperation: "Store Operation",
  reservationConfirmationEmail: "Reservation Confirmation Email",
  reservationConfirmationEmailHelp: "Enter up to 3 email addresses, separated by commas.",
  reservationConfirmationEmailInvalid: "Enter up to 3 valid email addresses, separated by commas.",
  reservationConfirmationEmailSaved: "Reservation confirmation addresses saved.",
  offline: "Offline",
  offlineBatchSize: "Batch size limit",
  offlineBatchSizeHelp: "Offline bills are sent in requests up to this size. The maximum is 256 KB.",
  offlineBatchSizeInvalid: "Enter a whole number from 1 to 256.",
  offlineBatchSizeSaved: "Offline batch size saved.",
  alternativeTimeOffered: "Alternative time offered: {date} {time}",
  keypadPopupAtLogin: "Keypad popup at login",
  keypadPopupAtLoginToggle: "Show keypad at login",
  keypadPopupAtLoginDescription:
    "When on, the PIN pad appears at login even if a POS user is linked. When off, a linked POS user starts automatically.",
  keypadPopupAtLoginEnabled: "Keypad popup enabled",
  keypadPopupAtLoginDisabled: "Keypad popup disabled",
  keypadPopupAtLoginEnabledHint: "The PIN keypad will appear automatically at login",
  keypadPopupAtLoginDisabledHint: "The PIN keypad will stay hidden at login",
  keypadPopupAtLoginUpdateFailed: "Failed to update keypad popup at login",
  sessionControl: "Session Control",
  all: "All",
  simple: "Simple",
  sessionControlExplained:
    "With [Simple] session control, you will not able to [Add new session], [Delete session], [Renew session] and [Print session] in [Cashier View], so please setup your session configuration properly before changing to [Simple] session control.",
  none: "None",
  nearest: "Nearest",
  up: "Up",
  down: "Down",
  roundingTotal: "Rounding Total Price",
  roundingItem: "Rounding Item Price",
  changeTo: "Changed to",
  allSessionControl: "Complete Session Control",
  simpleSessionControl: "Simple Session Control",
  requiredTableName:
    "Request Staff/Customer to insert table name (Not relatable to Layout's table) on checkout",
  pleaseInsertTableName: "Please insert your table name",
  session: "Session",
  inheritFromStore: "Inherit from store",
  customerScreen: "Customer screen",
  openCustomerScreen: "Open customer screen",
  openCustomerScreenHelp: "Opens the customer screen in a second window.",
  customerScreenActive: "Active",
  customerScreenOff: "Off",
  customerScreenActiveHelp: "Turns the customer screen on or off.",
  customerScreenAlwaysOnHelp: "Customer screen is turned on for this store.",
  customerScreenAppearance: "Appearance",
  customerScreenLight: "Light",
  customerScreenDark: "Dark",
  pinCustomerScreen: "Pin",
  unpinCustomerScreen: "Unpin",
  chooseThisCustomer: "Choose this customer",
  recentOrders: "Recent Orders",
  standard: "Standard",
  standardMenuControl: "Standard Menu Control",
  simpleMenuControl: "Simple Menu Control",
  menuControl: "Staff Menu",
  completePaymentFirstAlert: "Please complete payment at [Cashier View] first",
  detail: "Detail",
  detailNotExists: "Order detail no longer exists",
  addedRemarkShortcut: "Added remark shortcut",
  removedRemarkShortcut: "Removed remark shortcut",
  remarkShortcuts: "Remark shortcuts",
  paymentMethodNameIsRequired: "Payment method name is required",
  paymentMethodAlreadyExisted: "Payment method already existed",
  categoryNameIsRequired: "Category name is required",
  categoryAlreadyExisted: "Category already existed",
  shortcutNameIsRequired: "Shortcut name is required",
  shortcutAlreadyExisted: "Shortcut already existed",
  shortcut: "Shortcut",
  createOption: "Create option",
  optionName: "Option name",
  requireChange: "Require change calculation on payment",
  menuSettings: "Menu",
  paymentSettings: "Payment",
  submittingOrder: "Submitting order...",
  submittedOrder: "Successfully submitted the order!",
  addMeal: "Add Meal",
  createdFirstMeal: "Create First Meal",
  pleaseUpdateMenu:
    "You have successfully created your first meal, please click here to update your menu after completely setup your meals.",
  pleaseCreateSession:
    "Please proceed to [Cashier View] to create your first session/table.",
  storeSetupComplete: "Setup Session Successfully",
  moreStoreConfiguration:
    "Press on the QR code to start taking order, or print QR code for your customer to make order. Proceed to [Settings] section to update more specific store configuration to match your store operation perfectly.",
  ok: "Okay",
  features: "Features",
  others: "Others",
  kitchen: "Kitchen View",
  hasBeen: "has been ",
  enabled: "Enabled",
  disabled: "disabled",
  untickToDisable: "Untick to disable feature",
  debugMode: "Debug Mode",
  currentUrl: "Current URL",
  printAfterCompletion: "Print after order complete",
  userDecide: "User decide",
  alreadyAMember: "Already a member?",
  sign_up: "Sign Up",
  log_in: "Log In",
  welcomeToNuagePos: "Welcome to NuagePOS Eagle",
  signInToAccountPOS: "Sign in to your account.",
  password: "Password",
  confirmPassword: "Confirm Password",
  passwordMustBe6: "Password must be at least 6 characters long",
  passwordRequirements: "Use 8 to 25 characters with an uppercase letter, a lowercase letter, a number, and a symbol.",
  passwordRuleLength: "8 to 25 characters",
  passwordRuleUpper: "Uppercase letter",
  passwordRuleLower: "Lowercase letter",
  passwordRuleNumber: "Number",
  passwordRuleSymbol: "Symbol",
  passwordSymbolsLabel: "Allowed symbols",
  passwordUnsupportedCharacter: "Remove characters that are not a letter, a number, or an allowed symbol.",
  required: "Required",
  passwordUnmatched: "Password Unmatched",
  forgotPassword: "Forgot password?",
  OR: "OR",
  signInWithGoogle: "Sign in with Google",
  forgotPasswordInfo: "You'll get an email with a reset link",
  resetPassword: "Reset Password",
  sendResetPassword: "Send reset password",
  passwordResetFailed: "The password reset email was not sent",
  verifyYourEmail: "Verify your email address",
  check: "Check",
  toVerify: "to verify your account and get started.",
  ifYouHaveNotReceived:
    "If you have not received the email after a few minutes, please check your spam folder",
  resendVerificationEmail: "Resend Verification Email",
  refresh: "Refresh",
  startNow: "Start Now",
  freeUnlimitedUsers: "Free. Unlimited Users.",
  etilhubDescription:
    "A lite POS solution to run your restaurant and F&B business efficiently.",
  cloudSmart: "Cloud-based | Smart",
  pointOfSale: "Point of Sale",
  registerForFree: "Register for free",
  qrFoodOrdering: "QR Food Ordering",
  contactlessOrders: "Contactless Orders",
  instantAndEasySetup: "Instant and Easy to setup",
  adjustableForEveryBusiness: "Adjustable for every F&B business model",
  billingProcessingPrinting: "Billing processing & printing",
  orderSlipPrinting: "Order slip printing",
  issueReceipt: "Issue printed or electornic receipts",
  sessionQRPrinting: "Session QR code printing",
  instantKitchenView: "Instant kitchen view",
  realtimeOrderStatus: "Real-time order status",
  orderQueue: "Order queue",
  ingredientsDisplay: "Ingredients display",
  customizableFloorPlan: "Customizable floor plan",
  restaurantTableLayout: "Restaurant table layout",
  realtimeTableStatus: "Real-time table status",
  intuitiveInterface: "Intuitive interface",
  moreFeatures: "More features",
  comingsoon: "coming soon...",
  noItemExist: "No item records exist",
  myStore: "My Store",
  logout: "Logout",
  navigationSettings: "Navigation Settings",
  navigateToPaymentAfterSubmit:
    "Navigate to payment after order submitted (Cashier View)",
  size: "Size",
  small: "Small",
  medium: "Medium",
  large: "Large",
  tableNameMustBeSame:
    "Table name must be same as session name, you can create table here first before proceed to create session for your store. ",
  confirmDeleteStore:
    "Confirm that you want to delete this store:",
  deleteThisStore: "Delete this store?",
  deleteStoreWarning:
    "Doing so will permanently remove the store and unable to recover in the future.",
  pleaseInsertStoreName: "Please insert store name",
  typeDeleteToConfirm: "Type DELETE to confirm deletion",
  typeDeletePlaceholder: "Type DELETE",
  cloneThisStore: "Clone store",
  cloneStoreInfo: "Update details for your new store.",
  addIngredient: "Add Ingredient",
  orderUpdatedAt: "Order updated at table",
  simpleMenuInfo:
    "Note: Simple Menu has limitation of selecting multiple option for each meal.",
  fiverr: "Fiverr",
  bySigningUp: "By signing up, you agree to our",
  privacyPolicy: "Privacy Policy",
  termsAndConditions: "Terms & Conditions",
  and: "and",
  storeExceedSubscriptionLimit:
    "Number of store exceed subscription limit, update your plan to add more store.",
  someStoreIsNotShowing:
    "Some store is not showing due to expiration of your subscription.",
  currentPeriodStart: "Current period start",
  currentPeriodEnd: "Your plan renews on",
  planCanceledOn: "Your plan will be canceled on",
  // Subscription plan names
  planEssential: "Essential (Free Forever)",
  planStandard: "Standard",
  planProKitchen: "Pro Kitchen",
  planEliteKitchen: "Elite Kitchen",
  // Subscription messages
  orderLimitReached: "Order limit reached",
  orderLimitReachedMessage: "You have reached the limit. Please upgrade to Standard Plan to continue.",
  upgradePlanToContinue: "You have reached the daily order limit. Please upgrade your plan to continue.",
  upgradePlanToUseService: "Please upgrade your plan to use this service",
  serviceNotAvailable: "Service not available",
  daysRemaining: "days remaining",
  upgradeNow: "Upgrade Now",
  upgradeRequired: "Upgrade Required",
  upgradeToContinue: "To continue using the POS system, please upgrade your subscription plan.",
  accessBlocked: "Access Blocked",
  storeExceededLimitMessage: "Your store has exceeded the plan limit for 7 days. Please upgrade to Standard Plan to continue using POS.",
  goBack: "Go Back",
  currentPlan: "Current Plan",
  subscriptionStatus: "Subscription Status",
  orderLimit: "Order Limit",
  currentUsage: "Current Usage",
  unlimited: "Unlimited",
  manageSubscriptions: "Manage Subscriptions",
  assignPlan: "Assign Plan",
  selectPlan: "Select Plan",
  updatePlan: "Update Plan",
  updating: "Updating...",
  planDetails: "Plan Details",
  manageAllSubscriptions: "Manage All Store Subscriptions",
  search: "Search stores...",
  allPlans: "All Plans",
  allStatuses: "All Statuses",
  price: "Price",
  storeAdmin: "Store Admin",
  actions: "Actions",
  manage: "Manage",
  noStoresFound: "No stores found",
  totalStores: "Total Stores",
  filteredStores: "Filtered",
  comingSoon: "Coming Soon",
  stripeIntegrationComingSoon: "Stripe integration coming soon",
  feature: "Feature",
  stripeConfiguration: "Stripe Configuration",
  stripeConfigInfo: "Configure your Stripe API keys to enable subscription management. These keys are stored securely in Firestore.",
  stripeSecretKey: "Stripe Secret Key",
  stripeSecretKeyHint: "Get your secret key from Stripe Dashboard > Developers > API keys",
  stripeWebhookSecret: "Stripe Webhook Secret",
  stripeWebhookSecretHint: "Get your webhook secret from Stripe Dashboard > Developers > Webhooks",
  webhookEndpointUrl: "Webhook Endpoint URL",
  webhookEndpointHint: "Configure this URL in Stripe Dashboard > Developers > Webhooks > Add endpoint",
  saveConfiguration: "Save Configuration",
  saving: "Saving...",
  stripeConfigSaved: "Stripe configuration saved successfully",
  onlyOwnerCanConfigure: "Only the store owner can configure Stripe settings",
  unauthorized: "Unauthorized",
  copied: "Copied",
  copiedToClipboard: "copied to clipboard",
  subscriptionManagement: "Subscription Management",
  planName: "Plan Name",
  manageSubscription: "Manage Subscription",
  manageSubscriptionInfo: "To manage your subscription (cancel, update payment method, etc.), please use the billing portal or contact support.",
  onlyOwnerCanManage: "Only the store owner can manage subscriptions",
  stripeCheckoutRequiresOnline: "Stripe checkout requires an internet connection",
  cannotDowngrade: "Cannot downgrade",
  contactSupportToDowngrade: "Please contact support to downgrade to Essential plan",
  failedToStartCheckout: "Failed to start checkout process",
  subscription: "Subscription",
  perDay: "per day",
  // Plan features
  planFeatures: "Plan Features",
  counterService: "Counter Service",
  tableService: "Table Service",
  takeawayService: "Takeaway Service",
  deliveryService: "Delivery Service",
  onlineOrders: "Online Orders",
  reservations: "Reservations",
  storeQuantity: "Store Quantity",
  dailyOrder: "Daily order limit",
  perStore: "per store",
  createdBy: "Created by",
  completedBy: "Completed by",
  monday: "Monday",
  tuesday: "Tuesday",
  wednesday: "Wednesday",
  thursday: "Thursday",
  friday: "Friday",
  saturday: "Saturday",
  sunday: "Sunday",
  morePrices: "More prices in Options",
  moreIngredients: "More ingredients in Options",
  all_: "All",
  filter: "Filter",
  expired: "Expired",
  updated: "Updated",
  limitTime: "Limit Time",
  limitDay: "Limit Day",
  outOfStock: "Out of stock",
  startFrom: "Start from",
  endAt: "End at",
  hour: "Hour",
  hours: "Hours",
  default: "Default",
  cloud: "Cloud",
  printMethod: "Print Method",
  sessionCreated: "Session created",
  orderCreated: "Order created",
  orderCompleted: "Order completed",
  event: "Event",
  eventDescription:
    "All Print button (e.g, Print Session, Print Order Slip, Print Kitchen Slip, Print Receipt) will trigger the webhook event by default. Select any additonal types of events to trigger webhooks",
  endPointDescription:
    "Enter the URL at which you wish to receive the webhooks",
  webhookDescription:
    "We will submit a POST request to this URL with a JSON object representing the event data for any events you choose to be triggered",
  testEndpointUrl: "Test Endpoint URL",
  failedToPrint: "Failed to print",
  secretKeyDescription:
    "Secret key will be used to sign with HTTP body using HMAC-SHA256 and contained in header named X-Hub-Signature",
  outGoingWebhooks: "Outgoing Webhooks",
  urlIsRequired: "URL is required",
  invalidUrl: "Invalid URL",
  endpointUrl: "Endpoint URL",
  addWebhook: "Add Webhook",
  confirmDeleteWebhook: "Confirm delete webhook?",
  printButtonClick: "Kitchen",
  takeOrderforTable: "Take order",
  addGuestNumber: "Add Guest Number",
  endSession: "End Session",
  orderNow: "Order Now",
  viewMenu: "View Menu",
  adults: "Adults",
  kids: "Kids",
  seniors: "Seniors",
  other: "Other",
  leaveWarning: "Are you sure you want to leave? Changes you made may not be saved.",
  personAtTable: "persons ordering at table",
  bePatient: "Please be patient.",
  checkMenu: "Please check the menu.",
  language: "Language",
  itemPrintName: "Name on thermal Paper",
  samePriceForAllChannels: "Same price for all channels",
  editImage: "Edit Image",
  removeImage: "Remove image",
  serviceFee: "Service Fee",
  salesReport: "Sales Report",
  chatPrint: "Send Message to staff",
  send: "Send",
  openChatPrint: "Open Chat Print",
  deleteCategory: "Delete Category",
  deleteCategoryConfirmation: "Are you sure you want to delete this category?",
  categoryName: "Category Name",
  deleteCategoryWarning: "This action cannot be undone. All items in this category must be removed or reassigned before deletion.",
  cannotDeleteCategoryWithItems: "Cannot delete category. This category contains items.",
  totalItems: "Total items",
  itemsInCategory: "Items in this category",
  pleaseRemoveItemsFirst: "Please remove or reassign these items before deleting the category.",
  deletionFailed: "Category Deletion Failed",
  categorySuccessfullyDeleted: "Successfully deleted category",
  anErrorOccurred: "An error occurred",
  categoryAll: "All",
  languageSettings: "Language Settings",
  selectLanguagePopupInfo: "Please choose the languages you want to show in the startup popup, but you need to get the language of each dish uploaded in the system.",
  languagePopupEnabled: "Enable Language Popup",
  languageChoiceActive: "Language Choice Active",
  selectLanguage: "Select Language",
  languageChoiceUpdated: "Language choice updated to",
  orderPageLanguageUpdated: "Order Page Language updated to",
  loadingSession: "Loading Session...",
  sessionInvalid: "Table is closed or is not open yet",
  loadingMenu: "Loading Menu...",
  mergeTables: "Merge Tables",
  selectTablesToMerge: "Select Tables to Merge",
  selectedTables: "Selected Tables",
  cannotRemove: "Cannot Remove",
  primaryTableRequired: "Cannot remove primary table",
  applyMerge: "Apply Merge",
  invalidTables: "Invalid Tables",
  noActiveOrders: "have no active orders",
  selectTableGroup: "Select Table Group",
  selectTables: "Select Tables",
  selectOtherTables: "Select Other Tables",
  merged: "Merged",
  bulkUpload: "Bulk upload Table",
  enterYourName: "Enter your name",
  othersOrdering: "Table is open for ordering, welcome to join!",
  nameRequired: "Name required",
  pleaseEnterName: "Please enter your name to continue",
  somethingWentWrong: "Something went wrong",
  welcomeBack: "Welcome back",
  pleaseWait: "Please wait",
  sessionCheckInProgress: "Session check in progress",
  noSuchTable: "Sorry, no such table exists!",
  waitingForStaff: "Waiting for staff to open table for you ...",
  scanQRCodeAgain: "Please scan the QR code again to order or access menu!",
  bonAppetit: "Bon Appétit!",
  modalSelectLanguage: "Select Language",
  noSessionProvided: "No session provided",
  noStoreIdInSession: "No storeId in session",
  storeNotFound: "Store not found",
  failedToLoadData: "Failed to load data",
  orderNumber: "Order #",
  orderTotal: "Order Total",
  totalWithTaxes: "Total with Taxes",
  customerName: "Name",
  totalFor: "Total for",
  noOrders: "No Orders",
  pastOrders: "Past Orders",
  closeButton: "Close",
  thisSelectionIsRequired: "This selection is required",
  pleaseSelectAtLeast: "Please select at least",
  maximumSelections: "Maximum",
  selectionsAllowed: "selections allowed",
  optionItems: "options",
  customizeYourOrder: "Customize Your Order",
  totalExtra: "Total Extra",
  cancelButton: "Cancel",
  addToCart: "Add to Cart",
  selectExactly: "You need to select exactly",
  singleItem: "item",
  selectRange: "Select",
  rangeTo: "to",
  selectAtLeast: "Select at least",
  selectUpTo: "Select up to",
  selectMultipleOptional: "Select multiple (Optional)",
  selectOneRequired: "Select one (Required)",
  requiredOption: "Required",
  sessionNotProvided: "No session provided",
  noStoreIdProvided: "No storeId in session",
  storeNotConfigured: "Store not found",

  // TableRedirect translations
  invalidStoreId: "Invalid store ID",
  tableRedirectStoreNotFound: "Store not found",
  tableRedirectError: "Something went wrong. Please try again.",
  loadingTable: "Looking up your table...",
  fixedTableQrDisabled: "Fixed table QR codes are disabled for this store.",
  contactStaffForHelp: "Please contact staff for help",

  // MEV translations
  mevMonitor: "MEV Monitor",
  mevPrinters: "Printers",
  mevSettings: "MEV Settings",
  mevLogs: "Logs",
  mevGlobalApplicationConfiguration: "Global Application Configuration",
  mevRealTimeDiagnosticStream: "Real-time Diagnostic Stream",
  mevCoreEngineStream: "Core Engine Stream",
  mevPriorityAll: "Priority: All",
  mevLive: "Live",
  mevNoSystemEvents: "No system events",
  mevWaitingForTransactions: "Waiting for transactions...",
  mevCertificate: "Certificate",
  mevOrderMonitor: "MEV Order Monitor",
  orderJobs: "Orders ({count})",
  noJobsAvailable: "No orders available. Monitoring for new orders...",
  startedMonitoring: "Started monitoring for new orders",
  viewDetails: "View Details",
  jobDetails: "Job Details",
  jobId: "Job ID",
  orderData: "Order Data",
  cloudMevClient: "Cloud MEV Client Dashboard",
  cloudMev: "Cloud MEV",
  cloudMevKicker: "Cloud fiscal operations",
  cloudMevDescription: "Cloud MEV operations for this store. Worker credentials are configured by the super admin.",
  cloudMevWorker: "Worker",
  cloudMevStatus: "Status",
  cloudMevStatusHint: "Current Cloud MEV service and enrollment for this store.",
  cloudMevCertificate: "Certificate",
  cloudMevWorkerUrl: "Worker URL",
  cloudMevWorkerSecret: "Worker secret",
  cloudMevGenerateSecret: "Generate secret",
  cloudMevCopySecret: "Copy secret",
  cloudMevSaveWorker: "Save worker",
  cloudMevWorkerSaved: "Worker settings saved",
  cloudMevPing: "Ping Worker",
  cloudMevPingOk: "Worker reachable",
  cloudMevPingFail: "Worker ping failed",
  cloudMevNotConfigured: "Not configured by super admin",
  cloudMevConfigured: "Ready",
  cloudMevServiceStatus: "Cloud service",
  cloudMevEnroll: "Enroll certificate",
  cloudMevEnrolled: "Certificate enrolled",
  cloudMevPasteSecretHint: "Paste this secret into the Cloudflare Worker dashboard as INTERNAL_SHARED_SECRET.",
  cloudMevUserId: "Identification number",
  cloudMevAuthCode: "Authorization code",
  cloudMevQstNumber: "QST number",
  cloudMevGstNumber: "GST number",
  cloudMevDossierNumber: "Dossier number",
  cloudMevActivitySubsector: "Activity subsector",
  cloudMevNickname: "Certificate nickname",
  cloudMevEnvironment: "Environment",
  cloudMevEnvSharedHint: "This environment applies to every Cloud MEV page for this store.",
  cloudMevConfirmSwitchEnvTitle: "Switch Cloud MEV environment?",
  cloudMevConfirmSwitchEnvBody:
    "All Cloud MEV pages will switch from {from} to {to}. The workstation certificate for this store will use {to} only.",
  cloudMevLastError: "Last error",
  cloudMevLastEnroll: "Last enrollment",
  cloudMevEnrollmentStatus: "Enrollment status",
  cloudMevIdApprl: "Approval ID",
  cloudMevSelectStore: "Select a store first",
  cloudMevInvalidUrl: "Enter a valid HTTPS Worker URL",
  cloudMevSecretRequired: "Generate a worker secret first",
  cloudMevFillRequired: "Fill in all required fields",
  cloudMevNicknameForm: "The workstation certificate name is Certificat A avec serveur. Another letter keeps that form, such as Certificat R avec serveur.",
  cloudMevNicknameRequired: "Enter a certificate nickname.",
  cloudMevNicknameUseNextCsr: "Generate CSR again so this nickname is used.",
  cloudMevHasSecret: "Secret is configured",
  cloudMevNoSecret: "No secret saved yet",
  cloudMevCertificateHint: "Workstation certificate for this PC. The private key stays on this workstation.",
  cloudMevCertificateEnvHint: "The workstation certificate below belongs to {env} only.",
  cloudMevAddCertHint: "If the device has not yet received this identifier or the identifier has been lost, the initial value must be \"0000-0000-0000\".",
  cloudMevNoActiveCert: "No active Cloud MEV certificate.",
  cloudMevNoCsrYet: "No CSR yet.",
  cloudMevCsrFailed: "CSR generation failed",
  cloudMevExpiry: "Expiry",
  cloudMevDayRemaining: "day remaining",
  cloudMevExpiryWarning: "Certificate reminder is active.",
  cloudMevCertReminder: "Certificate reminder",
  cloudMevCertReminderStartsInOne: "Certificate reminder starts in 1 day.",
  cloudMevCertReminderStartsIn: "Certificate reminder starts in {days} days.",
  cloudMevCertReminderActive: "Certificate reminder is active.",
  cloudMevCertReminderDays: "Days before expiration",
  cloudMevCertReminderDate: "Reminder date",
  cloudMevCertReminderExpired: "Certificate expired. Replace it.",
  cloudMevCertReminderExpiresToday: "Certificate expires today. Replace it.",
  cloudMevCertReminderReplaceOne: "Replace the certificate. It expires in 1 day.",
  cloudMevCertReminderReplace: "Replace the certificate. It expires in {days} days.",
  cloudMevCertReminderBar: "Certificate expires in {days} days. Click for details.",
  cloudMevCertReminderBarOne: "Certificate expires in 1 day. Click for details.",
  cloudMevCertReminderBarToday: "Certificate expires today. Click for details.",
  cloudMevCertReminderBarExpired: "Certificate expired. Click for details.",
  cloudMevCertReminderAdmin: "Inform your administration to replace this certificate.",
  cloudMevCertReminderDesktop: "Certificate replacement is done in this software, not on the web.",
  cloudMevCertificateDetails: "Certificate details",
  cloudMevNoLastError: "None",
  cloudMevUsers: "MEV users",
  cloudMevTerminals: "Terminals",
  cloudMevTerminalName: "Terminal name",
  cloudMevAddTerminal: "Add terminal",
  cloudMevPrimaryTerminal: "Primary Cloud MEV device",
  cloudMevDeleteTerminal: "Delete terminal?",
  cloudMevDeleteTerminalMessage: "Remove this terminal record from Cloud MEV?",
  cloudMevUserReportHint: "Build the yearly RUT document and send it through the cloud certificate.",
  cloudMevGeneralReport: "User report",
  cloudMevGeneralReportHint: "Choose all users or one user. Generating sends the report to WEB-SRM.",
  cloudMevUserChoiceHint: "Choose all users or one user. Generating sends the report to WEB-SRM.",
  cloudMevCurrentReport: "Your user report",
  cloudMevCurrentReportHint: "This report is for the person signed in on this workstation. Generating it sends the report to WEB-SRM.",
  historyRailHint: "Bills, the user report, and the system log for this workstation.",
  cloudMevGenerateAndSend: "Generate and send",
  cloudMevReportSentWithGenerate: "Your report was sent to WEB-SRM.",
  cloudMevReportHistory: "Report history",
  cloudMevReportHistoryEmpty: "No report has been generated yet.",
  cloudMevReportHistoryLoading: "Loading.",
  cloudMevReportDocumentNumber: "Revenu Québec document number",
  cloudMevReportView: "View",
  cloudMevReportNotStored: "This report was not saved. Generate it again.",
  cloudMevReportOffline: "The user report is available when this workstation is online.",
  cloudMevReportRemove: "Remove",
  cloudMevReportRemoveTitle: "Remove this report record?",
  cloudMevReportRemoveMessage: "The report can be generated again.",
  cloudMevReportDenied: "A manager, the operator, or a user registered with WEB-SRM can generate the report for every user.",
  cloudMevReportSignIn: "Sign in on this workstation to generate your report.",
  cloudMevGenerateReport: "Generate report",
  cloudMevSubmitReport: "Submit to WEB-SRM",
  cloudMevReportGenerated: "User report generated",
  cloudMevReportSubmitted: "User report submitted",
  cloudMevGenerateReportFirst: "Generate the report first",
  cloudMevConfirmReport: "Submit user report?",
  cloudMevConfirmReportMessage: "Submit this user report to WEB-SRM?",
  cloudMevReportScope: "Scope",
  cloudMevSingleUser: "Current user",
  cloudMevAllUsers: "All users",
  cloudMevOrdersIncluded: "Orders included",
  cloudMevLogsHint: "Cloud MEV operations for this store and environment.",
  cloudMevNoLogs: "No Cloud MEV operations yet.",
  cloudMevJsonOverlayTitle: "Cloud MEV response",
  cloudMevJsonOverlaySending: "Sending Cloud MEV transaction…",
  cloudMevJsonOverlayClose: "Close",
  cloudMevJsonOverlayHeaders: "Headers",
  cloudMevJsonOverlayRequest: "Request sent",
  cloudMevJsonOverlayResponse: "Response received",
  cloudMevJsonOverlayError: "Cloud MEV error",
  cloudMevDebug: "Debug",
  cloudMevDebugHint: "Payloads sent to Revenu Québec (Up) and received back (Down) for this store and environment.",
  cloudMevDebugUp: "Up — sent to Revenu Québec",
  cloudMevDebugDown: "Down — received from Revenu Québec",
  cloudMevNoDebug: "No Revenu Québec exchanges recorded yet.",
  cloudMevServerResponse: "Server response",
  cloudMevNoServerResponse: "No response yet.",
  cloudMevWorking: "Working… please wait",
  cloudMevWorkingCsr: "Generating CSR…",
  cloudMevWorkstationCsrFailed: "Could not create the workstation certificate request.",
  cloudMevWorkstationCngRequired: "Windows CNG is required to save the workstation key.",
  cloudMevWorkstationKeySaveFailed: "Could not save the workstation key.",
  cloudMevWorkstationRequestFirst: "Generate the workstation certificate request on this PC first.",
  cloudMevWorkstationKeyMissing: "The workstation private key was not found.",
  cloudMevWorkstationRejected: "Revenu Québec rejected the workstation certificate.",
  cloudMevWindowsStoreRejected: "Windows certificate store rejected the certificate.",
  cloudMevWorkingEnroll: "Sending certificate request…",
  cloudMevWorkingRequest: "Sending request…",
  cloudMevCsrBadOrganization:
    "This CSR has Organization Restaurant-…. Revenu Québec requires RBC-<auth code>. Redeploy the mev-csr Worker, generate a new CSR, then add the certificate.",
  cloudMevActiveCertHint: "Currently installed MEV certificate",
  cloudMevDeviceId: "Device ID (IDAPPRL)",
  cloudMevExpirationDate: "Expiration Date",
  cloudMevCertificateContent: "Certificate Content",
  cloudMevNotAssigned: "Not Assigned",
  cloudMevInstallCertHint: "Install a certificate using the CSR generation and Addition tabs.",
  cloudMevValid: "Valid",
  cloudMevRemaining: "remaining",
  cloudMevCsrUsedAt: "This CSR has been used at {time}. It cannot be used again.",
  cloudMevCsrAlreadyUsed: "This CSR has already been used to generate a certificate. Generate a new CSR.",
  cloudMevHowTo: "How to",
  mevPathEnableTitle: "Turn on {name}?",
  mevPathDisableTitle: "Turn off {name}?",
  mevPathEnableBody: "POS orders can use {name} after you confirm.",
  mevPathDisableBody: "POS orders will stop using {name} until you turn it back on.",
  mevPrintersDesktopHint:
    "Physical printers use the desktop MEV client. Open this page in the desktop app to add and manage printers.",
  cloudMevHowToTitle: "First-time Cloud MEV setup",
  cloudMevHowToIntro:
    "This guide walks you through creating a certificate signing request (CSR), installing the Revenu Québec certificate, and adding an MEV user so the store can start sending transactions.",
  cloudMevHowToBeforeTitle: "Before you start",
  cloudMevHowToBeforeBody:
    "Open Cloud MEV and choose the environment at the top right. Use DEV or ESSAI to practice. Use PROD only when you are ready to enroll with Revenu Québec.",
  cloudMevHowToOverview: "What you will do",
  cloudMevHowToOverview1: "Save business information",
  cloudMevHowToOverview2: "Generate a CSR and add the first certificate",
  cloudMevHowToOverview3: "Record the device ID",
  cloudMevHowToOverview4: "Add an MEV user",
  cloudMevHowToOpenStep: "Open this step",
  cloudMevHowToStep1Title: "Business information",
  cloudMevHowToStep1Body:
    "On the Certificate page, open Business. Enter the legal name, address, city, province, postal code, and phone. In production these fields are required before Revenu Québec will accept the certificate.",
  cloudMevHowToStep1Action: "Click Save when the form is complete.",
  cloudMevHowToStep2Title: "Create the CSR and add the certificate",
  cloudMevHowToStep2Body:
    "Open Create CSR. Fill in the identification number, authorization code, QST, GST, dossier number, activity subsector, timezone, and certificate nickname.",
  cloudMevHowToStep2Generate:
    "Click Generate CSR. When the request succeeds, the PEM text appears on the right.",
  cloudMevHowToStep2Add:
    "For a first-time setup, click Use for Addition, then open Add Certificate and submit. Do not use Replace on a new store.",
  cloudMevHowToStep2Success:
    "A successful add returns an enrolled certificate. That CSR cannot be reused. Generate a new CSR if you need another certificate later.",
  cloudMevHowToStep2Caption: "Create CSR: generate the request, then choose Use for Addition the first time.",
  cloudMevHowToStep3Title: "Guard the device ID",
  cloudMevHowToStep3Body:
    "After the first certificate is added, the system issues a unique device ID (IDAPPRL) for this MEV. Open Active Cert to see it.",
  cloudMevHowToStep3Warn:
    "This device ID is created once and cannot be changed for the life of the device. Write it down and keep it safe. Do not try to replace it, and do not enroll a second first-time addition on the same store.",
  cloudMevHowToStep4Title: "Add a user",
  cloudMevHowToStep4Body:
    "Open Certify User. Enter the name and the GST/QST numbers, then submit. You need at least one certified person before you can operate.",
  cloudMevHowToReadyTitle: "You are ready",
  cloudMevHowToReadyBody:
    "With an active certificate, a device ID, and a certified person, this store can send Cloud MEV transactions.",
  cloudMevHowToLaterTitle: "Later operations",
  cloudMevHowToDeleteUserTitle: "Delete Certify User",
  cloudMevHowToDeleteUserBody:
    "Open Delete Certify User, choose the person, and confirm. The flow is the same as Certify User, in reverse.",
  cloudMevHowToReplaceTitle: "Replace an expired certificate",
  cloudMevHowToReplaceBody:
    "Revenu Québec certificates are typically valid for five years. When yours expires, generate a new CSR, click Use for Replacement, then open Replace Certificate and submit. The new certificate uses the same device ID.",
  cloudMevHowToReplaceNote:
    "Never click Use for Addition to renew. Addition is only for the first certificate on a new device.",
  confirmSignOut: "Confirm Sign Out",
  signOutMessage: "Print jobs will be missed when signed out",
  signIn: "Sign In",
  loginRequired: "Login required",
  connected: "Connected and ready to receive orders from cloud",
  disconnected: "Disconnected, please sign in",
  status: "Status",
  created: "Created",
  processed: "Processed",
  pending: "Pending",
  processing: "Processing",
  completed: "Completed",
  failed: "Failed",
  environment: "Environment",
  business: "Business",
  activeCert: "Active Cert",
  createCSR: "Create CSR",
  generateCSR: "Generate CSR",
  addCert: "Add Certificate",
  add_certificate: "Add Certificate",
  replaceCert: "Replace Certificate",
  replace_certificate: "Replace Certificate",
  deleteCert: "Delete Certificate",
  delete_certificate: "Delete Certificate",
  addUser: "Add User",
  deleteUser: "Delete User",
  certifyUser: "Certify User",
  deleteCertifyUser: "Delete Certify User",
  businessInformation: "Business Information",
  companyName: "Company Name",
  contactInformation: "Contact Information",
  addressInformation: "Address Information",
  addressLine1: "Address Line 1",
  addressLine2: "Address Line 2",
  province: "Province",
  printerName: "Printer Name",
  apiKey: "API Key",
  printerType: "Printer Type",
  commandLanguage: "Print command",
  printerTypeNetwork: "Network",
  printerTypeWindowsShared: "Windows shared",
  printingType: "Printing type",
  printCommandCheck: "Print command check",
  printCommandSwitchHelp: "Print a test slip. Confirm it is readable before this print command is saved. Next print will use {command}.",
  printTestSlip: "Print test slip",
  printCommandPaused: "Live printing for this printer is paused.",
  printCommandThisComputer: "This computer",
  printCommandComputerReady: "This computer is ready",
  printCommandComputerNotReady: "This computer is not ready",
  printCommandStoreCopy: "Store copy on this computer",
  printCommandChecking: "Checking",
  printCommandSaved: "Saved",
  printCommandMismatch: "Does not match",
  printCommandNextJob: "Next print will use {command}.",
  testSlipReadable: "The test slip is readable",
  testSlipNotReadable: "The test slip is not readable",
  printCommandUpdated: "Print command updated.",
  printCommandNotConfirmed: "The test slip was not confirmed. The previous print command stays in place.",
  starLine: "Star Line",
  starGraphic: "Star Graphic",
  starPrnt: "StarPRNT",
  starImpact: "Star Impact",
  starSeries: "Star series",
  printCommandDependsOnConfiguration: "The protocol depends on the printer configuration. The test slip confirms it.",
  escposEmulation: "ESC/POS emulation",
  escposEmulationHelp: "Leave this unchecked unless this printer is set to ESC/POS emulation. If it is not set, the receipt will not print correctly.",
  numCopies: "Number of Copies",
  networkPrinterAddress: "Network Printer Address",
  networkPrinterPort: "Network Printer Port",
  windowsSharedPrinterName: "Windows Shared Printer Name",
  printerModelNumber: "Model number",
  printerModelNumberHelp: "Optional. For your reference.",
  printerLocation: "Location",
  printerLocationHelp: "Optional. Where this printer is placed.",
  addPrinter: "Add Printer",
  editPrinter: "Edit Printer",
  edit_printer: "Edit Printer",
  add_printer: "Add Printer",
  printer_name: "Printer Name",
  api_key: "API Key",
  num_copies: "Number of Copies",
  printer_type: "Printer Type",
  network_printer_address: "Network Printer Address",
  network_printer_port: "Network Printer Port",
  windows_shared_printer_name: "Windows Shared Printer Name",
  test_printer: "Test Printer",
  print_qr_receipt: "Print QR Receipt",
  save_changes: "Save Changes",
  receipt_image_settings: "MEV receipt image settings",
  receipt_text_settings: "MEV receipt text settings",
  receipt_text_enabled: "Print on receipt",
  open_at_os_startup: "Open at OS Startup",
  openAtOsStartupHelp: "The application opens when the computer starts.",
  print_merchant_copy: "Print Merchant Copy with Temporary Bill",
  print_merchant_copy_temporary: "Print Merchant Copy with Temporary Bill",
  print_merchant_copy_closing: "Print Merchant Copy with Closing Receipt",
  merchant_copy_font_size_increase: "Increase font size by",
  no_increase: "No increase",
  receipt_content_shift: "Receipt Content Shift (Negative to left)",
  receipt_content_shift_range: "(-20 to 20)",
  api_wait_time: "MEV API Wait Time",
  api_wait_time_description: "Maximum wait time for communication with WEB-SRM (minimum 5 seconds)",
  save_receipt_as_image: "Save Receipt as Image",
  save_location: "Save Location",
  enter_folder_path: "Enter folder path",
  chooseFolderPath: "Choose a folder",
  receiptImageMaxHint: "Keeps the 100 newest receipt images. Older images are deleted automatically so the folder does not fill the disk.",
  receiptImageFolderDesktopHint: "Open this page in the desktop app to choose a Windows folder.",
  scrollPageUp: "Page up",
  scrollPageDown: "Page down",
  scrollToTopHint: "Tap to page up. Hold to jump to top.",
  scrollToBottomHint: "Tap to page down. Hold to jump to bottom.",
  receipt_text_top: "Receipt Text Top (max 100 characters)",
  receipt_text_bottom: "Receipt Text Bottom (max 100 characters)",
  receipt_text_french_notice: "Receipts issued in Québec must be in French, including the tax wording. Custom text on this card is not sent to WEB-SRM.",
  receipt_text_compliance_title: "Compliance Notice – Charter of the French Language",
  receipt_text_compliance_body: "Under Articles 57, 89, and 91 of the Charter of the French Language and Revenu Québec mandatory billing rules, all receipts generated in Québec must be drafted in French. Any custom text added to receipt footers remains the sole legal and regulatory responsibility of the business operator.\n\nIf you choose to add custom or non-French text to your receipt footer, you acknowledge and agree that your business assumes full liability for any government fines, legal penalties, or regulatory consequences resulting from non-compliance.",
  receipt_text_compliance_consent: "I have read the notice, confirm that my receipt text complies with Québec language regulations, and agree to assume sole legal responsibility.",
  receipt_text_agree_save: "Agree",
  receipt_text_not_french: "This text does not include French characters. Are you sure you want to save it?",
  receipt_text_save_anyway: "Save anyway",
  enter_top_text: "Bienvenue chez",
  enter_bottom_text: "Merci, journée",
  last_edited: "Last edited",
  total_logs: "Total Logs: {count} entries",
  system_logs: "System Logs",
  print_jobs_live_logs: "Jobs Live Logs",
  removePrinter: "Remove Printer",
  printers: "Printers",
  printerOffline: "Printer offline",
  systemDeviceManagement: "System device management",
  printerVirtualName: "Virtual printer",
  printerApiKeyTail: "API key",
  printerStatusOnline: "Online",
  enableDisablePrinter: "Enable/Disable",
  printerPrintingOff: "Turned off",
  printerTurnOffPrinting: "Turn off printing",
  printerTurnedOffHelp: "The printer can stay online. Turned off stops printing.",
  printerNoTicket: "Please select a virtual printer. Otherwise, no ticket will be printed on this printer.",
  createVirtualPrinter: "Create a virtual printer",
  printersInfoQMev: "What is the Cloud MEV printer?",
  printersInfoAMev: "The Cloud MEV printer is a required virtual printer. It prints the customer receipt and the merchant receipt. The customer receipt includes the QR code and the Revenu Québec information. The customer verifies the receipt by scanning the QR code.",
  printersInfoAMevLimits: "Some of its settings can be changed. It cannot be deleted.",
  printersInfoQKitchen: "What is Kitchen All?",
  printersInfoAKitchen: "Kitchen All is the required virtual printer for the kitchen. Its dish list stays fully selected, so every kitchen dish prints on it. A dish added later is assigned to this virtual printer automatically.",
  printersInfoAKitchenLimits: "Some settings can be changed, including the cut behavior. It cannot be renamed or deleted.",
  printersInfoQSplit: "What is a virtual printer? Why do I need it?",
  printersInfoASplit: "Split printing sends kitchen dishes to different printers.",
  printersInfoAVirtual: "A virtual printer is required. It groups the dishes that print together. Assign those dishes to the virtual printer, and set the cut behavior for that group.",
  printersInfoAssign: "A dish that is not assigned to a virtual printer is not printed.",
  itemPrinterAssignWarning: "Make sure to assign this dish to a virtual printer in Settings, under Print, in Printers List.",
  printersInfoQExample: "I have three workstations: Vegetable, Meat, and Bar. Each workstation has its own printer. How do I set up split printing?",
  printersInfoExampleStep1: "Create three virtual printers, one for each workstation, and assign the corresponding dishes to each virtual printer.",
  printersInfoExampleStep2: "Go to Printers, create a printer, and assign the corresponding virtual printer to the physical printer.",
  printersInfoExampleStep3: "When a new vegetable, meat, liquor, or wine item is added to the menu, assign it to the virtual printer so it is printed.",
  printerStatusOffline: "Offline",
  printerQrEnabled: "QR Enabled",
  addPrinterButton: "Add Printer",
  findPrinters: "Find printers",
  printerDiscovery: "Discovery",
  findPrintersHint: "Search this computer and the local network, then add the printers you want.",
  findPrintersScan: "Scan",
  findPrintersStopScan: "Stop scan",
  findPrintersLastScan: "Last scan",
  findPrintersNeverScanned: "No scan yet. Click Scan when you want to search.",
  findPrintersAddSelected: "Add selected",
  findPrintersCheckIp: "Check IP",
  findPrintersEmpty: "No printers found yet. Scan again or add one by IP.",
  findPrintersSelectOne: "Select at least one printer to add.",
  findPrintersAddedTitle: "Printers added",
  findPrintersAddedBody: "Selected printers were added to the printer list. You can edit them later.",
  findPrintersAlreadyAddedTitle: "This printer has been added already",
  findPrintersAlreadyAddedBody: "This printer is already in your list. The same printer can be used for different purposes. Do you want to add it one more time?",
  findPrintersAlreadyAddedManyBody: "One or more selected printers are already in your list. The same printer can be used for different purposes. Do you want to add them one more time?",
  findPrintersDesktopHint: "Open this page in the desktop app to search for printers on this computer and the local network.",
  addPrinterByIp: "Add printer by IP address",
  addPrinterManually: "Enter manually",
  printerNotFoundTitle: "Printer not found",
  printerNotFoundBody: "We could not find this printer. You can still add it later after you turn it on.",
  printerStatusReady: "Ready",
  printerStatusError: "Error",
  printerStatusUnreachable: "Unreachable",
  printerStatusUnknown: "Unknown",
  noPrintersFound: "No printers found. Click 'Add Printer' to get started.",
  deletePrinterTitle: "Delete printer",
  deletePrinterConfirm: "Are you sure you want to delete this printer?",
  mevDefaultPrinterName: "MEV printer",
  mevCustomerReceiptEntry: "MEV customer receipt",
  mevPrinterNotConfigured: "Not configured",
  mevPrinterReservedApiKey: "This printer is reserved for MEV receipts.",
  mevSetWindowsSharedPrinterName: "Set your Windows shared printer name",
  mevWindowsSharedPrinterHint: "Enter the Windows shared printer name so this MEV printer can print.",
  mevVirtualPrinterFromSettings: "Virtual Printer (from Settings)",
  mevSelectVirtualPrinter: "-- Select Virtual Printer --",
  mevNoVirtualPrinters: "No virtual printers in Settings",
  proceed: "Proceed",
  success: "Success",
  confirmCertificateAddition: "Confirm Certificate Addition",
  confirmCertificateAdditionMessage: "You are about to add a new certificate. Are you sure you want to proceed?",
  confirmCertificateDeletion: "Confirm Certificate Deletion",
  confirmCertificateDeletionMessage: "You are about to delete certificate with serial number {serialNumber}. Are you sure you want to proceed?",
  confirmUserAddition: "Confirm Certify User",
  confirmUserAdditionMessage: "You are about to certify this person. Are you sure you want to proceed?",
  confirmUserDeletion: "Confirm Delete Certify User",
  confirmUserDeletionMessage: "You are about to remove this certification. Are you sure you want to proceed?",
  mevTypeDelete: "Type delete",
  mevUserAdded: "Added",
  certificateDeletedSuccess: "Certificate has been successfully deleted.",
  userAddedSuccess: "User has been successfully added.",
  userDeletedSuccess: "User has been successfully deleted.",
  logs: "Logs",
  userReport: "User Report",
  identification_number: "Identification number",
  authorization_code: "Authorization code",
  qst_number: "QST number",
  gst_number: "GST number",
  dossier_number: "Dossier number",
  certificate: "Certificate",
  requiredFieldsMissing: "Required Fields Missing",
  fillRequiredFields: "Please fill in all required fields: {fields}",
  saveModifications: "Save Modifications",
  saveChanges: "Save Changes",
  mevCustomerReceiptInfo: "Use 'MEV-CUSTOMER-RECEIPT' as API key for MEV receipts",
  submit: "Submit",
  testPrinter: "Test Printer",
  printTestSent: "Test print sent successfully",
  printTestFailed: "Test print failed: {error}",
  printQrReceipt: "Print QR Receipt",
  enterBottomText: "Enter text to appear at the bottom of receipts",
  enterFolderPath: "Enter folder path",
  enterTopText: "Enter text to appear at the top of receipts",
  lastEdited: "Last Edited",
  merchantCopyFontSizeIncrease: "Merchant Copy Font Size Increase",
  noIncrease: "No Increase",
  openAtOsStartup: "Open at OS Startup",
  printJobsLiveLogs: "Print Jobs Live Logs",
  printMerchantCopy: "Print Merchant Copy",
  receiptContentShift: "Receipt Content Shift",
  receiptContentShiftRange: "Adjust horizontal position (-50 to 50 pixels)",
  receiptImageSettings: "Receipt Image Settings",
  receiptTextBottom: "Receipt Text Bottom",
  receiptTextSettings: "Receipt Text Settings",
  receiptTextTop: "Receipt Text Top",
  save: "Save",
  saveLocation: "Save Location",
  saveReceiptAsImage: "Save Receipt as Image",
  systemLogs: "System Logs",
  logViewerSubtitle: "Staff actions and WEB-SRM responses",
  logFiles: "Log Files",
  logDay: "Day",
  bothLogs: "POS and WEB-SRM",
  posLog: "POS log",
  logReceiptEmailedTo: "Receipt emailed to",
  logReceiptEmailed: "Receipt emailed",
  logReceiptEmailQueuedFor: "Receipt email queued for",
  logReceiptEmailQueued: "Receipt email queued",
  logReceiptEmailNotDeliveredTo: "Receipt email not delivered to",
  logReceiptEmailNotDelivered: "Receipt email not delivered",
  logReceiptEmailSkippedFor: "Receipt email skipped for",
  logReceiptEmailSkipped: "Receipt email skipped",
  logReceiptAlreadySent: "already sent",
  apiLog: "WEB-SRM log",
  noApiLogForDay: "No WEB-SRM log for this day.",
  fastFilters: "Fast Filters",
  allEvents: "ALL EVENTS",
  searchLogs: "Search in log content...",
  noLogsInFile: "No logs for this day.",
  eventTime: "TIME",
  eventType: "TYPE",
  eventDescription: "EVENT DESCRIPTION",
  copyDay: "Copy day",
  dayCopied: "Copied to the clipboard",
  copyFailed: "The records could not be copied.",
  nothingToCopy: "No records are available for this day.",
  backupYourLog: "Export logs",
  backupFrom: "From",
  backupTo: "To",
  backupRange: "Select a period of 30 days or less.",
  backupTooWide: "The period cannot exceed 30 days. Export additional periods separately.",
  backupTooLarge: "The export exceeds the time limit. Select a shorter period.",
  backupEmpty: "No records were found for the selected period.",
  backupReady: "The export file is located in",
  backupFailed: "The export could not be completed.",
  deleteOldLogs: "Remove logs",
  deleteOldLogsTitle: "Remove logs?",
  deleteOldLogsMessage: "Only logs older than six years can be removed.",
  oldLogsDeleted: "Records older than six years have been removed.",
  noOldLogs: "No records older than six years were found.",
  deleteOldFailed: "The removal could not be completed.",
  failedToListLogs: "Failed to list log files",
  failedToReadLog: "Failed to read the log file",
  totalLogs: "Total Logs: {count}",
  requiredField: "Required field",
  confirmCsrGeneration: "Confirm CSR Generation",
  confirmCsrGenerationMessage: "You are about to generate a new Certificate Signing Request (CSR). This operation may overwrite any existing pending CSR. Are you sure you want to proceed?",
  useInAddition: "Use for adding certificate",
  useInReplacement: "Use for replacing certificate",
  copyToClipboard: "Copy to Clipboard",
  copied: "Copied",
  certificate_details: "Certificate Details",
  certificate_text: "Certificate Text",
  expiry: "Expiry",
  serial: "Serial",
  idapprl: "IDAPPRL",
  noActiveCertificate: "No active certificate found. Please add a certificate first.",
  expired: "Expired",
  posDashboard: "POS Dashboard",
  quickAccessToPosFunctions: "Quick access to all POS functions",
  quickAccessProducts: "Quick access products",
  pinSearchRow: "Pin search",
  unpinSearchRow: "Unpin search",
  pinMenu: "Pin menu",
  unpinMenu: "Unpin menu",
  pinPaymentMethod: "Pin payment method",
  unpinPaymentMethod: "Unpin payment method",
  pinCategory: "Pin category",
  unpinCategory: "Unpin category",
  quebecAlcoholTax: "Quebec alcohol tax",
  backToDashboard: "Back to Dashboard",
  dashboardPage: "Dashboard page",
  categories: "Categories",
  products: "Products",
  tables: "Tables",
  kds: "KDS",
  transactions: "Transactions",
  delivery: "Delivery",
  browseByCategory: "Browse by category",
  browseByCategoryCounterService: "Browse by category/Counter Service",
  quickSaleTakeaway: "Quick Sale / Takeaway",
  counterServiceQuickSales: "Counter Service / Quick Service",
  savedCart: "Parked Tickets",
  savedCartDescription: "View and manage parked counter tickets",
  parkedTickets: "Parked Tickets",
  parkedTicketsDescription: "View and manage parked counter tickets",
  parked: "Parked",
  parkedPrintedOrder: "Tickets In Process",
  noParkedPrintedOrders: "No orders in process",
  sortByOrderNumber: "Sort by order number",
  ticketsInProgress: "TIP",
  ticketsInProgressFull: "Tickets in progress",
  ticketsInProgressDescription: "Counter orders",
  newOrder: "New order",
  sortByNumber: "Sort by number",
  tipItems: "Items",
  tipRefunded: "Refunded",
  tipPaymentChanged: "Payment method changed",
  tipReprints: "Reprints",
  reprintKitchenReceipt: "Reprint kitchen receipt",
  reprintKitchenSent: "Kitchen receipt sent",
  reprintKitchenPrinted: "Printed",
  reprintKitchenNone: "No kitchen is set up for these items",
  reprintKitchenFailed: "Kitchen receipt was not sent",
  tipService: "Service",
  tipInProcess: "In Process",
  tipCanceled: "Canceled",
  tipTemporaryBillPrinted: "Temporary bill printed",
  tipCancellationReceipt: "Cancellation receipt",
  tipCanceledNoNumber: "No number",
  noCanceledTickets: "No canceled tickets",
  tipNewPhoneOrder: "New phone order",
  tipDispatch: "Dispatch",
  tipAsap: "ASAP",
  tipDueSoon: "Due soon",
  tipLate: "Late",
  tipLocalDelivery: "Local delivery",
  tipPhoneOrder: "Phone order",
  tipDeliveryFee: "Delivery fee",
  tipDistance: "Distance",
  tipNote: "Note",
  tipAddress: "Address",
  tipStatusReady: "Ready",
  tipStatusOnRoute: "On route",
  tipStatusComplete: "Complete",
  tipStatusCanceled: "Cancelled",
  tipStatusConfirmed: "Confirmed",
  takeawayStartTitle: "New takeaway order",
  takeawayStartHint: "Choose the order type.",
  takeawayThisOrder: "This order",
  takeawayDefaultLabel: "Default",
  takeawaySetDefault: "Default option",
  takeawayDefaultHint: "Used the next time this screen opens.",
  phoneOrderInformationRequired: "Phone order information required",
  customerInfoRequiredMessage: "The following information is required before this ticket can continue.",
  customerInfoComplete: "Customer information complete",
  customerInfoCompleteMessage: "All required information is present. Continue with the previous action.",
  customerFieldPresent: "Entered",
  customerFieldMissing: "Missing",
  enterCustomerInfo: "Enter customer information",
  postalCode: "Postal code",
  parkTicket: "Park ticket",
  parkTicketTitle: "Park this ticket?",
  parkTicketLeaveMessage: "This ticket has items. Park it for later or discard it.",
  parkTicketLeaveMessageTakeaway: "This ticket contains items. Park it in TIP (Takeaway), discard it, or remain on this screen.",
  parkTicketLeaveMessageDelivery: "This ticket contains items. Park it in TIP (Delivery), discard it, or remain on this screen.",
  parkOnTakeaway: "Park ticket",
  parkOnDelivery: "Park ticket",
  ticketParked: "Ticket parked",
  orderSavedToTip: "The order has been saved to TIP. You can find it in TIP.",
  parkChoiceTitle: "Park",
  parkChoiceHint: "Choose the next step.",
  parkGoToTip: "Go to TIP",
  stayHere: "Stay here",
  openTicketsInProgress: "Open Tickets in progress",
  seatAtTable: "Seat at a table",
  seatHere: "Seat here",
  freeSeats: "{free} free",
  partyNeedsSeats: "This party needs {party} seats.",
  saleKeepsNumber: "This sale keeps {number}.",
  saleStartsAtTable: "This sale starts at the table.",
  noTableWithSeats: "No table has enough free seats.",
  seatedAtTable: "Seated at the table",
  ticketParkedMessage: "The ticket is parked and waiting.",
  ticketParkedOnTakeaway: "The ticket is parked in TIP (Takeaway).",
  ticketParkedOnDelivery: "The ticket is parked in TIP (Delivery).",
  errorParkingTicket: "Failed to park ticket",
  discardTicket: "Discard",
  draftTicket: "Draft",
  stay: "Stay",
  noSavedCarts: "No parked tickets found",
  noSavedCartsDescription: "Parked counter tickets will appear here",
  savedAt: "Parked",
  openCart: "Open ticket",
  confirmDeleteCart: "Are you sure you want to discard this ticket?",
  deleteSavedCart: "Discard ticket",
  areYouSureDeleteCart: "Are you sure you want to discard {name}?",
  pluralSuffix: "s",
  cartSaved: "Ticket parked",
  cartSavedMessage: "Ticket parked.",
  errorSavingCart: "Failed to park ticket",
  pleaseAddItemBeforeSave: "Please add an item before parking",
  errorCreatingNewSession: "Failed to create new counter session",
  skipCheckoutModalForCounterService: "Skip Checkout Modal for Counter Service",
  skipCheckoutModalForCounterServiceDescription: "When enabled, Counter Service orders will skip the checkout modal and go directly to payment.",
  skipCheckoutModalUpdated: "Skip Checkout Modal setting updated",
  errorUpdatingSetting: "Failed to update setting",
  tableLayoutManagement: "Table Live Order Management.",
  kitchenDisplaySystem: "Kitchen Display System",
  kitchenPoweredBy: "Powered by NuagePOS Eagle",
  kdsUserSettings: "KDS",
  kdsNetworkAddress: "KDS address",
  kdsNetworkAddressPending: "Looking for this computer's network address...",
  voiceAnnouncement: "Voice",
  voiceAnnouncementHelp: "Turn voice on, choose the voices, then attach them to an event and a speaker.",
  voiceAnnouncementEnabled: "Enable voice",
  voiceAnnouncementLanguage: "Language",
  voiceLanguageEnglish: "English",
  voiceLanguageFrench: "French",
  voiceLanguageChinese: "Chinese",
  voiceAnnouncementVoice: "Voice",
  voiceAnnouncementSpeed: "Speed",
  voiceAnnouncementVolume: "Volume",
  voiceAnnouncementTest: "Test Voice",
  voiceAnnouncementTesting: "Playing...",
  voiceAnnouncementSave: "Save",
  voiceAnnouncementSaved: "Voice announcement saved",
  voiceAnnouncementSaveFailed: "Failed to save voice announcement",
  voiceAnnouncementDeviceVoice: "Played with this device's voice",
  voiceAnnouncementDeviceVoiceHelp: "Google Text-to-Speech was unavailable, so the computer spoke the sample.",
  voiceAnnouncementTestFailed: "Voice test failed",
  voiceLanguageTurnOn: "Turn on",
  voiceGenderFemale: "Female",
  voiceGenderMale: "Male",
  voiceRegionEnUS: "American English",
  voiceRegionEnCA: "Canadian English",
  voiceRegionEnGB: "British English",
  voiceRegionEnAU: "Australian English",
  voiceRegionEnIN: "Indian English",
  voiceRegionFrCA: "Canadian French",
  voiceRegionFrFR: "European French",
  voiceRegionCmnCN: "Mandarin",
  voiceRegionCmnTW: "Taiwan Mandarin",
  voiceRegionYueHK: "Cantonese",
  voiceLibraryTab: "Voice library",
  voiceEventsTab: "Events",
  voiceDestinationsTab: "Destinations",
  voiceLibraryHelp: "Each row is a voice you can reuse. Speed and volume are saved with that voice.",
  voiceAddProfile: "Add voice",
  voiceProfileName: "Name",
  voiceProfileOff: "off",
  voiceDeleteProfileTitle: "Delete this voice?",
  voiceDeleteProfileConfirm: "Events that use this voice will stop announcing it.",
  voiceEventOrderCreated: "New Order Created",
  voiceEventsHelp: "Attach voices and KDS splitters to each event. A voice speaks when it is turned on in the library and checked here. The announcement plays on the kitchen screen where that KDS user is signed in.",
  voiceEventVoices: "Voices",
  voiceEventDestinations: "Destinations",
  voiceNoProfiles: "Add a voice in the library first.",
  voiceDestinationsHelp: "This computer plays on its own speakers so you can test. Each KDS splitter plays on the kitchen screen where that user is signed in, after they tap Enable Audio.",
  voiceThisComputer: "This computer",
  voiceThisComputerHelp: "This computer's speakers. Leave this on to test a new order here.",
  voiceNoSplitters: "Create a splitter for a KDS user first.",
  voiceEnableAudio: "Enable Audio",
  voiceAudioOn: "Audio on",
  voiceThisScreenHelp: "Every open POS or KDS page speaks when this destination is checked on an event.",
  voiceAddKds: "Add kitchen screen",
  voiceAddNetwork: "Add network speaker",
  voiceEndpoint: "Speaker address",
  voiceNetworkHelp: "Saved for a local bridge on the POS computer. This browser does not play this destination.",
  voiceThisDevice: "This device",
  voiceThisDeviceNone: "Not a kitchen screen",
  voiceThisDeviceHelp: "On a kitchen tablet, choose the screen name. That choice stays on this device.",
  voiceUnlock: "Enable sound on this screen",
  voiceUnlockHelp: "Tap this once on this computer so the browser can play the test.",
  voiceUnlocked: "Sound is enabled on this screen",
  voiceDestinationTypeScreen: "This screen",
  voiceDestinationTypeKds: "Kitchen screen",
  voiceDestinationTypeNetwork: "Network speaker",
  voiceDeleteDestinationTitle: "Delete this destination?",
  voiceDeleteDestinationConfirm: "Events that use this destination will stop using it.",
  kdsSplittingTab: "Splitting",
  kdsGroupingTab: "Grouping",
  kdsGroupingHelp: "Each rule has its own switch. Turn one on, or turn both on. The note below matches the switches you choose.",
  kdsGroupingTimeOn: "On. The clock will combine identical dishes when the time window ends.",
  kdsGroupingTimeOff: "Off. The clock will not combine tickets.",
  kdsGroupingCountOn: "On. Identical dishes combine after the order count is reached.",
  kdsGroupingCountOff: "Off. The order count will not combine tickets.",
  kdsGroupingOffTitle: "Both rules are off",
  kdsGroupingOffBody: "Tickets stay separate. Turn on Time interval, Order count, or both.",
  kdsGroupingTimeOnlyTitle: "Time interval is on",
  kdsGroupingTimeOnlyBody: "Every {minutes} minutes, starting at {start} past the hour, the dishes that arrived in that window are combined, whether that was 3 orders or 16. Orders still inside the current window stay as separate tickets until the time is up.",
  kdsGroupingCountOnlyTitle: "Order count is on",
  kdsGroupingCountOnlyBody: "After every {count} orders for the same chef, identical dishes are combined. Orders 1–{count} become one group, and the next {count} become the next group. Orders that have not reached {count} yet stay separate.",
  kdsGroupingBothTitle: "Both rules are on",
  kdsGroupingBothBody: "Whichever limit is reached first closes the group, then both start over. If {count} orders arrive before {minutes} minutes, they group immediately and the timer restarts. If {minutes} minutes pass first, the orders that have arrived are grouped and the count restarts.",
  kdsGroupingTableRule: "Rule",
  kdsGroupingTableExample: "Example",
  kdsGroupingTableResult: "What the kitchen sees",
  kdsGroupingTableTimeRule: "Time interval only",
  kdsGroupingTableTimeExample: "Every {minutes} minutes",
  kdsGroupingTableTimeDetail: "Any number of orders can arrive in the window, such as 3 or 16.",
  kdsGroupingTableTimeResult: "When the {minutes} minutes end, every order from that window is combined, no matter how many arrived.",
  kdsGroupingTableCountRule: "Order count only",
  kdsGroupingTableCountExample: "Every {count} orders",
  kdsGroupingTableCountDetail: "Orders keep arriving. There is no timer.",
  kdsGroupingTableCountResult: "The group closes as soon as {count} orders arrive. The next {count} orders form the next group. Anything left over stays as its own ticket until it reaches {count}.",
  kdsGroupingTableBothRule: "Both on",
  kdsGroupingTableBothExample: "Every {minutes} minutes or every {count} orders",
  kdsGroupingTableBothDetail: "Whichever limit is reached first closes the group. The timer and the count then start over.",
  kdsGroupingTableBothResult: "If {count} orders arrive before {minutes} minutes, they group immediately and the timer restarts. If {minutes} minutes pass first, the orders that have arrived are grouped and the count restarts.",
  kdsGroupingEnabled: "Enable grouping",
  kdsGroupingRule: "Grouping rule",
  kdsGroupingTimeRule: "Time interval",
  kdsGroupingCountRule: "Order count",
  kdsGroupingInterval: "Interval (minutes)",
  kdsGroupingStartMinute: "Start minute past each hour",
  kdsGroupingStartMinuteHelp: "For example, 10 or 15. A 5-minute interval starting at 10 closes groups at :15, :20, :25, and so on.",
  kdsGroupingOrderCount: "Orders per group",
  kdsGroupingOrderCountHelp: "Identical dishes are combined after this many orders reach the same chef. For example, every 5 or 10 orders.",
  kdsGroupingSave: "Save grouping",
  kdsGroupingSaved: "Grouping saved",
  kdsGroupingSaveFailed: "Failed to save grouping",
  kdsGroupOrders: "{count} orders",
  kdsGroupHideOrders: "Hide orders",
  kdsGroupReady: "{count} orders are ready",
  kdsGroupConfirmBody: "Are you sure you want to mark these orders as ready?",
  kdsGroupPageUp: "Previous items",
  kdsGroupPageDown: "Next items",
  kdsPageFlipInterval: "Page flip interval (seconds)",
  kdsPageFlipIntervalHelp: "When a card is taller than the screen, the kitchen shows the next items after this many seconds. The default is 5.",
  kdsPageFlipSaved: "Page flip interval saved",
  kdsPageFlipSaveFailed: "Failed to save page flip interval",
  kdsDefaultDisplay: "Default display",
  kdsDefaultDisplayHelp: "Night mode is a black screen with white text. Kitchen screens open in the mode you choose here.",
  kdsNightMode: "Night mode",
  kdsDayMode: "Day mode",
  kdsDisplayModeSaved: "Display mode saved",
  kdsDisplayModeSaveFailed: "Failed to save display mode",
  kdsUserSettingsHelp: "Each KDS user can have up to 15 splitters. Name a splitter for a chef or station, then assign the menu items that splitter shows.",
  kdsChefStation: "Chef / station",
  kdsChefStationPlaceholder: "Grill, sushi, expo",
  kdsAssignItems: "Assign items",
  kdsSaveStation: "Save",
  kdsNoUsers: "No KDS users yet. Add one from the Users tab.",
  kdsItemsSelectedCount: "{selected} of {total} items selected for this splitter.",
  kdsCoverageAssigned: "{assigned} of {total} items are assigned to a KDS splitter.",
  kdsUnassignedWarning: "{unassigned} of {total} items are currently unassigned and will not be shown on any KDS screen.",
  kdsSplitterSaved: "Splitter saved",
  kdsSplitterSaveFailed: "Failed to save splitter",
  kdsAddSplitter: "Add splitter",
  kdsSplitterCount: "{count} of 15 splitters",
  kdsSplitterLimit: "This KDS user already has 15 splitters.",
  kdsRemoveSplitter: "Remove",
  kdsRemoveSplitterTitle: "Remove this splitter?",
  kdsRemoveSplitterBody: "This chef or station will no longer have its own item list.",
  kdsViewAllItems: "All items",
  kdsUnassignedItems: "Unassigned items",
  kdsChooseSplitter: "Choose a splitter",
  kdsStationItemsReady: "This station's items are ready",
  kitchenKioskFullscreen: "Full screen",
  kitchenKioskExitFullscreen: "Exit full screen",
  kitchenOrderStatus: "Order Status",
  kitchenAutoOff: "Auto (Off)",
  kitchenIntervalOff: "Off",
  kitchenView6x2: "6×2 View",
  kitchenView6x1: "6×1 View",
  kitchenReady: "Ready",
  kdsSignOutTitle: "Sign out?",
  kdsSignOutBody: "Leave the kitchen screen on this device.",
  kitchenOfflineBanner: "POS is offline - Order updates are not being received",
  kitchenConfirmCompletionTitle: "Confirm Order Completion",
  kitchenConfirmCompletionBody: "Are you sure you want to mark this order as complete?",
  kitchenItemsIncompleteWarning: "Warning: Some items in this order are not yet marked as completed.",
  kitchenPaymentFirstNote: "Note: Please ensure payment is completed first.",
  orderHistoryRefunds: "Order history & refunds",
  takeawayOrders: "Takeaway orders",
  takeawayPickupPhoneOrders: "Takeaway/PickUp Orders/Phone Orders",
  takeawayPickupOrders: "Takeaway/PickUp Orders",
  pleaseSetupStationName: "Set the station name in Settings, Store details, Workstation registration.",
  stationName: "Station name",
  enterStationName: "Counter 1",
  stationNameHelp: "The station name can be changed. Earlier names stay in the history.",
  stationId: "Station ID",
  generateStationId: "Generate station ID",
  stationIdRequired: "Generate a station ID.",
  stationNameHistory: "Station name history",
  stationIdReadOnly: "The station ID cannot be changed.",
  stationIdPending: "Assigned when this workstation is approved.",
  stationType: "Station type",
  stationTypeRequired: "Choose a station type.",
  stationTypePos: "POS terminal",
  stationTypeHandheld: "Handheld device",
  stationTypeCustomerTablet: "Customer tablet",
  stationTypeTablet: "Tablet",
  stationTypeKiosk: "Kiosk",
  stationLetter: "Station letter",
  stationLetterRequired: "Choose one station letter.",
  stationLetterUsed: "That station letter is already used.",
  stationLetterChosen: "Station {letter}. Bills start at {numbers}.",
  stationStartTime: "Station start time",
  stationStartTimeDescription: "The time when the station creates a report for the day's totals, and installs any pending software updates.",
  workstationSetup: "Workstation registration",
  workstationSetupDescription: "Register this workstation. The same computer remains recognized after Windows or the application is reinstalled.",
  workstationSetupDesktopOnly: "Open the Nuage POS Windows application to register or activate this workstation.",
  workstationSetupWebBlocked: "This CAN NOT be completed in the web browser.",
  motherboardSerial: "Motherboard serial",
  biosUuid: "BIOS UUID",
  stationFingerprint: "Station fingerprint",
  registrationStatus: "Registration status",
  stationStatusUnregistered: "Not registered",
  stationStatusPending: "Pending approval",
  stationStatusApproved: "Approved",
  stationStatusRegistered: "Registered",
  stationStatusRejected: "Rejected",
  stationStatusDeactivated: "Deactivated",
  stationStatusRemoved: "Removed",
  stationNameRequired: "Enter a station name.",
  submitStationRegistration: "Submit registration request",
  stationRequestSubmitted: "Registration request submitted",
  stationRequestSubmittedHelp: "A super admin must approve this workstation before it can be used.",
  stationPendingHelp: "This registration request is pending approval.",
  stationRequestSentAt: "Request sent",
  stationTechnicalContact: "Technical contact",
  stationTechnicalContactHelp: "Optional. If a technical problem occurs, Nuage POS contacts this person. This can be someone other than the person submitting the request.",
  stationContactName: "Name",
  stationContactEmailInvalid: "Enter a valid email address for the technical contact.",
  stationConsentLabel: "I agree to send this workstation's computer information to Nuage POS for approval.",
  stationConsentRequired: "Agree to send this workstation's computer information before submitting the request.",
  stationDeactivatedHelp: "This workstation is deactivated. A super admin can reactivate it.",
  stationApprovedHelp: "This workstation is registered.",
  workstationConnection: "Workstation connection",
  workstationConnectionOn: "On",
  workstationConnectionOff: "Off",
  workstationConnectionOffLogin: "Workstation connection is off. Sign in with the store admin account.",
  workstationSetupBanner: "This workstation must be approved before the application can be opened.",
  workstationSync: "Workstation sync",
  syncThisWorkstationIsEagle: "This workstation is Eagle",
  syncThisWorkstationIsEaglet: "This workstation is an Eaglet.",
  syncEagletFollows: "Channel choices come from Eagle. This workstation can see them and cannot change them.",
  syncWorkstations: "Workstations",
  syncNoEaglet: "No Eaglet is connected.",
  syncMakeEagle: "Make this workstation Eagle",
  syncEagleHelp: "Eagle hosts workstation sync for this store. Only one workstation is Eagle. Eaglets follow these choices.",
  syncEditedOnEagle: "Channel choices are edited on Eagle.",
  syncTable: "Table service",
  syncCounter: "Counter",
  syncTakeaway: "Takeaway",
  syncDelivery: "Delivery",
  syncLocalDelivery: "Local delivery",
  syncOnline: "Online order",
  syncSelectByDefault: "Select by default",
  syncUberEats: "Uber Eats",
  syncDoorDash: "DoorDash",
  syncSkip: "SkipTheDishes",
  syncFantuan: "Fantuan",
  syncFamilyHelp: "Eagle Scout and Eagle Eye follow these choices in a later version. A channel that is off stays on the workstation that took the order.",
  syncNetworkHelp: "Allow workstation sync on the private restaurant network, port 48765.",
  syncSettingsSaveFailed: "Workstation sync was not saved.",
  syncStatusSynced: "Synced",
  syncStatusRestaurantNetwork: "On the restaurant network. No internet.",
  syncStatusWaiting: "Waiting to sync",
  syncStatusEagleDown: "Eagle is unreachable",
  syncStatusManager: "Needs a manager",
  workstationSubmitLink: "Click here to submit",
  workstationPendingBanner: "A registration request has been sent for this workstation.",
  workstationLocation: "Workstation location",
  workstationLocationPlaceholder: "Front counter",
  workstationLocationHelp: "Where this workstation is located.",
  workstationLocationRequired: "Enter the workstation location.",
  stationRejectedHelp: "This registration request was rejected.",
  stationCustomerRemarks: "Remarks",
  workstationNotSetUp: "This workstation must be approved before this section can be opened.",
  offlineReturnMaxDays: "Offline return maximum days",
  offlineReturnMaxDaysDescription: "How far back this station can look up a sale for a return while offline. Online returns are not limited by this. Default 2 days, allowed 1 to 7.",
  posOrderId: "POS Order ID",
  deliveryOrders: "Delivery orders",
  orderHistory: "Order history",
  orderHistoryCard: "Order History",
  reproductionSent: "Reproduction sent",
  reproductionSentToPrinter: "The receipt was sent to the printer.",
  orderId: "Order ID",
  paymentMethod: "Payment Method",
  posUserId: "POS User",
  posUserStations: "Stations",
  posUserStationsHelp: "This user can sign in on every station in this store.",
  posUserStationRequired: "Select at least one station.",
  posUserStationsLimited: "This user can sign in only on the selected stations.",
  posUserStationNotAllowed: "This user is not assigned to this station. Please sign in on an assigned station.",
  orderChannel: "Channel",
  onlineOrderManagement: "Online order management",
  onlineUnconfirmed: "Unconfirmed",
  onlineConfirmed: "Confirmed",
  confirmedDueSoon: "Confirmed (Due Soon)",
  confirmedUpcoming: "Confirmed (Upcoming)",
  onlineReady: "Ready",
  onlineOnRoute: "En Route",
  onlineCanceled: "Canceled",
  onlineStatusUpdated: "Status updated",
  onlineErrorUpdatingStatus: "Error updating status",
  onlineOrderDetails: "Order Details",
  onlineNothingHere: "Nothing here...",
  onlineGuest: "Guest",
  onlineServiceType: "Service",
  onlineCustomer: "Customer",
  onlineNotes: "Notes",
  onlineSubtotal: "Subtotal",
  onlineTaxes: "Taxes",
  onlineCancelOrder: "Cancel order",
  onlineManageOrder: "Manage order",
  stripeRefundPayment: "Refund Stripe payment",
  stripeRefundReceived: "Stripe refund received",
  stripeRefundPending: "Stripe refund is pending",
  stripeRefundFailed: "Stripe refund failed",
  stripeRefundConfirm: "This refunds {amount} on the Stripe payment for this order.",
  stripeRefundNone: "Record a refund on this order before refunding the Stripe payment.",
  stripeRefundAlready: "This Stripe refund is already recorded.",
  stripeRefundAmount: "Refund amount",
  stripeRefundNumber: "Refund number",
  stripeRefundHistoryItem: "Stripe refund",
  stripeRefundList: "Stripe refunds",
  stripeRefundSucceeded: "Succeeded",
  stripeRefundPendingStatus: "Pending",
  stripeRefundFailedStatus: "Failed",
  stripeRefundCanceled: "Canceled",
  orderDetailMissingReceipt: "The original receipt for this order was not saved.",
  onlineKeepOrder: "Keep order",
  onlineCancelOrderTitle: "Cancel order",
  confirmCancelOnlineOrder: "This cancels the order and issues a canceled closing receipt.",
  confirmCancelSentBill: "This cancels the order and issues a canceled closing receipt.",
  reprintReceipt: "Reprint receipt",
  resendReceiptEmail: "Resend email",
  confirmReprintReceipt: "This prints the receipt again. Revenu Québec receives a record of this reprint.",
  confirmResendReceiptEmail: "This sends the electronic receipt again to {email}. Revenu Québec receives a record of this receipt.",
  lastReprintAt: "Last reprint {time}",
  receiptLogReprint: "Receipt reprinted {time}",
  receiptLogResend: "Electronic receipt sent again {time}",
  receiptReprinted: "Receipt reprinted",
  receiptEmailResent: "Electronic receipt sent again",
  receiptEmailNotOnStation: "The electronic receipt is not on this station",
  customerEmailMissing: "The customer email is missing",
  sortBy: "Sort by",
  sortByDate: "Date",
  sortByTable: "Table",
  sortByOrderId: "Order ID",
  sortByTotal: "Total",
  orderDetails: "Order Details",
  customerInfo: "Customer Info",
  noPaymentMethod: "N/A",
  posSettings: "POS settings",
  items: "items",
  startOrdering: "Start Ordering?",
  startOrderingForTable: "Do you want to start ordering for table",
  startOrderingButton: "Start Ordering",
  // Takeaway translations
  activeSession: "active session",
  newTakeaway: "New Takeaway",
  clickToCreateTakeaway: "Click to create new takeaway order",
  takeawayCreated: "Takeaway created",
  phoneOrder: "Phone Order",
  newTakeawayForPhoneOrder: "New TakeAway for Phone order",
  clickToCreatePhoneOrder: "Click to create new phone order",
  phoneOrderCreated: "Phone order created",
  phoneOrderHasBeenCreated: "{name} has been created",
  errorCreatingPhoneOrder: "Error creating phone order",
  phoneOrderCustomerInfoRequired: "Customer name and phone number are required for phone orders",
  missingPhoneOrderFields: "Missing: {fields}",
  customerNameRequired: "Customer name is required",
  takeawayHasBeenCreated: "{name} has been created",
  errorCreatingTakeaway: "Error creating takeaway",
  offlineMode: "Offline Mode",
  disableNetwork: "Disable network",
  enableNetwork: "Enable network",
  takeawayWillBeCreatedOnline: "New takeaway will be created when online",
  cannotDeleteTW001: "Cannot delete TW001",
  tw001CannotBeDeleted: "TW001 is the default takeaway and cannot be deleted",
  sessionWillBeDeletedOnline: "Session will be deleted when online",
  sessionDeleted: "Session deleted",
  takeawayHasBeenDeleted: "{name} has been deleted",
  errorDeletingSession: "Error deleting session",
  deleteTakeawaySession: "Delete Takeaway Session",
  areYouSureDeleteTakeaway: "Are you sure you want to delete {name}?",
  // Delivery translations
  newDelivery: "New Delivery",
  clickToCreateDelivery: "Click to create new delivery order",
  deliveryCreated: "Delivery created",
  deliveryHasBeenCreated: "{name} has been created",
  errorCreatingDelivery: "Error creating delivery",
  deliveryHasBeenDeleted: "{name} has been deleted",
  deleteDeliverySession: "Delete Delivery Session",
  areYouSureDeleteDelivery: "Are you sure you want to delete {name}?",
  // Unprinted items warning
  unprintedItemsWarning: "Items Not Sent to Kitchen",
  unprintedItemsWarningMessage: "There are items in the cart that have not been printed to the kitchen yet.",
  unprintedItemsWarningQuestion: "Do you want to proceed to checkout without printing these items?",
  payWholeTableTitle: "Pay the whole table",
  payWholeTableMessage: "This pays the whole table on one bill.",
  proceedAnyway: "Proceed Anyway",
  // Delivery address translations
  deliveryInformation: "Delivery Information",
  deliveryInformationRequired: "Delivery Information Required",
  pleaseEnterPhoneAndAddress: "Please enter phone number and delivery address",
  pleaseSelectCustomerWithPhone: "Please select a customer with phone number",
  pleaseSelectCustomerWithAddress: "Please select a customer with complete delivery address",
  customerRequired: "Customer Required",
  pleaseAssignCustomer: "Please assign a customer before checkout",
  pleaseSelectCustomer: "Please select a customer",
  missingDeliveryFields: "Missing: {fields}",
  deliveryOrder: "Delivery Order",
  enterPhoneNumber: "Enter phone number",
  phoneRequired: "Phone number is required",
  streetAddress: "Street Address",
  enterStreetAddress: "Enter street address",
  streetAddressRequired: "Street address is required",
  apartmentUnit: "Apartment/Unit",
  enterApartmentUnit: "Enter apartment/unit",
  city: "City",
  enterCity: "Enter city",
  cityRequired: "City is required",
  enterPostalCode: "Enter postal code",
  postalCodeRequired: "Postal code is required",
  deliveryInstructions: "Delivery Instructions",
  enterDeliveryInstructions: "Enter delivery instructions (e.g., ring doorbell twice)",
  actionCannotBeUndone: "This action cannot be undone.",
  addGuestNumberAndCustomer: "Add Guest Number & Customer",
  selectExistingCustomer: "Select existing customer...",
  or: "OR",
  enterNewCustomerName: "Enter new customer name...",
  numberOfGuests: "Number of Guests",
  saving: "Saving",
  errorSaving: "Error saving",
  new: "New",
  changesWillBeSavedOnline: "Changes will be saved when online",
  sessionUpdated: "Session updated",
  errorUpdatingSession: "Error updating session",
  deleteCart: "Delete Cart",
  deleteCartConfirm: "Are you sure you want to clear the cart? This action cannot be undone.",
  deleteCartWorking: "Deleting the cart.",
  deleteCartDeleted: "{count} items have been deleted.",
  deleteCartDeletedOne: "1 item has been deleted.",
  orderCanceledDetail: "Order {order} has been canceled.",
  cancellationReceiptPrinted: "Cancellation receipt printed for {transaction}.",
  deleteCartLogHint: "You can view the deletion details in the system log.",
  noteRemark: "Note/Remark",
  remarkSaved: "Remark saved",
  errorSavingRemark: "Error saving remark",
  tableActions: "Table Actions",
  liveTables: "Live tables",
  switchTable: "Switch table",
  cart: "Cart",
  cartEmpty: "Cart is empty",
  cartAddItemsHint: "Add items to get started",
  subtotal: "Subtotal",
  allProducts: "ALL PRODUCTS",
  assignToTable: "Assign to Table",
  enterNoteOrRemark: "Enter note or remark...",
  additionalNotes: "Additional Notes",
  allergies: "Allergies",
  selectAllergies: "Select Allergies",
  commonAllergies: "Common Allergies",
  peanut: "Peanut",
  shellfish: "Shellfish",
  dairy: "Dairy",
  gluten: "Gluten",
  eggs: "Eggs",
  soy: "Soy",
  treeNuts: "Tree Nuts",
  fish: "Fish",
  sesame: "Sesame",
  printTemporaryBill: "Print FO",
  printTemporaryBillShort: "FO",
  printCartItems: "Kitchen",
  printed: "Printed",
  allItemsPrinted: "All items have been printed",
  itemsPrinted: "Items printed successfully",
  itemHold: "Hold Print",
  itemReleaseHold: "Release Hold",
  itemOnHold: "ON HOLD",
  applyDiscount: "Apply Discount",
  itemDiscount: "Item Discount",
  freeEntry: "Free Entry",
  unprintedItemsDetected: "Unprinted Items Detected",
  unprintedItemsMessage: "There are items that have not been printed. Do you want to proceed?",
  proceed: "Proceed",
  removeDiscount: "Remove Discount",
  addItemNote: "Add Note",
  itemNote: "Item Note",
  enterItemNote: "Enter note for this item...",
  removeNote: "Remove Note",
  printError: "Error printing items",
  payNow: "Pay",
  returnToEditing: "Return to Editing?",
  alreadyCheckedOut: "You have already started the checkout process.",
  returnToEditingConfirm: "Would you like to go back and continue adding items to this order?",
  stayOnCheckout: "Stay on Checkout",
  continueAdding: "Yes, Continue Adding",
  cartCleared: "Cart cleared",
  transferTable: "Transfer Table",
  pos: "POS",
  convertTakeawayToTable: "Convert Takeaway to Table",
  invalidOperation: "Invalid operation",
  onlyTakeawayCanConvert: "Only takeaway orders can be converted to table orders",
  pleaseSelectTable: "Please select a table",
  conversionSuccess: "Conversion successful",
  converted: "Converted",
  to: "to",
  errorConvertingSession: "Error converting session",
  occupied: "Occupied",
  convert: "Convert",
  takeawayOrder: "Takeaway Order",
  mergeTables: "Merge Tables",
  selectDestinationTable: "Select Destination Table",
  selectTablesToMerge: "Select Tables to Merge",
  currentTable: "Current Table",
  transferSuccess: "Table {from} transferred to {to}",
  mergeSuccess: "Tables merged: {tables}",
  noTablesSelected: "Please select at least one table",
  tableEmpty: "Table {name} is now empty",
  errorTransferringTable: "Error transferring table",
  errorMergingTables: "Error merging tables",
  noAvailableTables: "No available tables",
  noTableLargeEnough: "No open table seats {covers} or more.",
  destinationTooSmall: "This table seats {seats}. {covers} guests are seated.",
  tableSeats: "{seats} seats",
  sortSmallestFirst: "Smallest number first",
  sortLargestFirst: "Largest number first",
  noOtherOccupiedTables: "No other occupied tables available",
  noFloorTablesToMerge: "No other tables have open orders.",
  mergeReviewTitle: "Review merge",
  mergeReviewHint: "These items join All on this table. The other tables close.",
  reviewMerge: "Review",
  mergeIntoThisTable: "Other tables will be merged into this table",
  mergedTotal: "Merged Total",
  selectedTables: "Selected",
  transfer: "Transfer",
  merge: "Merge",
  // Split Payment Translations
  checkout: "Checkout",
  chooseItemToCheckout: "Choose item to checkout",
  singleSeatCheckout: "Single seat (seat 1 only)",
  splitByItem: "Split by Seat",
  splitByItemDescription: "Select items manually using checkboxes to create custom payment splits. (Coming soon)",
  splitInEqualParts: "Split in Equal Parts",
  fullCart: "Full Cart",
  splitEqualPartsDescription: "Divide the total bill equally among multiple parts.",
  numberOfParts: "Number of parts:",
  createEqualSplits: "Create Equal Splits",
  seatSpecificCheckout: "Seat-specific checkout: All items will be paid together. No split options available.",
  paymentSplits: "Payment Splits",
  pay: "Pay",
  paid: "Paid",
  allPaid: "All Paid",
  tableClosed: "Table is closed",
  item: "Item",
  qty: "Qty",
  grandTotal: "Grand Total",
  removeItemOutOfTable: "Remove item out of table order/kitchen",
  invalidNumber: "Invalid number",
  numberOfPartsRange: "Number of parts must be between 2 and 99",
  noItemsSelected: "No items selected",
  paymentSavedLocally: "{channel}. Payment saved on this station. The receipt is printing now.",
  orderCompletedSuccessfully: "Order completed successfully",
  sendingToRevenuQuebec: "Sending data to Revenu Québec",
  closingBillSentToRevenuQuebec: "{channel}. Closing bill is sent to Revenue Quebec and will print when Revenue Quebec responds.",
  temporaryBillSentToRevenuQuebec: "{channel}. This is a temporary bill. The receipt will print when Revenue Quebec responds.",
  temporaryBillOffline: "{channel}. Temporary bill saved on this station. The receipt is printing now.",
  offlineReceiptPrinting: "The receipt is printing on this station and shows a communication problem. The bill will be sent when the network returns.",
  syncUnsentBills: "Sync Unsent Bills",
  syncingUnsentBills: "Syncing...",
  noUnsentBills: "No unsent bills",
  revenueQuebecReceivedLot: "Revenue Québec received the unsent bills",
  revenueQuebecLotDetails: "{count} bill(s) sent on their own. Lot {noLot}. Received {psiDatLot}.",
  revenueQuebecReceivedWithBill: "Revenue Québec received this bill and the unsent bills",
  revenueQuebecWithBillDetails: "Bill {psiNoTrans}. {count} queued bill(s) sent with it. Lot {noLot}.",
  revenueQuebecLotRejected: "Revenue Québec did not accept the unsent bills",
  unsentBillsStillQueued: "The offline bills stay on this station until Revenue Québec confirms them.",
  offlineBillsSentSuccessfully: "Offline bills sent successfully",
  offlineBillsReceivedDetails: "Revenue Québec received {count} offline bill(s). Lot {noLot}. Received {psiDatLot}.",
  offlineBillsReceivedWithBill: "Revenue Québec received {count} offline bill(s) with this bill {psiNoTrans}. Lot {noLot}.",
  offlineBillsNotConfirmed: "Revenue Québec did not confirm the offline bills",
  orderWillSyncWhenOnline: "Order will sync to server when connection is restored",
  orderSavedOffline: "Order saved offline",
  fiscalReceiptQueued: "Fiscal receipt queued",
  revisedBillQueued: "Revised bill queued",
  fiscalReceiptQueuedDescription: "The receipt prints when Revenu Québec responds.",
  errorCompletingOrder: "Error completing order",
  itemsReadyForPayment: "Items ready for payment",
  clickGreenButtonToPay: "Click the green button again to proceed to payment",
  // Split Modal Translations
  splitModal: "Split",
  splitEqual: "Split Equal",
  availableItems: "Available Items",
  seats: "Seats",
  noSeatsCreated: "No seats created",
  clickAddSeatToCreate: "Click the + icon above to create a seat",
  apply: "Apply",
  revert: "Revert",
  finish: "Finish",
  splitApplied: "Split applied",
  splitSaved: "Split saved",
  discardChanges: "Discard Changes?",
  unsavedChangesWarning: "You have unsaved changes. Are you sure you want to cancel? All changes will be lost.",
  stay: "Stay",
  discard: "Discard Changes",
  addSeats: "Add Seats",
  howManySeats: "How many seats would you like to add?",
  enterSeatNames: "Enter Seat Names (Optional)",
  enterSeatNamesOptional: "Enter customer names for each seat (optional)",
  customerNameOptional: "Customer name (optional)...",
  seat: "Seat",
  seatsAdded: "Seats added",
  revertSplit: "Remove All Split Assignments",
  revertSplitWarning: "This will remove all split assignments. All items will be unassigned. Continue?",
  resumeSplit: "Restore Original Split State",
  resumeSplitWarning: "This will restore the original split assignments. Current changes will be lost. Continue?",
  modeSwitchWarning: "Remove All Seats First",
  modeSwitchWarningMessage: "You must remove all seats before switching methods. Use the Revert button or manually delete seats first.",
  modeSwitchBlocked: "Remove all seats first to switch methods",
  confirm: "Confirm",
  // Customer translations
  customers: "Customers",
  customersSynced: "Synced",
  customersNotSynced: "not synced",
  customer: "Customer",
  firstName: "First Name",
  lastName: "Last Name",
  firstNameIsRequired: "First name is required",
  lastNameIsRequired: "Last name is required",
  phoneIsRequired: "Phone number is required",
  address2: "Address 2",
  postCode: "PostCode / Zip",
  state: "Province",
  country: "Country",
  customerSegment: "Customer Segment",
  selectSegment: "Select Segment",
  regularCustomer: "Regular Customer",
  vipCustomer: "VIP Customer",
  newCustomer: "New Customer",
  frequentCustomer: "Frequent Customer",
  corporateCustomer: "Corporate Customer",
  phoneNumber: "Phone Number",
  unitNumber: "Unit #",
  latitude: "Latitude",
  longitude: "Longitude",
  wizardStepName: "Name",
  wizardStepPhone: "Phone",
  wizardStepAddress: "Address",
  wizardStepEmail: "Email",
  wizardStepSegment: "Segment",
  customerNumber: "Customer #",
  customerDetail: "Customer detail",
  customerAlreadyCreated: "This customer has already been created",
  customerAlreadyCreatedHint: "{name} already exists. Save this customer as {proposed}?",
  useThisName: "Use this name",
  next: "Next",
  previous: "Previous",
  quickAreaCodes: "Quick area codes",
  editQuickAreaCodes: "Edit quick area codes",
  addAreaCode: "Add",
  areaCodeHint: "Save the area codes this restaurant uses",
  quickPostalCodes: "Quick postal codes",
  editQuickPostalCodes: "Edit quick postal codes",
  postalPrefixHint: "Save the first 3 characters, such as H3Z",
  houseNumber: "Street number",
  streetName: "Street name",
  searchAddress: "Search",
  buzzCode: "Buzz code",
  manualEnter: "Enter manually",
  streetChoices: "Street choices",
  searchStreet: "Search street",
  skipAddress: "Skip address",
  phoneIncomplete: "Enter a 10-digit phone number",
  invalidAreaCode: "Enter a 3-digit area code",
  invalidPostalPrefix: "Enter 3 characters like H3Z",
  noStreetMatches: "No streets found. Search below.",
  clear: "Clear",
  createCustomer: "Create customer",
  addCustomer: "Add Customer",
  editCustomer: "Edit Customer",
  manageCustomers: "Manage customer database",
  searchCustomers: "Search customers...",
  searching: "Searching...",
  allSegments: "All Segments",
  noCustomersFound: "No customers found",
  errorLoadingCustomers: "Failed to load customers",
  customerDeleted: "Customer deleted successfully",
  errorDeletingCustomer: "Failed to delete customer",
  confirmDeleteCustomer: "Are you sure you want to delete this customer?",
  // Menu Management
  menus: "Menus",
  uberEatsMenu: "Uber Eats",
  uberEatsMenuEmpty: "No Uber Eats menu has been received.",
  uberEatsMenuPrinterOnly: "This menu is used to assign Uber Eats items to printers.",
  uberEatsMenuUpdated: "This menu was updated at",
  uberEatsActivity: "Activity",
  uberEatsEditConnection: "Edit connection",
  uberEatsCancelEdit: "Cancel",
  uberEatsStoreIdHidden: "The store ID is hidden. Choose Edit connection to change it.",
  uberEatsWebhookSecret: "Webhook secret",
  uberEatsWebhookSecretHelp: "Paste a webhook secret for this store.",
  uberEatsSecretSaved: "Webhook secret saved",
  uberEatsReplaceSecret: "Replace the webhook secret? Eat Printer must use the new secret before the next order.",
  uberEatsContinue: "Continue",
  uberEatsSaveSecret: "Save secret",
  uberEatsRemoveSecret: "Remove secret",
  uberEatsRemovePrompt: "Type REMOVE to delete the saved secret.",
  uberEatsSecretInvalid: "Enter the 64-character secret.",
  uberEatsSecretKept: "Webhook secret saved",
  uberEatsSecretRemoved: "Webhook secret removed",
  menu: "Menu",
  createMenu: "Create Menu",
  editMenu: "Edit Menu",
  deleteMenu: "Delete Menu",
  confirmDeleteMenu: "Are you sure you want to delete this menu? This action cannot be undone.",
  menuDeleted: "Menu deleted",
  menuDeletedSuccessfully: "Menu, categories, and items have been deleted successfully.",
  errorDeletingMenu: "Error deleting menu",
  menuCopied: "Menu copied",
  copyingMenu: "Copying menu...",
  menuCopiedSuccessfully: "Menu, categories, and items have been copied successfully.",
  errorCopyingMenu: "Error copying menu",
  menuCreated: "Menu created",
  menuUpdated: "Menu updated",
  errorSavingMenu: "Error saving menu",
  createCategory: "Create Category",
  editCategory: "Edit Category",
  confirmDeleteCategory: "Are you sure you want to delete this category? This action cannot be undone.",
  categoryDeletedSuccessfully: "Category and items have been deleted successfully.",
  categoryCopied: "Category copied",
  errorCopyingCategory: "Error copying category",
  categoryCreated: "Category created",
  categoryUpdated: "Category updated",
  errorSavingCategory: "Error saving category",
  createItem: "Create Item",
  editItem: "Edit Item",
  itemCreated: "Item created",
  itemUpdated: "Item updated",
  errorSavingItem: "Error saving item",
  itemCopied: "Item copied",
  errorCopyingItem: "Error copying item",
  createNewItem: "Create New Item",
  createNewCategory: "Create New Category",
  createNewMenu: "Create New Menu",
  rearrange: "Re-Arrange",
  sequencing: "Sequencing",
  sequencingHelper: "Drag and drop to reorder menus, categories, and items. Items can be moved between categories within the same menu.",
  editPrices: "Edit Prices",
  selected: "Selected",
  itemsPaused: "Items Paused",
  paused: "Paused",
  pauseItem: "Pause Item",
  resumeItem: "Resume Item",
  itemPaused: "Item paused",
  itemResumed: "Item resumed",
  errorPausingItem: "Error pausing item",
  errorResumingItem: "Error resuming item",
  favorite: "Favorite",
  itemActions: "Item actions",
  eightySixItem: "86 item",
  eightySixUnavailable: "Unavailable",
  eightySixOneHour: "1 hour",
  eightySixTwoHours: "2 hours",
  eightySixThreeHours: "3 hours",
  eightySixFourHours: "4 hours",
  eightySixRestOfDay: "Rest of the day",
  eightySixThreeDays: "3 days",
  eightySixOneWeek: "1 week",
  eightySixUntilResumed: "Until resumed",
  eightySixUntil: "Until",
  itemEightySixed: "Item 86'd",
  errorEightySixItem: "Could not 86 this item",
  noMenus: "No menus found",
  noCategoriesInMenu: "No categories in this menu",
  noCategoriesAvailable: "No categories available",
  noItemsInCategory: "No items in this category",
  createFirstMenu: "Create First Menu",
  general: "General",
  conditions: "Conditions",
  optional: "OPTIONAL",
  uniqueNameForMenu: "A unique name for your menu",
  displayName: "Display Name",
  displayNamePlaceholder: "Will override the unique name in your store",
  displayNameHelper: "Will override the unique name in your store",
  screenPin: "Screen PIN",
  screenPinPlaceholder: "4-6 digit PIN",
  screenPinHelper: "This 6-digit PIN is your POS PIN. You can change it here.",
  idleLockTitle: "LOGIN",
  idleLockInstruction: "Enter login information to login.",
  idleLockPinLabel: "Enter your PIN *",
  idleLockEnterPinOf: "Enter PIN of",
  idleLockWrongPin: "Wrong PIN",
  idleLockClear: "clear",
  idleLockOk: "OK",
  idleLockNoPinSet: "Screen PIN not set. Please set a PIN in your profile.",
  idleLockEnterPINToUnlock: "Enter PIN to unlock",
  idleLockLastUser: "Last user",
  idleLockEnter6Digits: "Please enter 6 digits",
  idleLockError: "Error logging in. Please try again.",
  idleTimeoutMinutes: "Screen Idle Time (minutes)",
  idleTimeoutDescription: "Time before screen locks due to inactivity",
  locationControlTitle: "Location control",
  locationControlDescription: "The application may be used only within this radius of the recorded location.",
  locationControlEnabled: "Location control",
  locationRadiusMeters: "Authorized radius (meters)",
  locationRadiusRequired: "Enter the authorized radius in meters.",
  locationRecord: "Record this location",
  locationRecorded: "Location recorded",
  locationRecordRequired: "Record this location before enabling location control.",
  locationCoordinates: "Recorded location",
  locationNotRecorded: "No location is recorded.",
  locationOutsideArea: "This station is outside the authorized area.",
  locationMeasuredDistance: "Measured distance",
  locationUnavailable: "Location is unavailable. This station cannot be verified.",
  locationCheckAgain: "Check location again",
  startWithWindows: "Start when Windows starts",
  showWindowShortcut: "Show window",
  checkApplicationUpdate: "Check for application updates",
  applicationUpdateAvailable: "An application update is available.",
  applicationUpdateCurrent: "This application is current.",
  applicationUpdateUnconfigured: "Application updates are not configured.",
  applicationUpdateFailed: "The application update check failed.",
  profileUpdated: "Profile Updated",
  profileUpdatedSuccess: "Your profile has been updated successfully",
  failedToUpdateProfile: "Failed to update profile",
  menuDescriptionPlaceholder: "Will be displayed above your menu. You can use this to summarise your menu requirements. E.g. 'Available Monday-Thursday after 9:00pm, Pickup's Only'",
  menuDescriptionHelper: "Will be displayed above your menu. You can use this to summarise your menu requirements. E.g. 'Available Monday-Thursday after 9:00pm, Pickup's Only'",
  hideUnavailableMenu: "Hide Unavailable Menu",
  hideUnavailableMenuHelper: "Enabling this will hide this menu in your store if it's unavailable. Otherwise, this menu will still be displayed with a warning message that it is not available.",
  services: "Services",
  // POS User Management
  posUsers: "POS Users",
  posUser: "POS User",
  createPOSUser: "Create POS User",
  editPOSUser: "Edit POS User",
  deletePOSUser: "Delete POS User",
  posUserCreated: "POS user created successfully",
  posUserUpdated: "POS user updated successfully",
  posUserDeleted: "POS user deleted successfully",
  confirmDeletePOSUser: "Are you sure you want to delete",
  errorLoadingPOSUsers: "Error loading POS users",
  errorSavingPOSUser: "Error saving POS user",
  errorDeletingPOSUser: "Error deleting POS user",
  noPOSUsers: "No POS users found. Create your first POS user to get started.",
  pinRequired: "PIN is required",
  pinMustBe6Digits: "PIN must be exactly 6 digits",
  atLeastOneRoleRequired: "At least one role is required",
  enter6DigitPIN: "Enter 6-digit PIN",
  leaveBlankToKeepCurrent: "leave blank to keep current",
  cashier: "Cashier",
  server: "Server",
  manager: "Manager",
  lastLogin: "Last Login",
  never: "Never",
  unauthorized: "You are not authorized to access this page.",
  currentPOSUser: "POS User",
  logoutPOSUser: "Logout POS User",
  posUserLoggedOut: "POS user logged out",
  refreshMenu: "Refresh the menu",
  refreshMenuDone: "The menu is refreshed.",
  hardRefreshTitle: "Hard refresh",
  hardRefreshBody: "This hard refresh can remove today's sales cards and today's transactions. Exit Nuage POS from the system tray at the bottom right of the screen, then start the app again.",
  hardRefreshTray: "Restart from the system tray",
  hardRefreshConfirm: "Hard refresh",
  logoutPOSUserConfirmTitle: "Log out the POS user?",
  logoutPOSUserConfirmBody: "If you log out, the other POS user will not be able to continue this work. Are you sure you want to log out the POS user? Other POS users need an admin to sign in before they can sign in as a POS user.",
  mevVerified: "MEV Verified",
  createdOn: "Created",
  posUserDeletedOn: "Deleted",
  posUserNotMevVerified: "This user is not MEV verified.",
  mevUserRestriction: "The name matches the certificate user. You can change the PIN, the role, the active status, and the stations.",
  // POS User Permissions
  role: "Role",
  roleRequired: "Role is required",
  managePermissions: "Manage Permissions",
  roles: "Roles",
  assignRole: "Assign role",
  newRole: "New role",
  roleName: "Role name",
  roleSaved: "Role saved",
  roleSaveFailed: "The role could not be saved",
  roleChangeReport: "Role change report",
  roleConfirmSave: "Confirm and save",
  roleConfirmCreate: "Confirm and create",
  roleConfirmDelete: "Confirm and delete",
  roleConfirmReset: "Confirm and reset",
  roleLeaveUnsaved: "Leave without saving",
  roleLeaveImpact: "These edits are not saved. Leaving this role discards them.",
  roleNameRequired: "Enter a role name.",
  roleNameDuplicate: "A role already uses this name.",
  roleAssignedPeople: "People with this role",
  roleNoOneAssigned: "No one is assigned this role. No current sign-in changes.",
  roleWillHaveAccess: "Who will have access",
  roleCanDo: "Who can do this",
  roleCannotDo: "Who cannot do this",
  roleWillLose: "Who will no longer have this",
  roleNoChanges: "No permission on this role changes.",
  roleOwnerUnchanged: "The store owner's email sign-in keeps full access when no POS user is signed in. This change does not change that sign-in.",
  roleCreateImpact: "This creates the role. It starts with the Cashier permissions. No one receives it until you assign the role.",
  roleDeleteImpact: "This removes the role. The people below keep this assignment, and this role will no longer grant any access.",
  roleResetImpact: "This returns the role to the product defaults. Edits that are not saved are discarded.",
  roleReportFailed: "The report could not be prepared. Nothing was saved.",
  roleNone: "None.",
  rolePosSignIn: "POS",
  roleEmailSignIn: "Email",
  roleSwitchOn: "On",
  roleSwitchOff: "Off",
  roleInactiveExcluded: "Inactive POS users with this role are not included.",
  assignedOnly: "Assigned only",
  posCards: "POS cards",
  actions: "Actions",
  grantAllow: "Allow",
  grantApproval: "Approval",
  grantDeny: "Not allowed",
  approvalLimit: "Limit amount",
  shiftSupervisor: "Shift Supervisor",
  clockOnlyRole: "Clock-in / clock-out",
  clockInOut: "Clock in / clock out",
  clockInOutHint: "Record a clock in or clock out",
  startTheDay: "Start the day",
  dayAlreadyStarted: "This business day is already started.",
  dayStartedBy: "Day started by",
  timeClock: "Time clock",
  alreadyClockedIn: "This person is already clocked in.",
  unpaidMealBreak: "Unpaid meal break",
  paidBreak: "Paid break",
  endBreak: "End break",
  endShift: "End shift",
  onBreak: "On a break",
  noOpenOrders: "No open orders.",
  openOrdersRemain: "Open orders remain on this shift.",
  transferOrder: "Transfer an order",
  noDrawerOnShift: "This shift has no cash drawer.",
  sharedDrawerStaysOpen: "The shared drawer stays open.",
  drawerStillOpen: "The drawer still needs a count.",
  shiftClosed: "Shift closed.",
  unpaidBreak: "Unpaid break",
  openOrders: "Open orders",
  labourReport: "Labour report",
  cashDrawerReport: "Cash drawer report",
  week: "This week",
  month: "This month",
  custom: "Custom",
  payable: "Payable",
  mealBreakMissing: "No unpaid meal break recorded.",
  forcedClockOut: "Force clock-out",
  forceClockOutAll: "Force clock-out all users",
  addShift: "Add a shift",
  summaryCsv: "Summary CSV",
  detailedCsv: "Detailed CSV",
  regularHours: "Regular hours",
  overtimeHours: "Overtime hours",
  grossWages: "Gross wages",
  hourlyRate: "Hourly rate",
  reason: "Reason",
  permissionDenied: "You do not have permission for this action.",
  cashDrawer: "Cash drawer",
  openCashDrawerSession: "Open cash drawer",
  cashIn: "Cash in",
  cashOut: "Cash out",
  cashDrop: "Cash drop",
  cashTipPayout: "Cash tip payout",
  countCash: "Count cash",
  handoverDrawer: "Handover drawer",
  closeCashDrawer: "Close cash drawer",
  drawerAlreadyOpen: "This drawer already has an open session.",
  drawerClaimWaiting: "This station cannot claim the drawer until the other station is reconciled.",
  managerApproval: "Manager approval",
  cashVariance: "Cash variance",
  addCashDrawer: "Add cash drawer",
  sharedDrawer: "Shared",
  dedicatedDrawer: "Dedicated",
  manualCashBox: "Manual cash box",
  blindCount: "Blind count",
  noSaleNeedsManager: "No-sale open needs a manager",
  defaultFloat: "Default opening float",
  cashDrawerSettingsHelp: "A physical drawer is the device. A session is the counted cash. Payment methods still choose when a tender kicks the drawer.",
  overtimeRules: "Weekly overtime",
  weekStarts: "Work week starts",
  monday: "Monday",
  sunday: "Sunday",
  weeklyThreshold: "Weekly threshold (hours)",
  overtimeMultiplier: "Overtime multiplier",
  clockIn: "Clock in",
  clockOut: "Clock out",
  clockedIn: "Clocked in",
  clockedOut: "Clocked out",
  noPunchesToday: "No punches today.",
  managerApproval: "Manager approval",
  managerApprovalHint: "A person who is allowed to do this enters their PIN. The signed-in person stays signed in.",
  approvalPin: "Approval PIN",
  approvalPinHint: "This PIN approves a restricted action. It is separate from the password.",
  approvalPinInvalid: "Enter the 6-digit PIN of a person who can approve this.",
  approvalPinRejected: "This PIN cannot approve this action.",
  approve: "Approve",
  actionNotAllowed: "This role cannot do that",
  managerRoleHint: "Manager is a back-office login for daily operations. A POS user and PIN are created with this login.",
  permissionDescription: "Customize permissions for this user. Permissions override role defaults.",
  resetToRoleDefaults: "Reset to Role Defaults",
  permissionsUpdated: "Permissions updated successfully",
  posOperations: "POS Operations",
  createOrders: "Create Orders",
  completeOrders: "Complete Orders",
  processRefunds: "Process Refunds",
  processRefundsDescription: "Only manager role has this by default",
  viewReports: "View Reports",
  manageTables: "Manage Tables",
  manageReservations: "Manage Reservations",
  manageCustomers: "Manage Customers",
  sidebarAccess: "Sidebar Access",
  cashier: "Cashier",
  server: "Server",
  manager: "Manager",
  // PIN Management
  autoGenerate: "Auto",
  pinGenerated: "PIN generated successfully",
  pinAlreadyInUse: "This PIN is already in use by another user",
  errorGeneratingPIN: "Error generating PIN",
  errorCheckingPIN: "Error checking PIN availability",
  pinIsSet: "PIN is set",
  signInUser: "Sign In User",
  backOfficeUser: "Back Office User",
  linkedPOSUser: "Linked POS user",
  linkedPOSUserPlaceholder: "Select a POS user",
  linkedPOSUserNone: "No linked POS user",
  linkedPOSUserHint: "When keypad popup at login is off, this POS user starts automatically after Firebase login.",
  noPOSUsersToLink: "Create a POS user first, then link it here.",
  linkedPOSUserSaved: "Linked POS user saved",
  linkedPOSUserCleared: "Linked POS user removed",
  linkedPOSUserSaveFailed: "Failed to save linked POS user",
  logoutBackOfficeUser: "Logout Back Office User",
  logoutBackOfficeUserConfirmTitle: "Log out the back office user?",
  logoutBackOfficeUserConfirmBody: "If you log out, you will interrupt the operation. To log out the POS user instead, choose Log off POS user. The next user needs an admin password and admin privileges to sign in.",
  logOffPOSUser: "Log off POS user",
  backOfficeUserLoggedOut: "Back office user logged out",
  errorLoggingOut: "Error logging out",
  originalPIN: "Original PIN",
  enterOriginalPIN: "Enter original 6-digit PIN",
  originalPINRequired: "Original PIN is required",
  originalPINIncorrect: "Original PIN is incorrect",
  confirmPIN: "Confirm New PIN",
  confirmNewPIN: "Confirm new 6-digit PIN",
  confirmPINRequired: "Please confirm the new PIN",
  pinMismatch: "New PIN and confirm PIN do not match",
  notAvailable: "Not available",
  notSet: "Not set",
  profilePicture: "Profile Picture",
  changePIN: "Change PIN",
  newPIN: "New PIN",
  pinChanged: "PIN changed successfully",
  errorChangingPIN: "Error changing PIN",
  noPOSUser: "No POS User",
  firstName: "First Name",
  lastName: "Last Name",
  firstNameRequired: "First name is required",
  enterFirstName: "Enter first name",
  enterLastName: "Enter last name",
  selectServicesHelper: "Select which services this menu will be available for. Leave empty for this menu to apply for all services.",
  tableService: "Table Service",
  counter: "Counter",
  takeaway: "Takeaway",
  delivery: "Delivery",
  online: "Online",
  applicableHours: "Applicable Hours",
  applicableHoursHelper: "Set which hours this will be available for. If no hours entered, it is applicable at all times. Enter time in 24H format, e.g. 21:00 for 9:00pm. Ensure time slots do not overlap or close before they open.",
  applicableHoursOvernightHelper: "For overnight time windows (spanning midnight), set the close time in 24-hour format. For example, 11:00 to 03:00 means 11:00am to 3:00am the following day. Use the 24H Available checkbox if the item is available all day.",
  storeHours: "Store Hours",
  storeHoursHelper: "Set the regular operating hours for your store. These hours apply to all days unless overridden by Special Hours.",
  storeHoursSaved: "Store Hours Saved",
  storeHoursSavedSuccess: "Store hours have been saved successfully",
  errorFetchingStoreHours: "Error fetching store hours",
  errorSavingStoreHours: "Error saving store hours",
  saveStoreHours: "Save Store Hours",
  allChannelSameHours: "All Channel Same Hours",
  counterStoreHours: "Counter Store Hours",
  tableStoreHours: "Table Service Store Hours",
  takeawayStoreHours: "Takeaway Store Hours",
  deliveryStoreHours: "Delivery Store Hours",
  onlineStoreHours: "Online Store Hours",
  saveSpecialHours: "Save Special Hours",
  specialHours: "Special Hours",
  specialHoursHelper: "Set date ranges with custom operating hours. These override the regular Store Hours for the specified date ranges.",
  specialHoursSaved: "Special Hours Saved",
  specialHoursSavedSuccess: "Special hours have been saved successfully",
  errorFetchingSpecialHours: "Error fetching special hours",
  errorSavingSpecialHours: "Error saving special hours",
  addSpecialHours: "Add Special Hours",
  nextDay: "Next Day",
  openTime: "Open Time",
  closeTime: "Close Time",
  dateRequired: "Date Required",
  pleaseSelectDate: "Please select a date for all special hours",
  pleaseSelectFromToDate: "Please select both from and to dates for all special hours",
  fromDate: "From",
  toDate: "To",
  invalidDateRange: "Invalid Date Range",
  toDateAfterFromDate: "To date must be on or after from date",
  timeRequired: "Time Required",
  pleaseEnterOpenCloseTime: "Please enter both open and close times",
  addTimeSlot: "Add Time Slot",
  addTimeWindow: "Add Time Window",
  activeTimeWindows: "Active Time Windows",
  day: "Day",
  open: "Open",
  hour24: "24 Hour",
  hour24Available: "24H Available",
  noLimit: "No Limit",
  invalidTimeFormat: "Invalid time format",
  use24HFormat: "Please use 24H format (e.g., 21:00)",
  invalidTimeRange: "Invalid time range",
  closeAfterOpen: "Close time must be after open time",
  overlappingSlots: "Overlapping time slots",
  noOverlapSameDay: "Time slots cannot overlap on the same day",
  enableAgeRestrictedAccess: "Enable Age Restricted Access",
  ageRestrictedHelper: "Enabling this will only allow logged in customers with their age verified to order from this menu. Age verification must be enabled for this feature to work.",
  enablePreOrdersOnly: "Enable Pre-orders Only",
  preOrdersOnlyHelper: "Enabling this will disable immediate orders for this menu and require that people pre-order according to the conditions below.",
  preOrderDaysInAdvance: "Pre-order Days In Advance",
  preOrderDaysHelper: "Ensures customers must pre-order items from this menu a certain amount of days in advance.",
  preOrderCutoffTime: "Pre-order Cutoff Time (24H Format)",
  preOrderCutoffHelper: "Use in conjunction with the above option to ensure customers must place orders before a certain time on the last pre-order day.",
  uniqueNameForCategory: "A unique name for your category",
  categoryDescriptionPlaceholder: "Tell your customers more details about this category",
  categoryDescriptionHelper: "Tell your customers more details about this category",
  hideUnavailableCategory: "Hide Unavailable Category",
  hideUnavailableCategoryHelper: "Enabling this will hide this category in your menu if it's unavailable. Otherwise, this category will still be displayed with a warning message that it is not available.",
  selectServicesCategoryHelper: "Select which services this category will be available for. Leave empty to apply for all services. Please double-check with the parent menu's Services setting in Conditions tab because it has a higher priority when any conflict happened.",
  applicableHoursCategoryHelper: "Set which hours this category will be available for. If no hours entered, the category is applicable at all times. Enter time in 24H format, e.g. 21:00 for 9:00pm. Ensure time slots do not overlap or close before they open. Please double-check with the parent menu's Applicable Hours setting in Conditions tab because it has a higher priority when any conflict happened.",
  imageAndTags: "Image & Tags",
  optionsAndIngredients: "Options & Ingredients",
  image: "Image",
  imageUrlPlaceholder: "Image URL (including https://)",
  upload: "Upload",
  customImage: "Custom Image",
  remoteImageUrl: "Remote Image URL",
  fileNameRestriction: "File name can't contain special characters. Only letters and numbers are allowed.",
  errorLoadingImage: "Error loading image",
  imageLoadError: "Failed to load image. Please check the URL or try uploading again.",
  noImageSelected: "No image selected",
  itemName: "Item name",
  itemDescription: "Item description",
  categoryRequired: "Category is required",
  menuRequired: "Menu is required",
  advanceOptionSetting: "Advance Option",
  itemTags: "Item Tags",
  templates: "Templates",
  csvExport: "CSV Export",
  csvImport: "CSV Import",
  errorLoadingMenus: "Error loading menus",
  menuChangesRequireOnline: "Menu changes can only be made when online. Please check your internet connection.",
  unauthorizedAccess: "Unauthorized access",
  bulkEditPricesMode: "Bulk Edit Prices Mode",
  copy: "Copy",
  paste: "Paste",
  copiedToClipboard: "Copied to clipboard",
  pastedFromClipboard: "Pasted from clipboard",
  errorPasting: "Error pasting",
  pricesUpdated: "Prices updated",
  noChanges: "No changes to save",
  errorSavingPrices: "Error saving prices",
  saving: "Saving...",
  available: "Available",
  noStock: "No Stock",
  hide: "Hide",
  reordered: "Reordered",
  rearrangeHelper: "Drag and drop to reorder menus, categories, and items",
  optionsAndIngredientsComingSoon: "Options & Ingredients coming soon",
  selectMenu: "Select menu",
  selectCategory: "Select category",
  imageUploaded: "Image uploaded",
  errorUploadingImage: "Error uploading image",
  pleaseLogIn: "Please log in to upload images",
  authenticationFailed: "Authentication failed. Please log in again.",
  storageNotInitialized: "Firebase Storage is not initialized",
  uploadFailed: "Upload failed. Please check your internet connection and try again.",
  pleaseEnterValidUrl: "Please enter a valid URL",
  // Reservations
  reservations: "Reservations",
  reservationManagement: "Manage customer reservations",
  newReservation: "New Reservation",
  editReservation: "Edit Reservation",
  reservationDate: "Reservation Date",
  reservationTime: "Reservation Time",
  numberOfGuests: "Number of Guests",
  assignTable: "Assign Table (Optional)",
  reservationNotes: "Notes",
  confirmReservation: "Confirm Reservation",
  seatCustomer: "Seat Customer",
  cancelReservation: "Cancel Reservation",
  reservationStatus: "Status",
  pending: "Pending",
  confirmed: "Confirmed",
  seated: "Seated",
  cancelled: "Cancelled",
  noShow: "No Show",
  completed: "Completed",
  upcomingReservations: "Upcoming Reservations",
  upcoming: "Upcoming",
  reservationCount: "Count",
  timeChangedFromTo: "From {from} to {to}",
  rescheduleAwaitingConfirmation: "Awaiting confirmation",
  todaysReservations: "Today's Reservations",
  noReservationsFound: "No reservations found",
  phoneRequiredForReservation: "Phone number is required for reservations",
  customerNameRequired: "Customer name is required",
  reservationDateRequired: "Reservation date is required",
  reservationDateMustBeTodayOrFuture: "Reservation date must be today or in the future",
  reservationTimeRequired: "Reservation time is required",
  numberOfGuestsRequired: "Number of guests is required (minimum 1)",
  selectTime: "Select Time",
  reservationCreated: "Reservation created",
  reservationUpdated: "Reservation updated",
  reservationConfirmed: "Reservation confirmed",
  reservationCancelled: "Reservation cancelled",
  reservationDeleted: "Reservation deleted",
  customerSeated: "Customer seated",
  searchReservations: "Search by name or phone...",
  allStatuses: "All Statuses",
  allDates: "All Dates",
  today: "Today",
  tomorrow: "Tomorrow",
  past: "Past",
  tryAdjustingFilters: "Try adjusting your filters",
  createFirstReservation: "Create your first reservation",
  unknownCustomer: "Unknown Customer",
  moreOptions: "More options",
  guests: "guests",
  loading: "Loading...",
  reservationConflictMessage: "This reservation was modified by another staff member. Do you want to overwrite their changes?",
  reservationWasModified: "The reservation was modified by another staff member. Please refresh and try again.",
  activeReservations: "reservations",
  clickToCreateReservation: "Click to create new reservation",
  decrease: "Decrease",
  increase: "Increase",
  partySize: "Party Size",
  partySizeRequired: "Party size is required (minimum 1)",
  staff: "staff",
  theGuest: "the guest",
  canceledByActor: "Canceled by {actor}",
  canceledByActorAt: "Canceled by {actor} at {time}",
  canceledByCustomer: "Canceled by the customer",
  canceledByCustomerAt: "Canceled by the customer at {time}",
  confirmedByCustomerAt: "Confirmed by the customer at {time}",
  updatedByCustomerAt: "Updated by the customer at {time}",
  acknowledgeCancellation: "Acknowledge cancellation",
  noShowRecordedAt: "No show recorded by {actor} at {time}",
  seatedByActorAt: "Seated by {actor} at {time}",
  partySizeChangedFromTo: "Party size changed from {from} to {to}",
  sortByStatus: "Sort by status",
  sortByStatusEnabled: "Sorting by status (click to disable)",
  selectCustomer: "Select customer",
  customerLanguage: "Language",
  english: "English",
  french: "French",
  sendConfirmation: "Send confirmation",
  confirmationSent: "Sent",
  confirmationNotSent: "Not sent",
  confirmationQueued: "Confirmation queued",
  syncPending: "Not synced",
  syncSynced: "Synced",
  syncFailed: "Sync failed",
  inStoreReservation: "In store",
  onlineReservation: "Online",
  websiteAddressMissing: "The website address is missing.",
  pauseServices: "Pause services",
  restOfDay: "Rest of the day",
  pauseUntilDate: "Until a date",
  pauseDateRange: "Date range",
  pauseStartDate: "Start date",
  pauseEndDate: "End date",
  tooBusy: "Too busy",
  closingEarly: "Closing early",
  equipmentUnavailable: "Equipment unavailable",
  privateEvent: "Private event",
  fullyBooked: "Fully booked",
  staffUnavailable: "Staff unavailable",
  reasonRequired: "Select a reason or enter a reason.",
  durationRequired: "Select a duration.",
  servicesPaused: "Services paused",
  until: "until",
  keyboardBackspace: "Backspace",
  keyboardTab: "Tab",
  keyboardCaps: "Caps Lock",
  keyboardEnter: "Enter",
  keyboardShift: "Shift",
  keyboardSpace: "Space",
  keyboardToggle: "Toggle virtual keyboard",
  keyboardFrench: "FR",
  keyboardEnglish: "EN",
  // End of Day
  endOfDay: "End of Day",
  endOfDayProcess: "End of Day Process",
  closeZeroBalanceOrders: "Close Zero Balance Orders",
  reconcileOpenOrders: "Reconcile Open Orders",
  reconcileOpenOrdersDescription: "Please reconcile all open orders before proceeding.",
  closeCashDrawer: "Close Cash Drawer",
  closeCashDrawerDescription: "Enter the end-of-day cash drawer amount (optional).",
  generateSalesReport: "Generate Sales Report",
  previewReport: "Preview Report",
  printReport: "Print Report",
  eodComplete: "End of Day Complete",
  eodCannotComplete: "Cannot complete End of Day",
  eodError: "Error",
  eodErrorClosingOrders: "Error closing zero balance orders",
  voidOrder: "Void",
  closeToCash: "Close to Cash",
  carryForward: "Carry Forward",
  goToOrder: "Go to Order",
  orderReconciled: "Order Reconciled",
  errorReconcilingOrder: "Error reconciling order",
  navigateToOrder: "Navigate to Order",
  pleaseCompleteOrderManually: "Please complete the order manually",
  allOrdersReconciled: "All orders have been reconciled.",
  remainingOrders: "Remaining orders",
  expectedCash: "Expected Cash",
  actualCash: "Actual Cash Amount",
  enterCashAmount: "Enter cash amount",
  difference: "Difference",
  skip: "Skip",
  continue: "Continue",
  cancel: "Cancel",
  complete: "Complete",
  processing: "Processing...",
  noZeroBalanceOrders: "No zero balance orders found.",
  generatingReport: "Generating report...",
  salesReportPreview: "Sales Report Preview",
  noDataAvailable: "No data available",
  ordersReconciled: "Orders Reconciled",
  savedCarts: "Parked Tickets",
  eodSavedCartsDescription: "Review and clear parked counter tickets. These are tickets with items but no submitted orders.",
  savedCartsCleared: "Parked Tickets Cleared",
  clearSessions: "Clear Sessions",
  eodClearSessionsDescription: "Sessions with no open orders will be cleared. Sessions with stayAlive or isStatic flags will be kept.",
  sessionsCleared: "Sessions Cleared",
  noSessionsToClear: "No sessions to clear",
  clearingSessions: "Clearing sessions...",
  readyToClear: "Ready to Clear",
  clearAll: "Clear All",
  cashDrawerAmount: "Cash Drawer Amount",
  reportReady: "Report is ready to print.",
  printingReport: "Printing Report",
  printJobQueued: "Print job has been queued.",
  // EOD Settings
  eodSettings: "End of Day Settings",
  autoCloseZeroBalance: "Auto-close zero balance orders",
  requireCashDrawer: "Require cash drawer count",
  requireAllReconciled: "Require all orders reconciled",
  allowCarryForward: "Allow order carry forward",
  autoLogoutAfterEOD: "Auto-logout after EOD",
  eodReportPrinter: "EOD Report Printer",
  selectPrinter: "Select printer",
  defaultPrinter: "Default",
  settingsSaved: "Settings Saved",
  eodSettingsSaved: "EOD settings saved successfully",
  errorSavingSettings: "Error saving settings",
  errorCompletingEOD: "Error completing End of Day",
  noOpenOrders: "No open orders found. All orders are completed.",
  // Simplified EOD translations
  eodReminderTitle: "Before closing the day, please review:",
  eodNoReminders: "No items to review. You can proceed with End of Day.",
  eodSavedCartsReminder: "You have {count} parked ticket(s) with items. Please clear them before closing the day.",
  unclosedOrders: "Unclosed Orders",
  eodUnclosedOrdersReminder: "You have {count} unclosed or unpaid order(s). Please process them before closing the day.",
  unclosedDeliveryTables: "Unclosed Delivery Tables",
  eodUnclosedDeliveryReminder: "You have {count} unclosed delivery table(s). Please close them before closing the day.",
  eodReminderNote: "You can close this dialog, clean up the items above, and return to continue End of Day.",
  posSalesReport: "POS Sales Report",
  posSalesOnly: "(POS Sales Only - Excludes Online Orders)",
  closeDay: "Close Day",
  eodDayClosed: "Day closed successfully. The next day has started.",
  errorGeneratingReport: "Error generating sales report",
  eodCannotProceed: "Cannot Proceed",
  eodMustCleanUp: "You must clean up all parked tickets, unclosed orders, and unclosed delivery tables before proceeding.",
  localPrint: "Local Print",
  noPrinterConfigured: "No printer configured for POS Sales Report. Please configure a printer with POS Sales Report enabled in printer settings.",
  errorPrintingReport: "Error printing sales report",
  print: "Print",
  // Transaction History
  transactionHistory: "Cash Transaction History",
  cashTransactionHistory: "Cash Transaction History",
  startingCash: "Starting Cash",
  cashIn: "Cash In",
  cashOut: "Cash Out",
  netCashFlow: "Net Cash Flow",
  expectedCash: "Expected Cash",
  cashReceived: "Received",
  cashBalance: "Balance",
  inDrawer: "In drawer",
  fromCustomers: "From customers",
  changeGiven: "Change given",
  cashInMinusOut: "In - Out",
  startingCashUpdated: "Starting cash balance updated",
  errorSavingStartingCash: "Error saving starting cash balance",
  noTransactionsFound: "No transactions found",
  orderId: "Order ID",
  dateTime: "Date/Time",
  tableOrCounter: "Table",
  orderTotal: "Total",
  refresh: "Refresh",
  // OEM Settings
  oem: "OEM",
  oemManagement: "OEM Management",
  oemDescription: "Manage white-label branding configurations",
  createOEM: "Create OEM",
  editOEM: "Edit OEM",
  deleteOEM: "Delete OEM",
  deleteOEMConfirmation: "Are you sure you want to delete this OEM? This action cannot be undone.",
  brandName: "Brand Name",
  customDomain: "Custom Domain",
  customDomainHelp: "Enter the full domain that will access this OEM (without https://)",
  searchOEM: "Search by brand name, domain, or email...",
  noOEMsFound: "No OEMs found",
  noOEMsYet: "No OEMs created yet",
  contactInformation: "Contact Information",
  logo: "Logo",
  uploadLogo: "Upload Logo",
  changeLogo: "Change Logo",
  welcomeToNuagePos: "Welcome to NuagePOS Eagle",
  poweredBy: "Powered by",
  // Training Mode
  trainingMode: "Training Mode",
  stationTrainingOn: "Training mode on",
  stationTrainingHint: "Training is off until you turn it on. The POS user menu shows Training Mode only on this workstation.",
  exit: "Exit",
  exitAdminPinPrompt: "If you want to exit, please use the admin PIN to exit.",
  exitAdminPinWrong: "That PIN is not an admin PIN.",
  exitAdminPinUnavailable: "An admin PIN is not available on this workstation.",
  exitTrainingMode: "Exit Training Mode",
  enableTrainingMode: "Enable Training Mode",
  disableTrainingMode: "Disable Training Mode",
  trainingModeHasEnded: "Training Mode Has Ended",
  trainingModeExpired: "Training Mode Expired",
  trainingModeExpiredNote: "All training transactions have been completed. The system will refresh and return to normal operation.",
  returnToProductionMode: "Return to Production Mode",
  exitTrainingModeTitle: "Exit Training Mode?",
  exitTrainingModeDescription: "Are you sure you want to exit Training Mode? You will return to Production Mode and all training transactions will be completed.",
  exitTrainingModeNote: "You can always re-enable Training Mode later if needed. The system will refresh and return to normal operation.",
  trainingModeWarning: "Training Mode Warning",
  trainingModeNotForProduction: "This is Training Mode. It is not intended for production use.",
  trainingModeReadInfo: "Please read the following information before enabling Training Mode:",
  trainingModeTransactionMarked: "All transactions will be marked as training (FOR mode)",
  trainingModeNoAffectCounters: "Training transactions will not affect production sales counters",
  trainingModeIndependentSession: "Each user has their own independent training session",
  trainingModePurpose: "Training Mode is designed for learning and practice purposes only. All transactions will be sent to WEB-SRM but marked as training.",
  trainingModeEnabled: "Training Mode Enabled",
  cannotEnableTrainingMode: "Cannot Enable Training Mode",
  failedToExitTrainingMode: "Failed to exit Training Mode",
  userMenuDisabledInTrainingMode: "User menu disabled in Training Mode",
  trainingModeDuration: "Training Mode Duration (minutes)",
  trainingModeDurationDescription: "Set the duration for Training Mode sessions (1-90 minutes)",
  trainingModeDurationInvalid: "Please enter a valid duration between 1 and 90 minutes",
  trainingModeDurationUpdated: "Training Mode duration updated successfully",
  trainingModeDurationUpdateFailed: "Failed to save Training Mode duration",
  storeIdMissing: "Store ID is missing. Please refresh the page and try again.",
  storeDataNotLoaded: "Store data is not loaded. Please wait and try again.",
  trainingModeExpiredDescription: "Your Training Mode session has ended. You will now return to Production Mode.",
  trainingModeAutoExpire: "Training Mode will automatically expire",
  trainingModeEnabledDescription: "Your session will automatically expire.",
  sessionWillAutoExpire: "Your session will automatically expire.",
  minutes: "minutes",
  storeInformation: "Store Information",
  storeLogo: "Store Logo",
  sessionAndDisplaySettings: "Session & Display Settings",
  hideTopBar: "Hide top bar",
  hideTopBarHelp: "Hide the title bar when the POS is not in full screen.",
  hideTaskbar: "Hide taskbar",
  hideTaskbarHelp: "Hide the Windows taskbar when the POS is not in full screen.",
  regionalIntegrationSettings: "Regional & Integration Settings",
  siteLanguage: "Site Language",
  posDashboardCards: "POS Dashboard Cards",
  posInterfaceTheme: "POS Interface Theme",
  posInterfaceThemeHelp: "Select a theme, then press Confirm.",
  posThemeUpdated: "POS theme updated",
  posThemeNow: "The POS theme is now {name}.",
  posThemeUpdateFailed: "The POS theme was not updated.",
  posThemeCurrent: "Current",
  tableView: "Table View",
  modernView: "Toggle Classic/Modern View",
  viewModern: "View: Modern",
  viewClassic: "View: Classic",
  modernViewLabel: "Modern",
  classicViewLabel: "Classic",
  tableStyle: "Table style",
  tableLayoutTitle: "Table layout",
  tableLayoutDescription: "Arrange tables on the floor. Add a ready-made table, then drag it into place.",
  tableLayoutLiveDescription: "See live table status on the floor.",
  addTable: "Add table",
  addRoom: "Add room",
  addRoomSequence: "Room {room}. Tables on the shared sequence go up to {highest}.",
  addRoomSequenceEmpty: "Room {room}. No numbered tables are on the shared sequence yet.",
  addRoomContinue: "Continue from {next}",
  addRoomStartAtOne: "Start from 1",
  addRoomStartAt: "Start from",
  addRoomUseNumber: "Use this number",
  tableNameHint: "Up to 4 numbers, or 5 characters.",
  tableNameTooLong: "Use at most 4 numbers, or 5 characters.",
  selectSeat: "Select a seat",
  tableNoFloor: "This table has no floor plan.",
  tableNameSuggest: "One letter fits 999 tables, such as P001. Two letters fit 99 tables, such as VP01. Three letters, such as VIP1, fit 9 tables.",
  tableNameLimitTitle: "Table name length",
  roomLimit: "A floor can have 26 rooms, A through Z.",
  specialSetting: "Special setting",
  specialName: "Name",
  specialNameFixed: "The room name stays the same.",
  specialOneDate: "One date",
  specialDateRange: "Date range",
  specialStartDate: "Start date",
  specialEndDate: "End date",
  specialAllDay: "All day",
  specialSetHours: "Set hours",
  specialRooms: "Rooms",
  specialWeekend: "Every weekend",
  specialWeekdays: "Weekdays",
  specialDate: "Date",
  specialStart: "Start",
  specialEnd: "End",
  specialArrange: "Arrange",
  specialApply: "Apply now",
  specialNew: "New setting",
  specialAddNew: "Add New Setting",
  specialNoEffect: "This setting has no effect.",
  specialNoEffectShort: "No effect",
  specialOnSchedule: "On. The live floor uses this during its schedule.",
  specialScheduleTitle: "Schedule",
  specialInUse: "This setting is in use.",
  specialLater: "This setting is used later.",
  specialEverydayNow: "The everyday floor is in use.",
  specialEverydayFloor: "the everyday floor",
  specialEverydayBackDate: "The everyday floor returns on {date}.",
  specialEverydayBackTime: "The everyday floor returns at {time}.",
  specialEverydayOtherDays: "The everyday floor is used on the other days.",
  specialTurnOffEffect: "Turn off {name}. {room} uses {next}.",
  specialTurnOnEffect: "Turn on {name}. {room} uses {name}.",
  specialTurnOnWaits: "Turn on {name}. {room} keeps {next} until this schedule.",
  specialChooseFloor: "Choose the floor.",
  specialNoDates: "No dates yet.",
  specialEditTables: "Edit tables",
  specialEditTablesHelp: "Move, merge, or split the tables for {name}.",
  specialThisSetting: "This setting",
  specialSavedSchedule: "Saved schedule",
  specialNoScheduleYet: "No schedule saved yet.",
  specialStepWhen: "When this layout is used",
  specialStepWhenHelp: "Choose weekdays, one day, or a date range.",
  specialByOneDay: "One day",
  specialSelectDays: "Select the days.",
  specialSelectDay: "Select the day.",
  specialSelectRange: "Select the start date and the end date.",
  specialStepHours: "Hours",
  specialFloorStep: "Floor layout",
  specialEditFloor: "Edit floor layout",
  specialEditFloorHelp: "Change the floor layout for {name}.",
  specialEmpty: "No special setting yet.",
  specialUntitled: "Untitled",
  specialOnNow: "On now",
  specialOff: "Off",
  specialTurnOff: "Turn off",
  specialTurnOn: "Turn on",
  specialSaved: "Special setting saved",
  specialOverlap: "These rules overlap. The shorter time range is used.",
  specialMerge: "Merge",
  specialMergePick: "Click the tables. The first table keeps its name.",
  specialRoomTaken: "This room already has a special setting.",
  specialFloorLimit: "Each floor can have up to 7 special settings.",
  specialRoomCount: "{count} of {max}",
  specialRoomFull: "This floor already has 7 special settings.",
  specialMergeHelp: "The first table keeps its name. The others are hidden until this setting ends.",
  specialMergeNone: "No table of the same shape is close enough.",
  specialSplit: "Split",
  specialSplitHelp: "The original name stays on the first piece. Each piece has at least 2 seats.",
  specialNameShort: "Use a shorter table name first. A new piece must fit in 5 characters.",
  specialOrdersTitle: "Open orders",
  specialOrdersBody: "There are still open orders on these tables.",
  specialOrdersAsk: "Apply this layout?",
  specialProceed: "Proceed",
  specialMon: "Mon",
  specialTue: "Tue",
  specialWed: "Wed",
  specialThu: "Thu",
  specialFri: "Fri",
  specialSat: "Sat",
  specialSun: "Sun",
  specialAnd: "and",
  specialSaveSetting: "Save floor plan",
  specialSaveOnly: "This saves the special layout only. The everyday floor stays as it is.",
  specialOverlapTables: "Tables {names} are on top of each other. Move one of them, then save.",
  specialRevert: "Revert",
  specialIntro: "A special setting is a second layout for the rooms you choose. The everyday floor stays in place. The special layout is used only while this setting is on.",
  specialFollow: "Follow the schedule",
  specialUseNow: "Use this layout now",
  specialOffChoice: "Off",
  specialUseNowHelp: "The room switches as soon as you confirm. It does not wait for the clock. Open orders stay on their tables.",
  specialOffHelp: "This room uses the everyday floor until you choose one of the choices above.",
  specialArrangeLayout: "Arrange layout",
  specialEditSchedule: "Edit schedule",
  specialWeekdayTaken: "{day} is already {name}. Turn {name} off, or choose other days.",
  specialDateBeforeWeekday: "A date is used before a weekday. This date is used before {name}.",
  specialWeekdayAfterDate: "A date is used before a weekday. {name} is used before this weekday setting.",
  specialShorterWins: "The shorter date is used. This setting is used before {name} on the shared days.",
  specialShorterLoses: "The shorter date is used. {name} is used before this setting on the shared days.",
  specialSaveSchedule: "Save schedule",
  specialRoomStays: "The room name stays {name}.",
  specialRoomsStay: "The room names stay {names}.",
  specialWholeDay: "for the whole day",
  specialFromHours: "from {start} to {end}",
  specialWeekSentence: "On {days}, {hours}, this room uses the special layout. At any other time it uses the everyday floor.",
  specialDateSentence: "On {date}, {hours}, this room uses the special layout. At any other time it uses the everyday floor.",
  specialRangeSentence: "From {startDate} through {endDate}, {hours}, this room uses the special layout. At any other time it uses the everyday floor.",
  roomName: "Room name",
  room: "Room",
  mainHall: "Main hall",
  roomHasTables: "Move tables out of this room before deleting it.",
  numberSeats: "Number seats",
  chooseStartSeat: "Click the start seat. Numbers continue clockwise.",
  rotateTable: "Rotate",
  done: "Done",
  presetSmallSquare: "Small square table",
  presetSmallRect: "Small rectangular table",
  presetRect: "Rectangular table",
  presetMediumSquare: "Medium square table",
  presetBooth: "Booth",
  presetRound: "Round table",
  presetBanquette: "Wall banquette",
  presetBar: "Bar seating",
  presetLargeRect: "Large rectangular table",
  presetLargeRound: "Large round table",
  presetCommunal: "Communal table",
  presetHighTop: "High-top table",
  presetWall: "Wall",
  presetWallArc: "Curved wall",
  presetWallL: "L wall",
  presetWallLFlip: "Opposite L wall",
  length: "Length",
  maxSessions: "Max sessions",
  sessionInterval: "Session interval (min)",
  qrCardView: "QR card view",
  liveTableView: "Live table",
  tableSize: "Table size",
  seatCountLabel: "{count} seats",
  sortTimeLongest: "Longest",
  sortTimeShortest: "Shortest",
  sortGuestsMost: "Most guests",
  sortGuestsFewest: "Fewest guests",
  sortTableNumber: "Table",
  openTable: "Open",
  startTable: "Start",
  shapeRound: "Round",
  shapeSquare: "Square",
  shapeRect: "Rectangular",
  shapeBooth: "Booth",
  shapeBar: "Bar",
  sortAsc: "Asc",
  sortDesc: "Desc",
  last14Days: "Last 14 days",
  sales: "Sales",
  todaySales: "Today's sales",
  todayOrders: "Today's orders",
  averageTicket: "Average ticket",
  analyticsPosSales: "POS sales",
  analyticsOnlineSales: "Online sales",
  analyticsByChannel: "Sales by channel",
  analyticsByCategory: "Sales by category",
  analyticsByItem: "Sales by item",
  analyticsBestSelling: "Best selling",
  analyticsFirebaseCount: "Count",
  analyticsYesterday: "Yesterday",
  analyticsLast7Days: "Last 7 days",
  analyticsLast30Days: "Last 30 days",
  analyticsThisYear: "This year",
  analyticsPreviousYear: "Previous year",
  analyticsPastYear: "Past year",
  analyticsCustomRange: "Custom",
  analyticsFrom: "From",
  analyticsTo: "To",
  analyticsNoSales: "No paid sales in this period.",
  analyticsDeletedCarts: "Deleted carts",
  analyticsNoDeletedCarts: "No deleted carts in this period.",
  analyticsLatestOrders: "Latest paid orders",
  analyticsClearFilter: "Show all",
  analyticsShowing: "Showing",
  analyticsQty: "Qty",
  analyticsUncategorized: "Uncategorized",
  analyticsLocalDelivery: "Local delivery",
  analyticsOnlinePickup: "Online pickup",
  analyticsOnlineDelivery: "Online delivery",
  analyticsUberEats: "Uber Eats",
  analyticsUberEatsPickup: "Uber Eats pickup",
  analyticsDoorDash: "DoorDash",
  analyticsDoorDashPickup: "DoorDash pickup",
  analyticsLoadError: "Sales could not be loaded.",
  analyticsSalesTab: "Sales",
  tableAnalysis: "Table Analysis",
  tablePerformance: "Table Performance",
  openTables: "Open Tables",
  tableVisits: "Visits",
  averageTurnover: "Average turnover",
  averagePerVisit: "Average per visit",
  tableTurnoverHint: "Completed parties per table, including tables with no visits.",
  mostUsedTable: "Most used",
  tablesWithNoVisits: "tables had no visits",
  tableWithNoVisits: "had no visits",
  noTableVisits: "No completed table visits in this period.",
  lunchPeriod: "Lunch",
  dinnerPeriod: "Dinner",
  otherPeriod: "Other",
  tableClockPeriods: "Lunch is 11:00–15:59. Dinner is 16:00–21:59. Times follow the store clock.",
  allRooms: "All rooms",
  tableReportTruncated: "This range includes more orders than the report can load. Choose a shorter range.",
  tableReportLoadError: "Table sales could not be loaded.",
  tableLast3Months: "Last 3 months",
  tableLastYear: "Last year",
  tableSummaryNotReady: "This period is not ready yet.",
  tableSummaryPartial: "Some days in this period are not ready yet.",
  unpaidTables: "Unpaid",
  noOpenTables: "No tables are open.",
  tableVisitClosed: "Time",
  tableNumber: "Table #",
  guestCount: "Guests",
  adjustGuestCount: "Adjust guest count",
  findCustomer: "Find customer",
  customerSearchPlaceholder: "Name or phone number",
  changeCustomer: "Change",
  removeCustomer: "Remove",
  closedAt: "Closed at",
  totalTaxIn: "Total (tax in)",
  menuManagementSection: "Menu Management",
  ruleManagement: "Rule Management",
  pricingAndFees: "Pricing & Fees",
  taxesAndFees: "Taxes & Fees",
  guestGroups: "Guest groups",
  taxesHeading: "Taxes",
  taxesInfoItems: "The tax name, rate, and fiscal type come from Super Admin. This store chooses the items and may use its own exemption.",
  taxSetByAdmin: "The name, rate, and fiscal type are set in Super Admin.",
  editItemTaxes: "Edit item taxes",
  taxExemptionGlobal: "Super Admin: {status}",
  taxExemptionWarningTitle: "Warning – Tax Exemption Override",
  taxExemptionWarningBody1: "Tax exemptions are controlled globally. Overriding this setting for an individual store may result in non-compliance with Revenu Québec regulations if a valid tax exemption does not apply.",
  taxExemptionWarningBody2: "Unauthorized or incorrect tax exemptions may result in audits, penalties, fines, or other enforcement measures by Revenu Québec.",
  taxExemptionWarningBody3: "By saving this change, you acknowledge that you are responsible for ensuring the exemption is legally valid and that all applicable taxes are correctly charged and reported.",
  taxExemptionAgree: "I agree to take the responsibility.",
  taxExemptionWarningConfirm: "You agreed to take responsibility for this store's tax exemption.",
  taxExemptionOverrideClosed: "Super Admin has not allowed this store to change the exemption.",
  taxOverrideAllowed: "Super Admin has allowed this store to change this tax.",
  taxExemptionStandard: "This store uses the standard exemption from Super Admin.",
  taxExemptionUseStore: "Use a store exemption",
  taxExemptionUseStandard: "Use the standard exemption",
  taxExemptionStoreOwn: "This store uses its own exemption. The standard exemption still applies to other stores.",
  taxesInfoFiscal: "The fiscal type sets the tax code on the bill: F federal, P provincial, S additional.",
  taxNameN: "Tax name {n}",
  taxRatePercent: "Rate (%)",
  taxCustomName: "Custom name",
  taxCustomNamePlaceholder: "Enter a tax name",
  taxFiscalType: "Fiscal type",
  taxFiscalFederal: "Federal (F)",
  taxFiscalProvincial: "Provincial (P)",
  taxFiscalAdditional: "Additional (S)",
  taxExemptionRules: "Exemption rules",
  taxExemptionFor: "{tax} exemption",
  taxExemptionActive: "Active",
  taxExemptionStatusOff: "Not active. This rule has no effect. The normal rate applies.",
  taxExemptionStatusUpcoming: "Active. The rule starts on {from}.",
  taxExemptionStatusActive: "Active. The rule is in effect now, until it is turned off.",
  taxExemptionStatusActiveUntil: "Active. The rule is in effect now, until {to}.",
  taxExemptionStatusEnded: "Active. The rule ended on {to}. The normal rate applies.",
  taxExemptStart: "Start date and time",
  taxExemptEnd: "End date and time",
  taxExemptionRate: "Rate during exemption (%)",
  taxExemptionHelp: "Leave the end empty to keep the rule until it is turned off.",
  taxExemptionStartRequired: "Enter the start date and time.",
  taxExemptionOrder: "The end must be after the start.",
  taxExemptionSaved: "Exemption rule saved",
  taxExemptionSaveError: "The exemption rule could not be saved",
  taxSelectItems: "Select items ({n})",
  taxItemsTitle: "Items with {tax}",
  taxItemsSelectedCount: "{n} items selected",
  taxesSaved: "Taxes saved",
  taxesSaveError: "Taxes could not be saved",
  editTaxes: "Edit taxes",
  itemTaxes: "Taxes",
  previousPage: "Previous",
  nextPage: "Next",
  pageOfPages: "Page {page} of {pages}",
  guestGroupsHelp: "Count guests by group. Groups are by age by default. Rename them or add groups for other criteria.",
  guestGroupName: "Group name",
  guestGroupNamePlaceholder: "Group name",
  guestGroupAbbreviation: "Abbreviation",
  guestGroupNameRequired: "Enter a group name.",
  guestGroupAbbreviationRequired: "Enter 1 to 3 letters.",
  guestGroupAbbreviationDuplicate: "This abbreviation is already used.",
  addGuestGroup: "Add group",
  deleteGuestGroup: "Delete group",
  guestGroupsSaved: "Guest groups saved",
  guestGroupsSaveError: "Guest groups could not be saved",
  orderRulesCustomization: "Order Rules & Customization",
  menuDisplay: "Menu display",
  recipe: "Recipe",
  recipeMenuItems: "Menu items",
  recipeBack: "Back",
  recipeUnassigned: "Unassigned",
  recipeCount: "recipes",
  recipeIngredients: "Ingredients",
  recipeReports: "Reports",
  recipeAll: "All",
  recipeMissing: "Missing recipe",
  recipeHasRecipe: "Has recipe",
  recipeStatus: "Status",
  recipeInUse: "In use",
  recipeDraft: "Draft",
  recipeStartsOn: "Starts on",
  recipeEnded: "Ended",
  recipeNone: "No recipe",
  recipeEstimatedCost: "Estimated cost",
  recipeSaveRecipe: "Save recipe",
  recipeSaveDraft: "Save draft",
  recipeCopyTo: "Copy to other dishes",
  recipeCopyFrom: "Copy from another item",
  recipeCreateIngredient: "Create ingredient",
  recipeMaterialNumber: "Material number",
  recipeMaterialNumberHint: "6 digits, for example 000123. This number links to the material you buy.",
  recipeMaterialNumberInvalid: "Enter 6 digits or leave the material number blank.",
  recipeMaterialNumberDuplicate: "Another ingredient already uses this material number.",
  recipeBaseUnit: "Unit",
  recipeCategory: "Category",
  recipeActive: "Active",
  recipeInactive: "Inactive",
  recipePurchaseUnit: "Purchase unit",
  recipePurchaseCost: "Purchase cost",
  recipePurchaseQuantity: "Quantity in the recipe unit",
  recipeCost: "Cost",
  recipeCostPerUnit: "Cost per unit",
  recipeEffectiveDate: "Effective date",
  recipeQuantity: "Quantity",
  recipeLineCost: "Line cost",
  recipeTotalCost: "Estimated cost",
  recipeAddLine: "Add",
  recipeSearchIngredient: "Search by name or material number",
  recipeNoMatch: "No matching ingredient.",
  recipeKeepTyping: "Keep typing to narrow the list.",
  recipeMoreSettings: "More settings",
  recipePortionCount: "Portions this recipe makes",
  recipeNote: "Note",
  recipeSaveItemFirst: "Save the item before adding a recipe.",
  recipePreparedIngredients: "Prepared ingredients",
  recipePreparedHelp: "Show ingredients your kitchen prepares in batches.",
  recipePreparedLater: "Batch recipes will be added in a later update.",
  recipeViewOnly: "This version has ended. Earlier quantities stay unchanged.",
  recipeOverlap: "These dates overlap another version. Choose a later start date.",
  recipeCopied: "Recipe copied.",
  recipeSaved: "Recipe saved.",
  recipeSavedDraft: "Draft saved.",
  recipeIngredientSaved: "Ingredient saved.",
  recipeName: "Ingredient",
  recipeNext: "Next",
  recipePrevious: "Previous",
  recipeConsumption: "Theoretical use",
  recipeTheoreticalCost: "Theoretical cost",
  recipeFoodCostPercent: "Food cost",
  recipeGrossProfit: "Gross profit",
  recipeRevenue: "Recipe sales",
  recipeUnmatchedRefunds: "Refunds without item detail",
  recipeNoRecipeSales: "Sold items without a recipe",
  recipeReportHelp: "Estimates ingredient use from paid sales. Refunds are included when the original order was created within 31 days before the start date. This report does not change stock.",
  recipeDateFrom: "From",
  recipeDateTo: "To",
  recipeRunReport: "Run report",
  recipeByIngredient: "By ingredient",
  recipeByItem: "By dish",
  recipeEmptyReport: "No paid sales with a recipe in this date range.",
  recipeSelectDishes: "Select dishes",
  recipeConfirmCopy: "Copy recipe",
  recipeCopyHelp: "Each dish keeps its own copy. Earlier versions stay unchanged.",
  recipeStartsOnHelp: "Earlier dates stay on the previous version.",
  recipeLibraryEmpty: "No ingredients yet.",
  recipeAddIngredient: "Add ingredient",
  recipeEditIngredient: "Edit ingredient",
  recipeRequiredName: "Enter an ingredient name.",
  recipeRemove: "Remove",
  recipeVersion: "Version",
  recipeLoading: "Loading recipe.",
  recipeOffline: "Recipe changes need a connection.",
  recipeConflict: "This recipe was updated. Load it again, then save.",
  recipeClosed: "An ended version cannot be changed.",
  recipeInvalid: "Check the quantities and the start date.",
  recipeNoSource: "That dish has no recipe to copy.",
  recipeCopyFailed: "Some dishes were not copied.",
  recipeDish: "Dish",
  recipeNetSold: "Net sold",
  recipeNoItems: "No menu items match this filter.",
  recipeCostMissing: "Add a cost to calculate the total.",
  recipeUnitMismatch: "Choose a unit in the same family as the ingredient.",
  recipePortionInvalid: "Enter a portion count greater than zero.",
  recipeSearchDishes: "Search dishes",
  recipeNothingSelected: "Select at least one dish.",
  recipeOpen: "Edit recipe",
  showPosItemPictures: "Show pictures in POS",
  showPosItemPicturesHelp: "Product cards show a photo. Turn this off to show the name only.",
  showCategoryPagePictures: "Show pictures on the category page",
  showCategoryPagePicturesHelp: "Category cards show a photo. Turn this off to show the name only.",
  favoriteCategories: "Favorite categories",
  noFavoriteCategories: "No favorite categories",
  toggleCategoryFavorite: "Favorite",
  categoryActions: "Category actions",
  posPicturesOn: "Pictures are on",
  posPicturesOff: "Pictures are off",
  posPicturesSyncFailed: "The POS on this computer is updated. The store copy will update when the connection returns.",
  showPosAddButton: "Show add button",
  showPosAddButtonHelp: "A plus button sits on each product. Turn this off to add an item by tapping the card.",
  posAddButtonOn: "Add button is on",
  posAddButtonOff: "Add button is off",
  showPosItemPrice: "Show price",
  showPosItemPriceHelp: "Product cards show the price. Turn this off to hide the price.",
  posItemPriceOn: "Price is on",
  posItemPriceOff: "Price is off",
  pricingAndRounding: "Pricing & Rounding",
  orderPreferences: "Order Preferences",
  corePrintSettings: "Core Print Settings",
  additionalSettings: "Additional Settings",
  qrTable: "QR Table",
  qrCodePrintSettings: "QR Code Print Setting",
  additionalQrSettings: "Additional QR Setting",
  qrCodePresenting: "QR Code Presenting",
  printersList: "Virtual printer list",
  cupLabelSection: "Cup label",
  cupLabelTemplateTitle: "Cup Label Template",
  cupLabelTemplates: "Templates",
  cupLabelAdd: "Add template",
  cupLabelName: "Name",
  cupLabelEnabled: "Enabled",
  cupLabelDisabled: "Disabled",
  cupLabelMedia: "Paper",
  cupLabelSticky: "Sticky label",
  cupLabelReceipt: "Receipt paper",
  cupLabelLiner: "Linerless paper",
  cupLabelStickyHelp: "Die-cut sticker with a fixed width and height.",
  cupLabelReceiptHelp: "Thermal paper. Glue can be added to the label.",
  cupLabelLinerHelp: "Continuous adhesive paper. The label length grows with the text.",
  cupLabelSize: "Label size",
  cupLabelCustom: "Custom",
  cupLabelWidth: "Width (mm)",
  cupLabelHeight: "Height (mm)",
  cupLabelReceiptWidth: "Receipt paper uses the printer paper width.",
  cupLabelFont: "Text size",
  cupLabelRotate: "Rotate 90° clockwise",
  cupLabelRotateHelp: "The paper curve matches the cup. Words run with the paper, top to bottom.",
  cupLabelCompact: "Compact",
  cupLabelRegular: "Regular",
  cupLabelLarge: "Large",
  cupLabelLines: "Lines",
  cupLabelDrag: "Drag to arrange",
  cupLabelRowHelp: "Drag a field onto a row. Fields on the same row print together. The number prints when it is more than 1.",
  cupLabelItemName: "Item name",
  cupLabelOption: "Option",
  cupLabelAdvanceOption: "Advance option",
  cupLabelAdvanceQty: "Number",
  cupLabelOrderNumber: "Order number",
  cupLabelDrinkName: "Drink name",
  cupLabelSizeField: "Drink size",
  cupLabelQuantity: "Quantity",
  cupLabelModifiers: "Modifiers",
  cupLabelCustomer: "Customer name",
  cupLabelTime: "Time",
  cupLabelSource: "Order source",
  cupLabelStoreName: "Store name",
  cupLabelSequence: "Item sequence",
  cupLabelInstructions: "Special instructions",
  cupLabelPreview: "Preview",
  cupLabelFitWarning: "This label does not fit. Turn off a line or use a larger label.",
  cupLabelSaved: "Cup Label Template saved",
  cupLabelSavedLocal: "Saved on this computer. The store copy will update when the connection returns.",
  cupLabelSaveFailed: "Cup label template was not saved",
  cupLabelNameRequired: "Enter a template name.",
  cupLabelTemplate: "Template",
  cupLabelNoTemplate: "No template",
  cupLabelCreateTemplate: "Create a template in Cup Label Template.",
  cupLabelEmpty: "No templates yet.",
  cupLabelConfirmDelete: "Confirm delete",
  webhooksIntegration: "Webhooks Integration",
  customerExperience: "Customer Experience",
  dataManagement: "Data Management",
  exportData: "Export Data",
  downloadMenuJson: "Download menu JSON",
  uploadMenuJson: "Upload menu JSON",
  menuJsonPasteHere: "Paste JSON here",
  menuJsonUsePasted: "Use pasted JSON",
  menuJsonPasted: "Pasted JSON",
  menuJsonChooseMenu: "Choose a menu",
  menuJsonCreateNew: "Create new menu",
  menuJsonNewMenuName: "Menu name",
  menuJsonDownload: "Download JSON",
  menuJsonDownloading: "Downloading...",
  menuJsonDownloaded: "Menu JSON downloaded.",
  menuJsonDownloadFailed: "Menu JSON could not be downloaded.",
  menuJsonLoadMenusFailed: "Menus could not be loaded.",
  menuJsonDishCountFile: "{0} dishes",
  menuJsonDishPosition: "Dish {0} of {1}",
  menuJsonPreview: "Preview",
  menuJsonStep1: "Step 1. Preview and create",
  menuJsonStep2: "Step 2. Sync pictures and the menu",
  menuJsonStep3: "Step 3. Refresh the register",
  menuJsonPreviewCreate: "Preview and create",
  menuJsonSync: "Sync",
  menuJsonSyncing: "Syncing. Stay on this screen.",
  menuJsonSyncDone: "The menu is on the register.",
  menuJsonSyncFailed: "Sync could not finish.",
  menuJsonPreviewFailed: "The preview could not be opened.",
  menuJsonNoDishes: "This file has no dishes.",
  menuJsonBadFile: "Choose a menu JSON file.",
  menuJsonUntitled: "Untitled dish",
  menuJsonCategoryMissing: "This category is not on the selected menu: {0}",
  menuJsonCategoryWillCreate: "This category will be added to the menu: {0}",
  menuJsonCategoryRequired: "A category is required.",
  menuJsonSameName: "When the name already exists",
  menuJsonOverwrite: "Overwrite",
  menuJsonIgnore: "Ignore",
  menuJsonKeepBoth: "Keep both",
  menuJsonDuplicateOverwrite: "This name is already on the menu. Next will update it.",
  menuJsonDuplicateIgnore: "This name is already on the menu. Next will leave it unchanged.",
  menuJsonDuplicateKeep: "This name is already on the menu. Next will add another dish.",
  menuJsonDishUpdated: "Dish updated.",
  menuJsonLeftUnchanged: "The existing dish was left unchanged.",
  menuJsonNameRequired: "A name is required.",
  menuJsonPriceRequired: "A price is required.",
  menuJsonCombo: "Combo",
  menuJsonComboMissing: "These combo dishes are not on the menu yet: {0}",
  menuJsonPictureNotSaved: "The picture for {0} was not saved.",
  menuJsonPictureNotDownloaded: "The picture was not downloaded. The dish was saved without a picture.",
  menuJsonNoPicture: "No picture",
  menuJsonCreating: "Creating...",
  menuJsonDishCreated: "Dish created.",
  menuJsonCreateFailed: "This dish could not be created.",
  menuJsonReviewComplete: "All dishes were reviewed.",
  menuJsonReviewCompleteDetail: "Choose Sync. Pictures are saved, then the register menu is refreshed.",
  tableManagement: "Table Management",
  cloudStorageOperations: "Cloud Storage Operations",
  onlineOrdering: "Online ordering",
  onlineOrderingDescription: "Online ordering settings are stored per store.",
  orderTypes: "Order types",
  guestPayments: "Guest payments",
  eTransferReceived: "E-Transfer Received",
  paymentStatusPending: "Pending",
  paymentStatusReceived: "Received",
  paymentAutoAssigned: "Auto assigned",
  paymentReceived: "Payment Received",
  updatePaymentStatus: "Update payment status",
  mevSection: "MEV (online order without a payment method)",
  mevUnconfirmedIntro: "If the payment method on an online order is not updated manually, the selected rule applies.",
  mevRuleComplete: "On completion",
  mevRuleCompleteHelp: "When the order is completed, send the receipt with the default payment method.",
  mevRuleTime: "After a set time",
  mevRuleTimeHelp: "When this time passes without a payment update, send the receipt with the default payment method.",
  mevRuleManual: "Manual only",
  mevRuleManualHelp: "Send the receipt only after staff update the payment status.",
  mevDelayMinutes: "Minutes",
  mevDefaultPaymentMethod: "Default payment method",
  noEnabledPaymentMethods: "No payment methods are enabled.",
  printReceipt: "Print receipt",
  receiptSentWhenPaid: "The receipt is sent when payment is received",
  transmittedToRevenuQuebec: "Transmitted to Revenu Québec",
  rqReturnNumber: "Return number",
  rqReturnDate: "Return date",
  rqReceiptEmail: "Receipt email",
  rqWaiting: "Waiting for Revenu Québec",
  receiptSentTo: "Electronic receipt sent to {email}",
  receiptQueuedFor: "Waiting to send the electronic receipt to {email}",
  storeDefaults: "Store defaults",
  guestPage: "Guest page",
  connectedApps: "Connected apps",
  storeProfile: "Store profile",
  addressAndHours: "Address & hours",
  discountsAndPromos: "Discounts & Promos",
  extraCharges: "Extra charges",
  termsAndConditions: "Terms & Conditions",
  orderEmails: "Order emails",
  newOrderSound: "New-order sound",
  guestSignIn: "Guest sign-in",
  tips: "Tips",
  orderFlow: "Order flow",
  extra: "Extra",
  takeout: "Takeout",
  waitingForKitchenOrders: "Waiting for orders",
  systemLocale: "System Locale",
  kilometresMiles: "Kilometres/Miles",
  kilometres: "Kilometres",
  miles: "Miles",
  timezone: "Timezone",
  timeFormatting: "Time Formatting",
  twelveHour: "12 Hour",
  twentyFourHour: "24 Hour",
  dateFormatting: "Date Formatting",
  taxInPrices: "Tax In Prices",
  taxOnTips: "Tax On Tips",
  firstDayOfTheWeek: "First day of the week",
  enableTaxInPricesDescription: "Enable this if your store prices already include tax.",
  enableTaxOnTipsDescription: "Enable this to charge taxes on tips.",
  menuSettingsDescription: "Manage categories, menu layout, and pricing.",
  orderSettingsDescription: "Manage order rules, rounding, and checkout preferences.",
  categoriesAndPricing: "Categories",
  manageOrder: "Manage order",
  noItems: "No items",
  tax: "Tax",
  deliveryFee: "Delivery fee",
  orderDetailReprint: "Reprint",
  orderDetailRefund: "Refund",
  orderDetailModifyPayment: "Modify",
  orderDetailDone: "Done",
  orderDetailChannel: "Channel",
  orderDetailStaff: "Staff",
  orderDetailItems: "Items",
  orderDetailRefundHistory: "Refund history",
  orderDetailStatusSubmitted: "Submitted",
  orderDetailStatusCompleted: "Completed",
  orderDetailStatusCanceled: "Cancelled",
  orderDetailPrintFailed: "Print failed",
  orderDetailNoRefundableItems: "No items available for refund",
  orderDetailAllItemsRefunded: "All items in this order have already been refunded.",
  orderDetailRefundProcessed: "Refund processed",
  orderDetailCreditNotePrinted: "Credit note printed",
  orderDetailRefundFailed: "Refund failed",
  orderDetailProcessRefund: "Process refund",
  orderDetailConfirmRefund: "Confirm refund",
  orderDetailRefundByItem: "Select items",
  orderDetailRefundByAmount: "Custom amount",
  orderDetailRefundAmountAfterTax: "Refund amount (taxes included)",
  orderDetailRefundExceeds: "The amount exceeds the remaining refundable balance of",
  orderDetailQuantity: "Quantity",
  orderDetailRefundBeforeTax: "Refund total (before taxes)",
  orderDetailRemainingBalance: "Remaining refundable balance",
  orderDetailStatusRefunded: "Refunded",
  orderDetailStatusPartiallyRefunded: "Partial refund",
  orderDetailRefundedTag: "Refunded",
  orderDetailRefunded: "Refunded",
  orderDetailNetTotal: "Net total",
  orderActivityTitle: "History",
  orderActivityEmpty: "No reprints, refunds or payment changes.",
  orderActivityReprint: "Receipt reprinted",
  orderActivityRefund: "Refund",
  orderActivityPaymentChange: "Payment method changed",
  modifyPaymentTitle: "Modify payment method",
  modifyPaymentConfirm: "Confirm correction",
  modifyPaymentWarningTitle: "A reverse transaction will be sent to the MEV.",
  modifyPaymentWarningBody: "The original receipt is cancelled and a corrected receipt is printed.",
  modifyPaymentCurrent: "Current payment",
  modifyPaymentSelectNew: "New payment method",
  modifyPaymentCurrentTag: "Current method",
  modifyPaymentNoneSelected: "No payment method selected",
  modifyPaymentSelectPrompt: "Select a new payment method.",
  modifyPaymentSameMethod: "Same payment method",
  modifyPaymentSelectDifferent: "Select a different payment method.",
  modifyPaymentCorrected: "Receipt corrected",
  modifyPaymentChangedTo: "Payment method changed to",
  modifyPaymentFailed: "Receipt correction failed",
  modifyPaymentRejected: "Revenue Québec rejected the transaction",

  // Electronic receipts
  printAndEmailReceipts: "Print and email receipts",
  receiptFormat: "Receipt format",
  receiptFormatHelp: "Applies to closing receipts, refunds, and payment method changes. At least one format remains active.",
  receiptFormatPaper: "Paper",
  receiptFormatElectronic: "Electronic",
  receiptFormatBoth: "Paper and electronic",
  merchantEmailAddresses: "Merchant email addresses",
  merchantEmailAddressesHelp: "Up to three addresses. At least one address is required for electronic receipts.",
  merchantEmailNumber: "Merchant email {n}",
  onScreenKeyboard: "On-screen keyboard",
  remove: "Remove",
  invalidEmailAddress: "The email address is not valid.",
  merchantCopyNotice: "These addresses automatically receive a copy of every electronic receipt, as required by Revenu Québec. This copy cannot be cancelled.",
  merchantEmailRequired: "Enter at least one merchant email address before enabling electronic receipts.",
  receiptFormatPaperReceipt: "Paper receipt",
  receiptFormatPaperHelp: "Printed at the station.",
  receiptFormatElectronicReceipt: "Electronic receipt",
  receiptFormatElectronicHelp: "Sent by email to the customer.",
  processingPayment: "Processing payment",
  paymentCompleted: "Payment completed",
  electronicReceiptTo: "Electronic receipt to",
  receiptSettingsSaved: "Receipt settings saved",
  receiptDelivery: "Receipt",
  receiptPaperShort: "Paper",
  receiptEmailShort: "Email",
  merchantCopyShort: "Merchant copy",
  receiptBothShort: "Both",
  recipientEmail: "Recipient email",
  recipientEmailHelp: "The electronic receipt is sent to this address.",
  useCustomerEmail: "Use customer address",
  saveEmailToCustomer: "Save this address to the customer record",
  confirmAndPay: "Confirm and pay",
  electronicReceipt: "Electronic receipt",
  receiptEmailStatusSent: "Sent",
  receiptEmailStatusPending: "Waiting",
  receiptEmailStatusAwaiting: "Awaiting Revenu Québec",
  receiptEmailStatusFailed: "Not delivered",
  customerEmailNotSent: "Customer email not sent",
  customerEmailNotSentBody: "The bill was recorded. The email to {email} was not sent.",
  receiptEmailAddressIncorrect: "The email address is not correct.",
  receiptEmailFailedExplicit: "Email to {email} for order {order} has failed. Please check the email address, fix it, and send again.",
  receiptEmailFailedShort: "Email failed",
  receiptEmailBouncedTitle: "This email address was rejected",
  receiptEmailBouncedDetail: "The email for {document} {number} was not delivered to {email}.",
  receiptEmailCorrectAddress: "Correct the address",
  receiptEmailLeaveIt: "Leave it",
  receiptEmailSameAddress: "Enter a different email address. This address was rejected.",
  receiptEmailDocTemporary: "Temporary bill",
  receiptEmailDocClosing: "Closing receipt",
  receiptEmailDocCredit: "Credit note",
  receiptEmailDocCancelled: "Cancelled bill",
  receiptEmailDocCorrected: "Corrected bill",
  receiptEmailLastError: "Last error",
  resendElectronicReceipt: "Resend electronic receipt",
  retrySending: "Retry sending",
  cloudMevCasEssai: "Test case (CASESSAI)",
  cloudMevRecipientEmail: "Recipient email (electronic receipt cases)",
  cloudMevRecipientRequired: "Enter a recipient email address for this test case",
  cloudMevCasEssaiHelp: "The second digit after the period selects the format: 1 paper, 2 electronic, 4 paper and electronic.",
  essaiResetCounters: "Reset counters",
  essaiResetCountersTitle: "Reset sales counters",
  essaiResetCountersMessage: "This clears the test sales counters. The next sale in each channel starts at 1.",
  essaiResetCountersConfirm: "Reset counters",
  essaiCountersReset: "The test sales counters now start at 1.",
  essaiCountersResetFailed: "The test sales counters were not reset.",
  essaiStartTest: "Start test",
  essaiStopTest: "Stop test",
  rqExchangeButton: "Requests",
  rqExchangeTitle: "Request and response",
  rqExchangeMinimize: "Minimize",
  rqExchangeList: "List",
  rqExchangeRequest: "Request",
  rqExchangeResponse: "Response",
  rqExchangeOutHeaders: "Out headers",
  rqExchangeOutPayload: "Out payload",
  rqExchangeInHeaders: "In headers",
  rqExchangeInPayload: "In payload",
  rqExchangeEarlierCall: "Earlier call",
  rqExchangeLaterCall: "Later call",
  rqExchangeEmpty: "No request has been saved.",
  rqExchangeEmptyResponse: "Nothing was saved for this response.",
  rqExchangeEmptyRequest: "Nothing was saved for this request.",
  essaiSetTestCase: "Set test case",
  essaiOpenRecord: "Open test record",
  essaiTestCase: "Test case",
  essaiCustomCase: "Custom case",
  essaiCustomCaseInvalid: "Enter a test case as 000.000.",
  essaiUseCase: "Use this case",
  essaiTestResponse: "Test response",
  essaiTestSaved: "Saved",
  essaiTestNotSaved: "The response was not saved.",
  essaiTestCopied: "Copied",
  essaiTestCopy: "Copy",
  essaiTestRecordFailed: "The test record was not created.",
  essaiTestOpenFailed: "The test record was not opened.",
  essaiTestCopyFailed: "The response was not copied.",
  signInCodesTitle: "Additional sign-in verification",
  signInCodesIntro: "Optional verification after the password. Configure each method once. After configuration, enable or disable it for sign-in. Disabling a method does not remove its configuration.",
  signInCodesRequired: "Complete configuration before the rest of the application opens. Sign-in will require it afterward.",
  signInStatusNotSetUp: "Not configured",
  signInStatusSetUp: "Configured",
  signInUseAtSignIn: "Sign-in requirement",
  signInUseOn: "Enabled",
  signInUseOff: "Disabled",
  signInTurnOn: "Enable",
  signInTurnOff: "Disable",
  signInAskAtSignIn: "Enable",
  signInStopAsking: "Disable",
  signInAskingNow: "Enabled",
  signInNotAsking: "Disabled",
  signInSetUpOn: "Configured on {time}.",
  authShowQr: "View authenticator code",
  authShowQrHelp: "Scan this code with Google Authenticator to add Nuage POS Eagle on another device. The current configuration remains unchanged.",
  signInSetUpText: "Configure text message",
  signInSetUpAuthenticator: "Configure authenticator",
  signInCancel: "Cancel",
  smsTitle: "Text message",
  smsNotSetUpBody: "Text message verification sends a code to a mobile phone after the password. Cellular service is required to receive the message. No message is sent until this method is configured.",
  smsSetUpBody: "A mobile number is saved for this account. When text message verification is enabled, sign-in requires a code sent to that number. When it is disabled, no text is sent. The number remains on file.",
  smsPhoneLabel: "Mobile number",
  smsSetupHelp: "Enter the mobile number that should receive the verification code, including the country code, for example +15145551234. One message is sent. Enter that code to complete configuration. The number then remains on file.",
  smsSavedNumber: "A verification code will be sent to {phone}. Enter the code to enable text message verification. The number does not need to be entered again.",
  smsSendCode: "Send code",
  smsSendAgain: "Send code again",
  smsSendAgainIn: "Send code again in {seconds}s",
  smsTextCode: "Text code",
  smsFinishSetup: "Complete configuration",
  smsTurnedOff: "Text message verification is disabled. The mobile number remains on file.",
  smsTurnedOn: "Text message verification is enabled.",
  smsCodeSent: "The verification message has been sent. Delivery can take up to one minute.",
  authTitle: "Authenticator",
  authNotSetUpBody: "Authenticator verification uses the Google Authenticator application. After the password, sign-in requires a 6-digit code from that application. An internet connection is required on the phone. Cellular service is not required.",
  authSetUpBody: "Google Authenticator is configured for this account under the name Nuage POS Eagle. When authenticator verification is enabled, sign-in requires the 6-digit code from that application. When it is disabled, the code is not required. The authenticator entry remains on the device.",
  authStep1Title: "1. Install Google Authenticator",
  authStep1Body: "Scan one code with the phone camera. Use the App Store code for Apple devices and the Google Play code for Android devices.",
  authAppleStore: "Apple App Store",
  authGooglePlay: "Google Play",
  authStep2Title: "2. Open the application",
  authStep2Body: "Open Google Authenticator and sign in if prompted. Continue when the application is ready.",
  authInstalledNext: "Continue",
  authStep3Title: "3. Scan the Nuage POS Eagle code",
  authStep3Body: "In Google Authenticator, select Add and then Scan a QR code. The new account must be named Nuage POS Eagle.",
  authQrAlt: "Nuage POS Eagle authenticator code",
  authStep4Title: "4. Enter the verification code",
  authExampleOnPhone: "Example",
  authExampleHint: "The code on the device changes every few seconds. Enter the current code. Do not enter the example 123456.",
  authCodeLabel: "Verification code",
  authFinishSetup: "Complete configuration",
  authTurnedOff: "Authenticator verification is disabled. Nuage POS Eagle remains in Google Authenticator.",
  authTurnedOn: "Authenticator verification is enabled.",
  authGatePrompt: "Enter the 6-digit code from your authenticator app.",
  authGateClear: "Clear",
  signInPhoneInvalid: "Enter the phone number with the country code, for example +15145551234.",
};
